import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  UploadFile: any;
};

export type AbsentNotification = {
  __typename?: 'AbsentNotification';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AbsentNotificationsInput = {
  attendanceId: Scalars['String'];
};

export type AbsentNotificationsResponse = {
  __typename?: 'AbsentNotificationsResponse';
  absentNotifications: Array<AbsentNotification>;
};

export type AddRecruitmentToFavoriteInput = {
  recruitmentId: Scalars['String'];
};

export type AddRecruitmentToFavoriteResponse = {
  __typename?: 'AddRecruitmentToFavoriteResponse';
  success: Scalars['Boolean'];
};

export type AddressSearchInput = {
  zipCode: Scalars['String'];
};

export type AddressSearchResponse = {
  __typename?: 'AddressSearchResponse';
  address?: Maybe<Scalars['String']>;
  areaL?: Maybe<AddressSearchResponseAreaL>;
};

export type AddressSearchResponseAreaL = {
  __typename?: 'AddressSearchResponseAreaL';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AgreedDocument = {
  __typename?: 'AgreedDocument';
  name: Scalars['String'];
  url: Scalars['String'];
};

export type AnswerAttendanceQuestionnaireInput = {
  answerId: Scalars['String'];
  attendanceId: Scalars['ID'];
};

export type AnswerAttendanceQuestionnaireResponse = {
  __typename?: 'AnswerAttendanceQuestionnaireResponse';
  success: Scalars['Boolean'];
};

export type ApplicationConfirmationConfirmations = {
  __typename?: 'ApplicationConfirmationConfirmations';
  body: ApplicationConfirmationConfirmationsBody;
  button?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ApplicationConfirmationConfirmationsBody = {
  __typename?: 'ApplicationConfirmationConfirmationsBody';
  description: Scalars['String'];
  dialog: ApplicationConfirmationDialog;
  items: Array<ApplicationConfirmationConfirmationsBodyItem>;
  title: Scalars['String'];
};

export type ApplicationConfirmationConfirmationsBodyItem = {
  __typename?: 'ApplicationConfirmationConfirmationsBodyItem';
  description: Scalars['String'];
  label: Scalars['String'];
};

export type ApplicationConfirmationDialog = {
  __typename?: 'ApplicationConfirmationDialog';
  recruitment: ApplicationRecruitment;
};

export type ApplicationConfirmationDocuments = {
  __typename?: 'ApplicationConfirmationDocuments';
  body: ApplicationConfirmationDocumentsBody;
  button?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ApplicationConfirmationDocumentsBody = {
  __typename?: 'ApplicationConfirmationDocumentsBody';
  description: Scalars['String'];
  documents?: Maybe<Array<Maybe<ApplicationConfirmationDocumentsBodyItem>>>;
  title: Scalars['String'];
};

export type ApplicationConfirmationDocumentsBodyItem = {
  __typename?: 'ApplicationConfirmationDocumentsBodyItem';
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ApplicationConfirmationResponse = {
  __typename?: 'ApplicationConfirmationResponse';
  confirmations: ApplicationConfirmationConfirmations;
  documents?: Maybe<ApplicationConfirmationDocuments>;
};

export type ApplicationRecruitment = {
  __typename?: 'ApplicationRecruitment';
  dateOfWork: Scalars['String'];
  facilityName: Scalars['String'];
  jobRepresentativeImage: Scalars['String'];
  jobTitle: Scalars['String'];
};

export type ApplyToRecruitmentInput = {
  allowSelection?: InputMaybe<Scalars['Boolean']>;
  recruitmentId: Scalars['String'];
};

export type ApplyToRecruitmentResponse = {
  __typename?: 'ApplyToRecruitmentResponse';
  success: Scalars['Boolean'];
};

export type ApproveScheduleCancellationInput = {
  id: Scalars['String'];
};

export type Area = {
  __typename?: 'Area';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type AreaLListResponse = {
  __typename?: 'AreaLListResponse';
  areas: Array<Area>;
};

export type AreaLTreeItem = {
  __typename?: 'AreaLTreeItem';
  areaMList: Array<Area>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type AreaTreeResponse = {
  __typename?: 'AreaTreeResponse';
  regions: Array<AreaTreeResponseRegion>;
};

export type AreaTreeResponseRegion = {
  __typename?: 'AreaTreeResponseRegion';
  areaLList: Array<AreaLTreeItem>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type AttendanceAdjustment = {
  __typename?: 'AttendanceAdjustment';
  breakTime: BreakTimeAdjustment;
  endTime: ColoredLabel;
  startTime: ColoredLabel;
};

export type AttendanceHistoriesInput = {
  cursor?: InputMaybe<Scalars['String']>;
};

export type AttendanceHistoriesResponse = {
  __typename?: 'AttendanceHistoriesResponse';
  attendances: Array<AttendanceHistoriesResponseAttendance>;
  paging: Paging;
};

export type AttendanceHistoriesResponseApplicationLabel = {
  __typename?: 'AttendanceHistoriesResponseApplicationLabel';
  text: Scalars['String'];
  type: Scalars['String'];
};

export type AttendanceHistoriesResponseAttendance = {
  __typename?: 'AttendanceHistoriesResponseAttendance';
  id: Scalars['ID'];
  job: Job;
  /** @deprecated 旧仕様 stateLabelを使用してください */
  label?: Maybe<AttendanceHistoriesResponseApplicationLabel>;
  stateLabel?: Maybe<Scalars['String']>;
  tapToTransition: Scalars['Boolean'];
  workday: Workday;
};

export type AttendanceQuestionnaireInput = {
  attendanceId: Scalars['String'];
  token: Scalars['String'];
};

export type AttendanceQuestionnaireResponse = {
  __typename?: 'AttendanceQuestionnaireResponse';
  questionnaireItemList: Array<AttendancesQuestionnaireItem>;
};

export type AttendanceScheduleListInput = {
  cursor?: InputMaybe<Scalars['String']>;
};

export type AttendanceScheduleListResponse = {
  __typename?: 'AttendanceScheduleListResponse';
  paging: Paging;
  sections: Array<Section>;
};

export type AttendanceSummaryInput = {
  applicationId: Scalars['String'];
  token: Scalars['String'];
};

export type AttendanceSummaryResponse = {
  __typename?: 'AttendanceSummaryResponse';
  attendanceId: Scalars['ID'];
  facilityName: Scalars['String'];
  title: Scalars['String'];
  workday: AttendanceSummaryWorkday;
};

export type AttendanceSummaryWorkday = {
  __typename?: 'AttendanceSummaryWorkday';
  endsAt: Scalars['String'];
  salary: Scalars['Int'];
  startsAt: Scalars['String'];
};

export type AttendanceWorkday = {
  __typename?: 'AttendanceWorkday';
  endsAt: Scalars['String'];
  salary: Scalars['Int'];
  startsAt: Scalars['String'];
  wage: Scalars['Int'];
};

export type AttendancesQuestionnaireItem = {
  __typename?: 'AttendancesQuestionnaireItem';
  id: Scalars['String'];
  name: Scalars['String'];
};

export enum BankAccountState {
  Invalid = 'INVALID',
  Valid = 'VALID'
}

export type BankBranchSearchInput = {
  bankCode: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export type BankBranchSearchResponse = {
  __typename?: 'BankBranchSearchResponse';
  branches: Array<BankSearchBranches>;
};

export type BankSearchBanks = {
  __typename?: 'BankSearchBanks';
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type BankSearchBranches = {
  __typename?: 'BankSearchBranches';
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type BankSearchInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type BankSearchResponse = {
  __typename?: 'BankSearchResponse';
  banks: Array<BankSearchBanks>;
};

export type BreakTimeAdjustment = {
  __typename?: 'BreakTimeAdjustment';
  dayTimeAdjustable?: Maybe<Scalars['Boolean']>;
  label: Scalars['String'];
  nightTimeAdjustable?: Maybe<Scalars['Boolean']>;
};

export enum ButtonType {
  Absence = 'absence',
  Chat = 'chat',
  CheckinStamp = 'checkin_stamp',
  CheckinStampDisabled = 'checkin_stamp_disabled',
  CheckoutStamp = 'checkout_stamp',
  CheckoutStampDisabled = 'checkout_stamp_disabled',
  VerifyPayroll = 'verify_payroll',
  Withdraw = 'withdraw'
}

export type Buttons = {
  __typename?: 'Buttons';
  name?: Maybe<Scalars['String']>;
  type?: Maybe<ButtonType>;
};

export type CancelAttendanceInput = {
  attendanceId: Scalars['ID'];
  cancelReasonId: Scalars['String'];
  specificReason: Scalars['String'];
};

export type CancelAttendanceResponse = {
  __typename?: 'CancelAttendanceResponse';
  success: Scalars['Boolean'];
};

export type CancelReason = {
  __typename?: 'CancelReason';
  id: Scalars['String'];
  name: Scalars['String'];
};

export enum CancelSituation {
  Absented = 'Absented',
  Deleted = 'Deleted',
  Dismissed = 'Dismissed'
}

export type CancelWarningsInput = {
  attendanceId: Scalars['String'];
};

export type CancelWarningsResponse = {
  __typename?: 'CancelWarningsResponse';
  importantMatters?: Maybe<Scalars['String']>;
  needsPhoneCall: Scalars['Boolean'];
  penalties: Array<PenaltySimulation>;
  precautions: Array<Scalars['String']>;
  reasons: Array<CancelReason>;
};

export type ColoredLabel = {
  __typename?: 'ColoredLabel';
  colored: Scalars['Boolean'];
  label: Scalars['String'];
};

export type Current = {
  __typename?: 'Current';
  document: Document;
  messages: Array<Scalars['String']>;
  state: Scalars['String'];
};

export type CurrentPenalty = {
  __typename?: 'CurrentPenalty';
  expirationDate: Scalars['String'];
  name: Scalars['String'];
};

export type DeleteReason = {
  description: Scalars['String'];
  ids: Array<Scalars['String']>;
};

export type DeleteWorkerInput = {
  reason: DeleteReason;
};

export type DeleteWorkerLicenseCertificateInput = {
  uploadId: Scalars['String'];
};

export type DeleteWorkerResponse = {
  __typename?: 'DeleteWorkerResponse';
  success: Scalars['Boolean'];
};

export type Document = {
  __typename?: 'Document';
  name: Scalars['String'];
  type?: Maybe<DocumentType>;
};

export enum DocumentType {
  BasicResidentRegistrationCard = 'basic_resident_registration_card',
  DriversLicense = 'drivers_license',
  DrivingHistoryCertificate = 'driving_history_certificate',
  HealthInsuranceCard = 'health_insurance_card',
  IndividualNumberCard = 'individual_number_card',
  Other = 'other',
  Passport = 'passport',
  ResidenceCard = 'residence_card',
  SpecialPermanentResidentCertificate = 'special_permanent_resident_certificate'
}

export type DummyResponse = {
  __typename?: 'DummyResponse';
  success: Scalars['Boolean'];
};

export type EmailNotificationSettingInput = {
  enabled: Scalars['Boolean'];
};

export type EmailNotificationSettingResponse = {
  __typename?: 'EmailNotificationSettingResponse';
  enabled: Scalars['Boolean'];
};

export type EmergencyContactResponse = {
  __typename?: 'EmergencyContactResponse';
  phoneNumber: Scalars['String'];
  relationShipId: Scalars['ID'];
};

export type EmploymentConditionAction = {
  __typename?: 'EmploymentConditionAction';
  name?: Maybe<Scalars['String']>;
  type?: Maybe<ButtonType>;
};

export type EmploymentConditionAmbience = {
  __typename?: 'EmploymentConditionAmbience';
  averageNursingCareLevel: Scalars['String'];
};

export type EmploymentConditionEmployer = {
  __typename?: 'EmploymentConditionEmployer';
  address: Scalars['String'];
  ambience: EmploymentConditionAmbience;
  id: Scalars['ID'];
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  service: Scalars['String'];
  station: Scalars['String'];
};

export type EmploymentConditionRating = {
  __typename?: 'EmploymentConditionRating';
  name: Scalars['String'];
  rate: Scalars['Int'];
};

export type EmploymentConditionResponse = {
  __typename?: 'EmploymentConditionResponse';
  actions: Array<Maybe<EmploymentConditionAction>>;
  agreedDocuments?: Maybe<Array<AgreedDocument>>;
  appealPoints?: Maybe<Scalars['String']>;
  belonging: Scalars['String'];
  bonus?: Maybe<Scalars['String']>;
  breakTimeLabel: Scalars['String'];
  description: Scalars['String'];
  employer: EmploymentConditionEmployer;
  endsAt: Scalars['String'];
  id: Scalars['ID'];
  images: Array<Scalars['String']>;
  isFavoriteRecruitment: Scalars['Boolean'];
  jobId: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  recruitmentId: Scalars['String'];
  requirementLicenses?: Maybe<Scalars['String']>;
  requirementNote?: Maybe<Scalars['String']>;
  review?: Maybe<EmploymentConditionReview>;
  salary: Scalars['Int'];
  startsAt: Scalars['String'];
  stateLabel?: Maybe<Scalars['String']>;
  tagline?: Maybe<Scalars['String']>;
  tags: Array<EmploymentConditionTag>;
  tasks: Scalars['String'];
  title: Scalars['String'];
  wageAndAllowanceLabel: Scalars['String'];
  workflow?: Maybe<Scalars['String']>;
};

export type EmploymentConditionReview = {
  __typename?: 'EmploymentConditionReview';
  description?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
  ratings: Array<EmploymentConditionRating>;
};

export type EmploymentConditionTag = {
  __typename?: 'EmploymentConditionTag';
  color: EmploymentConditionTagColor;
  name: Scalars['String'];
};

export type EmploymentConditionTagColor = {
  __typename?: 'EmploymentConditionTagColor';
  background: Scalars['String'];
  border: Scalars['String'];
  font: Scalars['String'];
};

export type ExchangeAmazonGiftCardInput = {
  amount: Scalars['Int'];
  idempotencyKey: Scalars['String'];
};

export type ExchangeAmazonGiftCardResponse = {
  __typename?: 'ExchangeAmazonGiftCardResponse';
  success: Scalars['Boolean'];
};

export type ExchangeRateOfAmazonGiftCardResponse = {
  __typename?: 'ExchangeRateOfAmazonGiftCardResponse';
  exchangedAmount: Scalars['Int'];
  minimumExchangeableAmount: Scalars['Int'];
};

export type Facility = {
  __typename?: 'Facility';
  id: Scalars['ID'];
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type FacilityAmbience = {
  __typename?: 'FacilityAmbience';
  averageNursingCareLevel: Scalars['String'];
};

export type FacilityFeature = {
  __typename?: 'FacilityFeature';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type FacilityFeatureListResponse = {
  __typename?: 'FacilityFeatureListResponse';
  features: Array<FacilityFeature>;
};

export type FavoriteRecruitmentListInput = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  token: Scalars['String'];
};

export type FavoriteRecruitmentListResponse = {
  __typename?: 'FavoriteRecruitmentListResponse';
  paging: RecruitmentSearchPaging;
  recruitments: Array<RecruitmentSearchRecruitment>;
};

export type File = {
  __typename?: 'File';
  encoding: Scalars['String'];
  filename: Scalars['String'];
  mimetype: Scalars['String'];
};

export type FullName = {
  first: Scalars['String'];
  last: Scalars['String'];
};

export type GenerateIdentificationInput = {
  id: Scalars['ID'];
};

export type GenerateIdentificationResponse = {
  __typename?: 'GenerateIdentificationResponse';
  publicId: Scalars['String'];
};

export type GetIncentivePointBalanceResponse = {
  __typename?: 'GetIncentivePointBalanceResponse';
  balance: Scalars['Int'];
};

export type GetIncentivePointHistoriesRequest = {
  cursor?: InputMaybe<Scalars['String']>;
  size: Scalars['Int'];
};

export type GetIncentivePointHistoriesResponse = {
  __typename?: 'GetIncentivePointHistoriesResponse';
  cursor?: Maybe<Scalars['String']>;
  histories: Array<History>;
};

export type GetPenaltyPointHistoriesRequest = {
  cursor?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
};

export type GetPenaltyPointHistoriesResponse = {
  __typename?: 'GetPenaltyPointHistoriesResponse';
  cursor?: Maybe<Scalars['String']>;
  histories: Array<History>;
};

export type GetPenaltySummaryResponse = {
  __typename?: 'GetPenaltySummaryResponse';
  balance: Scalars['Int'];
  currentPenalty?: Maybe<CurrentPenalty>;
  feedbackComment?: Maybe<Scalars['String']>;
  penaltyCount: Scalars['Int'];
};

export type History = {
  __typename?: 'History';
  amount: Scalars['Int'];
  date: Scalars['String'];
  id: Scalars['String'];
  note?: Maybe<Scalars['String']>;
};

export type HowToEnable = {
  __typename?: 'HowToEnable';
  message: Scalars['String'];
};

export type IdentityAddress = {
  building?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  prefectureCode: Scalars['String'];
  streetNumber: Scalars['String'];
  zipCode?: InputMaybe<Scalars['String']>;
};

export type IncentiveItemOrderRequest = {
  orderId: Scalars['String'];
};

export type IncentiveItemOrderResponse = {
  __typename?: 'IncentiveItemOrderResponse';
  status: IncentiveItemOrderStatus;
};

export enum IncentiveItemOrderStatus {
  Canceled = 'CANCELED',
  Pending = 'PENDING',
  Shipped = 'SHIPPED',
  Unshipped = 'UNSHIPPED'
}

export type Job = {
  __typename?: 'Job';
  facilityName: Scalars['String'];
  representativeImage: Scalars['String'];
  title: Scalars['String'];
};

export type JobArrangementListArrangements = {
  __typename?: 'JobArrangementListArrangements';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type JobArrangementListResponse = {
  __typename?: 'JobArrangementListResponse';
  arrangements?: Maybe<Array<JobArrangementListArrangements>>;
};

export type JobBenefit = {
  __typename?: 'JobBenefit';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type JobBenefitListResponse = {
  __typename?: 'JobBenefitListResponse';
  jobBenefits: Array<JobBenefit>;
};

export type JobTask = {
  __typename?: 'JobTask';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type JobTaskListResponse = {
  __typename?: 'JobTaskListResponse';
  jobTasks?: Maybe<Array<JobTask>>;
};

export type License = {
  __typename?: 'License';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type LicenseListResponse = {
  __typename?: 'LicenseListResponse';
  licenses: Array<License>;
};

export type LicenseVerificationState = {
  displayName: Scalars['String'];
};

export type LicenseVerificationStatePending = LicenseVerificationState & {
  __typename?: 'LicenseVerificationStatePending';
  displayName: Scalars['String'];
  remarksOnDifferentName?: Maybe<Scalars['String']>;
};

export type LicenseVerificationStateRejected = LicenseVerificationState & {
  __typename?: 'LicenseVerificationStateRejected';
  displayName: Scalars['String'];
  rejectionReason: Scalars['String'];
};

export type LicenseVerificationStateVerified = LicenseVerificationState & {
  __typename?: 'LicenseVerificationStateVerified';
  displayName: Scalars['String'];
};

export type MakeChannelResponse = {
  __typename?: 'MakeChannelResponse';
  id: Scalars['String'];
  type: Scalars['String'];
};

export type MakeCsChannelResponse = {
  __typename?: 'MakeCsChannelResponse';
  id: Scalars['String'];
  type: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addRecruitmentToFavorite: AddRecruitmentToFavoriteResponse;
  answerAttendanceQuestionnaire: AnswerAttendanceQuestionnaireResponse;
  applyToRecruitment: ApplyToRecruitmentResponse;
  approveScheduleCancellation?: Maybe<Scalars['Boolean']>;
  cancelAttendance: CancelAttendanceResponse;
  deleteWorker: DeleteWorkerResponse;
  deleteWorkerLicenseCertificate?: Maybe<Scalars['Boolean']>;
  dummy?: Maybe<DummyResponse>;
  exchangeAmazonGiftCard: ExchangeAmazonGiftCardResponse;
  generateIdentification: GenerateIdentificationResponse;
  makeChannel: MakeChannelResponse;
  makeCsChannel: MakeCsChannelResponse;
  postReview?: Maybe<Scalars['Boolean']>;
  refuseScheduleCancellationApproval?: Maybe<Scalars['Boolean']>;
  registerBank: RegisterBankResponse;
  registerIdentityAndContact?: Maybe<Scalars['Boolean']>;
  registerWorkEndTimeByCode: RegisterWorkEndTimeByCodeResponse;
  registerWorkStartTimeByCode: RegisterWorkStartTimeByCodeResponse;
  registerWorkerLicenseCertificate: RegisterWorkerLicenseCertificateResponse;
  remitPenalty: RemitPenaltyResponse;
  removeRecruitmentFromFavorite: RemoveRecruitmentFromFavoriteResponse;
  requestAttendanceApproval: RequestAttendanceApprovalResponse;
  requestBankTransfer: RequestBankTransferResponse;
  requestChatToken: RequestChatTokenResponse;
  saveNotificationSetting: SaveNotificationSettingResponse;
  skipPreparationToApply?: Maybe<Scalars['Boolean']>;
  updateAbsentNotification?: Maybe<Scalars['Boolean']>;
  updateBreakTime: UpdateBreakTimeResponse;
  updateCheckinTime: UpdateCheckinTimeResponse;
  updateCheckoutTime: UpdateCheckoutTimeResponse;
  updateEmailNotificationSetting: Scalars['Boolean'];
  updateEmergencyContact: UpdateEmergencyContactResponse;
  updateSubscriptionForAvailability?: Maybe<Scalars['Boolean']>;
  updateWorkerAvailableDateList: UpdateWorkerAvailableDateListResponse;
  updateWorkerLicenseCertificate?: Maybe<Scalars['Boolean']>;
  updateWorkerMainImage: UpdateWorkerMainImageResponse;
  updateWorkerProfile: UpdateWorkerProfileResponse;
  withdrawApplication?: Maybe<Scalars['Boolean']>;
};


export type MutationAddRecruitmentToFavoriteArgs = {
  data: AddRecruitmentToFavoriteInput;
};


export type MutationAnswerAttendanceQuestionnaireArgs = {
  data: AnswerAttendanceQuestionnaireInput;
};


export type MutationApplyToRecruitmentArgs = {
  data: ApplyToRecruitmentInput;
};


export type MutationApproveScheduleCancellationArgs = {
  data: ApproveScheduleCancellationInput;
  token: Scalars['String'];
};


export type MutationCancelAttendanceArgs = {
  data: CancelAttendanceInput;
};


export type MutationDeleteWorkerArgs = {
  data: DeleteWorkerInput;
  token: Scalars['String'];
};


export type MutationDeleteWorkerLicenseCertificateArgs = {
  data: DeleteWorkerLicenseCertificateInput;
  token: Scalars['String'];
};


export type MutationExchangeAmazonGiftCardArgs = {
  data: ExchangeAmazonGiftCardInput;
  token: Scalars['String'];
};


export type MutationGenerateIdentificationArgs = {
  data: GenerateIdentificationInput;
  token: Scalars['String'];
};


export type MutationMakeChannelArgs = {
  memberId: Scalars['String'];
};


export type MutationPostReviewArgs = {
  data: PostReviewInput;
  token: Scalars['String'];
};


export type MutationRefuseScheduleCancellationApprovalArgs = {
  data: RefuseScheduleCancellationApprovalInput;
  token: Scalars['String'];
};


export type MutationRegisterBankArgs = {
  data: RegisterBankInput;
  token: Scalars['String'];
};


export type MutationRegisterIdentityAndContactArgs = {
  data: RegisterIdentityAndContactInput;
  token: Scalars['String'];
};


export type MutationRegisterWorkEndTimeByCodeArgs = {
  data: RegisterWorkEndTimeByCodeInput;
};


export type MutationRegisterWorkStartTimeByCodeArgs = {
  data: RegisterWorkStartTimeByCodeInput;
};


export type MutationRegisterWorkerLicenseCertificateArgs = {
  data: RegisterWorkerLicenseCertificateInput;
  token: Scalars['String'];
};


export type MutationRemitPenaltyArgs = {
  data: RemitPenaltyRequest;
  token: Scalars['String'];
};


export type MutationRemoveRecruitmentFromFavoriteArgs = {
  data: RemoveRecruitmentFromFavoriteInput;
};


export type MutationRequestAttendanceApprovalArgs = {
  data: RequestAttendanceApprovalInput;
};


export type MutationRequestBankTransferArgs = {
  token: Scalars['String'];
};


export type MutationSaveNotificationSettingArgs = {
  data: SaveNotificationSettingInput;
  token: Scalars['String'];
};


export type MutationSkipPreparationToApplyArgs = {
  data: SkipPreparationToApplyInput;
  token: Scalars['String'];
};


export type MutationUpdateAbsentNotificationArgs = {
  data: UpdateAbsentNotificationInput;
  token: Scalars['String'];
};


export type MutationUpdateBreakTimeArgs = {
  data: UpdateBreakTimeInput;
};


export type MutationUpdateCheckinTimeArgs = {
  data: UpdateCheckinTimeInput;
};


export type MutationUpdateCheckoutTimeArgs = {
  data: UpdateCheckoutTimeInput;
};


export type MutationUpdateEmailNotificationSettingArgs = {
  data: EmailNotificationSettingInput;
  token: Scalars['String'];
};


export type MutationUpdateEmergencyContactArgs = {
  data: UpdateEmergencyContactInput;
  token: Scalars['String'];
};


export type MutationUpdateSubscriptionForAvailabilityArgs = {
  data: UpdateSubscriptionForAvailabilityInput;
  token: Scalars['String'];
};


export type MutationUpdateWorkerAvailableDateListArgs = {
  data: WorkerAvailableDateListInput;
  token: Scalars['String'];
};


export type MutationUpdateWorkerLicenseCertificateArgs = {
  data: UpdateWorkerLicenseCertificateInput;
  token: Scalars['String'];
};


export type MutationUpdateWorkerMainImageArgs = {
  data: UpdateWorkerMainImageInput;
  token: Scalars['String'];
};


export type MutationUpdateWorkerProfileArgs = {
  data: UpdateWorkerProfileInput;
  token: Scalars['String'];
};


export type MutationWithdrawApplicationArgs = {
  data: WithdrawApplicationInput;
  token: Scalars['String'];
};

export enum Nationality {
  Foreign = 'foreign',
  Japan = 'japan'
}

export type Paging = {
  __typename?: 'Paging';
  nextCursor?: Maybe<Scalars['String']>;
};

export type PagingCursor = {
  __typename?: 'PagingCursor';
  cursor: Scalars['String'];
};

export type PenaltyRemission = {
  __typename?: 'PenaltyRemission';
  after: PenaltyRemissionPoints;
  amount: Scalars['Int'];
  before: PenaltyRemissionPoints;
};

export type PenaltyRemissionPoints = {
  __typename?: 'PenaltyRemissionPoints';
  incentivePoints: Scalars['Int'];
};

export type PenaltyRemissionResponse = {
  __typename?: 'PenaltyRemissionResponse';
  remission?: Maybe<PenaltyRemission>;
};

export type PenaltySimulation = {
  __typename?: 'PenaltySimulation';
  afterCancellation: PenaltySimulationTarget;
  current: PenaltySimulationTarget;
  subject: Scalars['String'];
};

export type PenaltySimulationTarget = {
  __typename?: 'PenaltySimulationTarget';
  amount: Scalars['String'];
  prefix: Scalars['String'];
};

export type PostReviewInput = {
  eventId: Scalars['String'];
  feedbackComment?: InputMaybe<Scalars['String']>;
  ratings: Array<RatingWithRateId>;
};

export type PredefinedDeletionReasonResponse = {
  __typename?: 'PredefinedDeletionReasonResponse';
  reasons: Array<Reasons>;
};

export type PrefectureOfSubscription = {
  __typename?: 'PrefectureOfSubscription';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PreparationToApply = {
  __typename?: 'PreparationToApply';
  kind: PreparationToApplyKind;
  optional: Scalars['Boolean'];
};

export enum PreparationToApplyKind {
  BankAccount = 'bank_account',
  Identity = 'identity',
  License = 'license',
  Profile = 'profile'
}

export type Query = {
  __typename?: 'Query';
  absentNotifications: AbsentNotificationsResponse;
  addressSearch: AddressSearchResponse;
  applicationConfirmation: ApplicationConfirmationResponse;
  areaLList: AreaLListResponse;
  areaTree: AreaTreeResponse;
  attendanceHistories: AttendanceHistoriesResponse;
  attendanceQuestionnaire: AttendanceQuestionnaireResponse;
  attendanceScheduleList: AttendanceScheduleListResponse;
  attendanceSummary: AttendanceSummaryResponse;
  bankBranchSearch: BankBranchSearchResponse;
  bankSearch: BankSearchResponse;
  cancelWarnings: CancelWarningsResponse;
  currentUser?: Maybe<User>;
  emailNotificationSetting: EmailNotificationSettingResponse;
  emergencyContact: EmergencyContactResponse;
  employmentCondition: EmploymentConditionResponse;
  exchangeRateOfAmazonGiftCard: ExchangeRateOfAmazonGiftCardResponse;
  facilityFeatureList: FacilityFeatureListResponse;
  favoriteRecruitmentList: FavoriteRecruitmentListResponse;
  getIncentivePointBalance: GetIncentivePointBalanceResponse;
  getIncentivePointHistories: GetIncentivePointHistoriesResponse;
  getPenaltyPointHistories: GetPenaltyPointHistoriesResponse;
  getPenaltySummary: GetPenaltySummaryResponse;
  getRemainingPreparationToApplyList: RemainingPreparationToApplyListResponse;
  incentiveItemOrder: IncentiveItemOrderResponse;
  jobArrangementList: JobArrangementListResponse;
  jobBenefitList: JobBenefitListResponse;
  jobTaskList: JobTaskListResponse;
  licenseList: LicenseListResponse;
  notificationSetting: Subscription;
  penaltyRemission: PenaltyRemissionResponse;
  predefinedDeletionReason: PredefinedDeletionReasonResponse;
  recruitmentDetail: RecruitmentDetailResponse;
  recruitmentSearch: RecruitmentSearchResponse;
  relationShipList: RelationShipListResponse;
  reviewRequests: ReviewRequestsResponse;
  reviewSummaryFromFacility: ReviewSummaryFromFacilityResponse;
  reviewsFromFacility: ReviewsFromFacilityResponse;
  scheduleCancellationRequests: ScheduleCancellationRequestsResponse;
  searchPrefectureFromStation: SearchPrefectureFromStationResponse;
  searchRailwayFromPrefecture: SearchRailwayFromPrefectureResponse;
  sortOptionList: SortOptionListResponse;
  statementOfEarningFile: StatementOfEarningFileResponse;
  statementOfEarnings: StatementOfEarningsResponse;
  subscriptionCount: SubscriptionCountResponse;
  subscriptionForAvailability: SubscriptionForAvailabilityResponse;
  wageWithAdjustment: WageWithAdjustmentResponse;
  wageWithoutAdjustment: WageWithoutAdjustmentResponse;
  workTime: WorkTimeResponse;
  workerAvailableDateList: WorkerAvailableDateListResponse;
  workerBankSummary: WorkerBankSummaryResponse;
  workerBankTransfer: WorkerBankTransferResponse;
  workerDeletableJudgement: WorkerDeletableJudgementResponse;
  workerIdentification: WorkerIdentificationResponse;
  workerIdentity: WorkerIdentityResponse;
  workerLicenseCertificateList: WorkerLicenseCertificateListResponse;
  workerProfile: WorkerProfileResponse;
  workingHourOptionList: WorkingHourOptionListResponse;
};


export type QueryAbsentNotificationsArgs = {
  data: AbsentNotificationsInput;
  token: Scalars['String'];
};


export type QueryAddressSearchArgs = {
  data: AddressSearchInput;
};


export type QueryApplicationConfirmationArgs = {
  recruitmentId: Scalars['ID'];
  token?: InputMaybe<Scalars['String']>;
};


export type QueryAttendanceHistoriesArgs = {
  data: AttendanceHistoriesInput;
  token: Scalars['String'];
};


export type QueryAttendanceQuestionnaireArgs = {
  data: AttendanceQuestionnaireInput;
};


export type QueryAttendanceScheduleListArgs = {
  data: AttendanceScheduleListInput;
  token: Scalars['String'];
};


export type QueryAttendanceSummaryArgs = {
  data: AttendanceSummaryInput;
};


export type QueryBankBranchSearchArgs = {
  data: BankBranchSearchInput;
};


export type QueryBankSearchArgs = {
  data: BankSearchInput;
};


export type QueryCancelWarningsArgs = {
  data: CancelWarningsInput;
  token: Scalars['String'];
};


export type QueryCurrentUserArgs = {
  token: Scalars['String'];
};


export type QueryEmailNotificationSettingArgs = {
  token: Scalars['String'];
};


export type QueryEmergencyContactArgs = {
  token: Scalars['String'];
};


export type QueryEmploymentConditionArgs = {
  id: Scalars['ID'];
};


export type QueryFavoriteRecruitmentListArgs = {
  data: FavoriteRecruitmentListInput;
};


export type QueryGetIncentivePointBalanceArgs = {
  token: Scalars['String'];
};


export type QueryGetIncentivePointHistoriesArgs = {
  data: GetIncentivePointHistoriesRequest;
  token: Scalars['String'];
};


export type QueryGetPenaltyPointHistoriesArgs = {
  data: GetPenaltyPointHistoriesRequest;
  token: Scalars['String'];
};


export type QueryGetPenaltySummaryArgs = {
  token: Scalars['String'];
};


export type QueryGetRemainingPreparationToApplyListArgs = {
  token: Scalars['String'];
};


export type QueryIncentiveItemOrderArgs = {
  data: IncentiveItemOrderRequest;
  token: Scalars['String'];
};


export type QueryNotificationSettingArgs = {
  token: Scalars['String'];
};


export type QueryPenaltyRemissionArgs = {
  token: Scalars['String'];
};


export type QueryRecruitmentDetailArgs = {
  recruitmentId: Scalars['ID'];
  token?: InputMaybe<Scalars['String']>;
};


export type QueryRecruitmentSearchArgs = {
  data: RecruitmentSearchInput;
};


export type QueryReviewRequestsArgs = {
  data?: InputMaybe<ReviewRequestInput>;
  token: Scalars['String'];
};


export type QueryReviewSummaryFromFacilityArgs = {
  token: Scalars['String'];
};


export type QueryReviewsFromFacilityArgs = {
  data: ReviewsFromFacilityInput;
  token: Scalars['String'];
};


export type QueryScheduleCancellationRequestsArgs = {
  token: Scalars['String'];
};


export type QuerySearchPrefectureFromStationArgs = {
  data: SearchPrefectureFromStationInput;
};


export type QuerySearchRailwayFromPrefectureArgs = {
  data: SearchRailwayFromPrefectureInput;
};


export type QueryStatementOfEarningFileArgs = {
  data: StatementOfEarningFileInput;
  token: Scalars['String'];
};


export type QueryStatementOfEarningsArgs = {
  data: StatementOfEarningsInput;
  token: Scalars['String'];
};


export type QuerySubscriptionCountArgs = {
  token: Scalars['String'];
};


export type QuerySubscriptionForAvailabilityArgs = {
  token: Scalars['String'];
};


export type QueryWageWithAdjustmentArgs = {
  data: WageWithAdjustmentInput;
};


export type QueryWageWithoutAdjustmentArgs = {
  data: WageWithoutAdjustmentInput;
};


export type QueryWorkTimeArgs = {
  id: Scalars['ID'];
  token: Scalars['String'];
};


export type QueryWorkerAvailableDateListArgs = {
  id: Scalars['ID'];
  token: Scalars['String'];
};


export type QueryWorkerBankSummaryArgs = {
  token: Scalars['String'];
};


export type QueryWorkerBankTransferArgs = {
  data: WorkerBankTransferInput;
  token: Scalars['String'];
};


export type QueryWorkerIdentificationArgs = {
  id: Scalars['ID'];
  token?: InputMaybe<Scalars['String']>;
};


export type QueryWorkerIdentityArgs = {
  token: Scalars['String'];
};


export type QueryWorkerLicenseCertificateListArgs = {
  token: Scalars['String'];
};


export type QueryWorkerProfileArgs = {
  id: Scalars['ID'];
  token: Scalars['String'];
};

export type RailCorporation = {
  __typename?: 'RailCorporation';
  code: Scalars['String'];
  lines: Array<RailLine>;
  name: Scalars['String'];
};

export type RailLine = {
  __typename?: 'RailLine';
  code: Scalars['String'];
  name: Scalars['String'];
  stations: Array<Station>;
};

export enum RatingItemGroup {
  V2 = 'v2'
}

export type RatingWithRateId = {
  comment?: InputMaybe<Scalars['String']>;
  itemId: Scalars['String'];
  rateId: Scalars['String'];
};

export type Reasons = {
  __typename?: 'Reasons';
  id: Scalars['String'];
  label: Scalars['String'];
};

export type RecruitmentDetailButton = {
  __typename?: 'RecruitmentDetailButton';
  action: RecruitmentDetailButtonAction;
  disabled: Scalars['Boolean'];
  label: Scalars['String'];
};

export enum RecruitmentDetailButtonAction {
  Apply = 'apply',
  Login = 'login',
  Nothing = 'nothing',
  RegisterBankAccount = 'register_bank_account',
  RegisterEmergencyContact = 'register_emergency_contact',
  RegisterIdentification = 'register_identification',
  RegisterLicense = 'register_license',
  UpdateProfile = 'update_profile'
}

export type RecruitmentDetailFacility = {
  __typename?: 'RecruitmentDetailFacility';
  address: Scalars['String'];
  ambience: FacilityAmbience;
  facilityId: Scalars['String'];
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  service: Scalars['String'];
  station: Scalars['String'];
};

export type RecruitmentDetailInput = {
  recruitmentId: Scalars['String'];
};

export type RecruitmentDetailOtherCandidates = {
  __typename?: 'RecruitmentDetailOtherCandidates';
  bonus?: Maybe<Scalars['String']>;
  breakTimeLabel: Scalars['String'];
  canApply: Scalars['Boolean'];
  capacity: Scalars['Int'];
  deadline: Scalars['String'];
  endsAt: Scalars['String'];
  otherCandidatesId: Scalars['String'];
  remainingRecruitmentNumbers: Scalars['Int'];
  salary: Scalars['Int'];
  startsAt: Scalars['String'];
  wageAndAllowanceLabel: Scalars['String'];
  warningDialogView?: Maybe<RecruitmentDetailWarningDialogView>;
};

export type RecruitmentDetailRate = {
  __typename?: 'RecruitmentDetailRate';
  description?: Maybe<Scalars['String']>;
  ratings: Array<RecruitmentDetailRateRating>;
  value?: Maybe<Scalars['Float']>;
};

export type RecruitmentDetailRateRating = {
  __typename?: 'RecruitmentDetailRateRating';
  name: Scalars['String'];
  rate: Scalars['Float'];
};

export type RecruitmentDetailResponse = {
  __typename?: 'RecruitmentDetailResponse';
  appealPoints?: Maybe<Scalars['String']>;
  belonging?: Maybe<Scalars['String']>;
  bonus?: Maybe<Scalars['String']>;
  breakTimeLabel: Scalars['String'];
  button: RecruitmentDetailButton;
  capacity?: Maybe<Scalars['Int']>;
  deadline: Scalars['String'];
  description: Scalars['String'];
  endsAt: Scalars['String'];
  facility: RecruitmentDetailFacility;
  favorited: Scalars['Boolean'];
  images: Array<Scalars['String']>;
  isRecruitmentCompleted: Scalars['Boolean'];
  jobId: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  otherCandidates: Array<RecruitmentDetailOtherCandidates>;
  rate?: Maybe<RecruitmentDetailRate>;
  recruitmentId: Scalars['String'];
  remainingRecruitmentNumbers: Scalars['Int'];
  requirementLicenses?: Maybe<Scalars['String']>;
  requirementNote?: Maybe<Scalars['String']>;
  salary: Scalars['Int'];
  startsAt: Scalars['String'];
  tagline?: Maybe<Scalars['String']>;
  tags: Array<RecruitmentDetailTags>;
  tasks: Scalars['String'];
  title: Scalars['String'];
  wageAndAllowanceLabel: Scalars['String'];
  warningDialogView?: Maybe<RecruitmentDetailWarningDialogView>;
  workflow?: Maybe<Scalars['String']>;
};

export type RecruitmentDetailTags = {
  __typename?: 'RecruitmentDetailTags';
  color: RecruitmentDetailTagsColor;
  name: Scalars['String'];
};

export type RecruitmentDetailTagsColor = {
  __typename?: 'RecruitmentDetailTagsColor';
  background: Scalars['String'];
  border: Scalars['String'];
  font: Scalars['String'];
};

export enum RecruitmentDetailWarningDialogKind {
  PreventTransition = 'PreventTransition',
  WarnBeforeTransition = 'WarnBeforeTransition'
}

export type RecruitmentDetailWarningDialogView = {
  __typename?: 'RecruitmentDetailWarningDialogView';
  description: Scalars['String'];
  kind: RecruitmentDetailWarningDialogKind;
  title: Scalars['String'];
};

export type RecruitmentSearchFacility = {
  __typename?: 'RecruitmentSearchFacility';
  address: Scalars['String'];
  name: Scalars['String'];
  service: Scalars['String'];
};

export type RecruitmentSearchInput = {
  areaIds?: InputMaybe<Array<Scalars['String']>>;
  date: Scalars['String'];
  facilityFeatureIds?: InputMaybe<Array<Scalars['String']>>;
  jobBenefitIds?: InputMaybe<Array<Scalars['String']>>;
  jobTaskIds?: InputMaybe<Array<Scalars['String']>>;
  licenseIds?: InputMaybe<Array<Scalars['String']>>;
  maximumDailyWage?: InputMaybe<Scalars['Int']>;
  maximumWorkingHours?: InputMaybe<Scalars['Int']>;
  minimumDailyWage?: InputMaybe<Scalars['Int']>;
  onlyRecruiting?: InputMaybe<Scalars['Boolean']>;
  pagingCursor?: InputMaybe<Scalars['String']>;
  sortOptionId?: InputMaybe<Scalars['String']>;
  workingHourOptionIds?: InputMaybe<Array<Scalars['String']>>;
};

export type RecruitmentSearchPaging = {
  __typename?: 'RecruitmentSearchPaging';
  nextCursor?: Maybe<Scalars['String']>;
};

export type RecruitmentSearchRecruitment = {
  __typename?: 'RecruitmentSearchRecruitment';
  bonus?: Maybe<Scalars['String']>;
  capacity?: Maybe<Scalars['Int']>;
  deadline: Scalars['String'];
  endsAt: Scalars['String'];
  facility: RecruitmentSearchFacility;
  id: Scalars['String'];
  remainingRecruitmentNumbers?: Maybe<Scalars['Int']>;
  representativeImage: Scalars['String'];
  review?: Maybe<RecruitmentSearchReview>;
  salary: Scalars['Int'];
  startsAt: Scalars['String'];
  state: RecruitmentState;
  tags: Array<RecruitmentSearchTags>;
  tasks: Scalars['String'];
  title: Scalars['String'];
  travelAllowanceLabel?: Maybe<Scalars['String']>;
};

export type RecruitmentSearchResponse = {
  __typename?: 'RecruitmentSearchResponse';
  paging: RecruitmentSearchPaging;
  recruitments: Array<RecruitmentSearchRecruitment>;
};

export type RecruitmentSearchReview = {
  __typename?: 'RecruitmentSearchReview';
  description?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
};

export type RecruitmentSearchTags = {
  __typename?: 'RecruitmentSearchTags';
  color: RecruitmentSearchTagsColor;
  name: Scalars['String'];
};

export type RecruitmentSearchTagsColor = {
  __typename?: 'RecruitmentSearchTagsColor';
  background: Scalars['String'];
  border: Scalars['String'];
  font: Scalars['String'];
};

export enum RecruitmentState {
  Closed = 'closed',
  Open = 'open'
}

export type RefuseScheduleCancellationApprovalInput = {
  id: Scalars['String'];
  reason: Scalars['String'];
};

export type RegisterBankInput = {
  accountHolder: Scalars['String'];
  bankAccountType: Scalars['String'];
  bankCode: Scalars['String'];
  bankName: Scalars['String'];
  bankNumber: Scalars['String'];
  branchCode: Scalars['String'];
};

export type RegisterBankResponse = {
  __typename?: 'RegisterBankResponse';
  success: Scalars['Boolean'];
};

export type RegisterIdentityAndContactInput = {
  address: IdentityAddress;
  birthday: Scalars['String'];
  kana: FullName;
  name: FullName;
  nationality: Nationality;
  phoneNumber: Scalars['String'];
  sex: Sex;
};

export type RegisterWorkEndTimeByCodeInput = {
  attendanceId: Scalars['String'];
  code: Scalars['String'];
};

export type RegisterWorkEndTimeByCodeResponse = {
  __typename?: 'RegisterWorkEndTimeByCodeResponse';
  success: Scalars['Boolean'];
};

export type RegisterWorkStartTimeByCodeInput = {
  attendanceId: Scalars['String'];
  code: Scalars['String'];
};

export type RegisterWorkStartTimeByCodeResponse = {
  __typename?: 'RegisterWorkStartTimeByCodeResponse';
  success: Scalars['Boolean'];
};

export type RegisterWorkerLicenseCertificateInput = {
  file: Scalars['UploadFile'];
};

export type RegisterWorkerLicenseCertificateResponse = {
  __typename?: 'RegisterWorkerLicenseCertificateResponse';
  uploadId: Scalars['String'];
};

export type RelationShip = {
  __typename?: 'RelationShip';
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type RelationShipListResponse = {
  __typename?: 'RelationShipListResponse';
  relationShips: Array<RelationShip>;
};

export type RemainingPreparationToApplyListResponse = {
  __typename?: 'RemainingPreparationToApplyListResponse';
  preparations: Array<Maybe<PreparationToApply>>;
};

export enum RemarksOnDifferentNameReason {
  Divorced = 'divorced',
  Married = 'married',
  Other = 'other'
}

export type RemitPenaltyRequest = {
  idempotencyKey: Scalars['String'];
};

export type RemitPenaltyResponse = {
  __typename?: 'RemitPenaltyResponse';
  orderId: Scalars['String'];
};

export type RemoveRecruitmentFromFavoriteInput = {
  recruitmentId: Scalars['String'];
};

export type RemoveRecruitmentFromFavoriteResponse = {
  __typename?: 'RemoveRecruitmentFromFavoriteResponse';
  success: Scalars['Boolean'];
};

export type RequestAttendanceApprovalInput = {
  attendanceId: Scalars['ID'];
  type: RequestAttendanceApprovalType;
};

export type RequestAttendanceApprovalResponse = {
  __typename?: 'RequestAttendanceApprovalResponse';
  success: Scalars['Boolean'];
};

export enum RequestAttendanceApprovalType {
  WithAdjustment = 'with_adjustment',
  WithoutAdjustment = 'without_adjustment'
}

export type RequestBankTransferResponse = {
  __typename?: 'RequestBankTransferResponse';
  success: Scalars['Boolean'];
};

export type RequestChatTokenResponse = {
  __typename?: 'RequestChatTokenResponse';
  token: Scalars['String'];
};

export type ReviewFromFacility = {
  __typename?: 'ReviewFromFacility';
  attendance: ReviewsFromFacilityReviewAttendance;
  feedbackComment?: Maybe<Scalars['String']>;
  /** @deprecated 旧仕様 feedbackCommentを使ってください */
  negativeComment?: Maybe<Scalars['String']>;
  /** @deprecated 旧仕様 feedbackCommentを使ってください */
  positiveComment?: Maybe<Scalars['String']>;
  rate: Scalars['Float'];
  ratings: Array<ReviewsFromFacilityReviewRating>;
};

export type ReviewRating = {
  __typename?: 'ReviewRating';
  commentNotes: Scalars['String'];
  description: Scalars['String'];
  items: Array<ReviewRatingItem>;
};

export type ReviewRatingItem = {
  __typename?: 'ReviewRatingItem';
  id: Scalars['String'];
  name: Scalars['String'];
  rates: Array<ReviewRatingItemRate>;
};

export type ReviewRatingItemRate = {
  __typename?: 'ReviewRatingItemRate';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ReviewRequest = {
  __typename?: 'ReviewRequest';
  endsAt: Scalars['String'];
  eventId: Scalars['String'];
  facilityName: Scalars['String'];
  jobTitle: Scalars['String'];
  ratings: ReviewRating;
  startsAt: Scalars['String'];
  wage: Scalars['Int'];
};

export type ReviewRequestInput = {
  attendanceId?: InputMaybe<Scalars['String']>;
  ratingItemGroup?: InputMaybe<RatingItemGroup>;
};

export type ReviewRequestsResponse = {
  __typename?: 'ReviewRequestsResponse';
  requests: Array<ReviewRequest>;
};

export type ReviewSummaryFromFacility = {
  __typename?: 'ReviewSummaryFromFacility';
  count: Scalars['Int'];
  rate: Scalars['Float'];
};

export type ReviewSummaryFromFacilityResponse = {
  __typename?: 'ReviewSummaryFromFacilityResponse';
  reviewSummaryFromFacility?: Maybe<ReviewSummaryFromFacility>;
};

export type ReviewsFromFacilityInput = {
  cursor?: InputMaybe<Scalars['String']>;
  workerId: Scalars['String'];
};

export type ReviewsFromFacilityPaging = {
  __typename?: 'ReviewsFromFacilityPaging';
  cursor?: Maybe<Scalars['String']>;
};

export type ReviewsFromFacilityResponse = {
  __typename?: 'ReviewsFromFacilityResponse';
  paging: ReviewsFromFacilityPaging;
  reviews: Array<ReviewFromFacility>;
};

export type ReviewsFromFacilityReviewAttendance = {
  __typename?: 'ReviewsFromFacilityReviewAttendance';
  image: Scalars['String'];
  jobTitle: Scalars['String'];
  name: Scalars['String'];
  workdayLabel: Scalars['String'];
};

export type ReviewsFromFacilityReviewRating = {
  __typename?: 'ReviewsFromFacilityReviewRating';
  comment?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated 旧仕様 rateNameを使ってください */
  rate?: Maybe<Scalars['Int']>;
  rateName: Scalars['String'];
};

export type SaveNotificationSettingInput = {
  smsEnabled: Scalars['Boolean'];
};

export type SaveNotificationSettingResponse = {
  __typename?: 'SaveNotificationSettingResponse';
  success: Scalars['Boolean'];
};

export type ScheduleCancellationRequest = {
  __typename?: 'ScheduleCancellationRequest';
  id: Scalars['String'];
  reason: Scalars['String'];
  schedule: ScheduleToBeCanceled;
  situation: CancelSituation;
  warningMessage?: Maybe<Scalars['String']>;
};

export type ScheduleCancellationRequestsResponse = {
  __typename?: 'ScheduleCancellationRequestsResponse';
  requests: Array<ScheduleCancellationRequest>;
};

export type ScheduleToBeCanceled = {
  __typename?: 'ScheduleToBeCanceled';
  jobTitle: Scalars['String'];
  thumbnail?: Maybe<Scalars['String']>;
  workingHours: Scalars['String'];
  workplace: Scalars['String'];
};

export type SearchPrefectureFromStationInput = {
  stationCodes: Array<Scalars['String']>;
};

export type SearchPrefectureFromStationResponse = {
  __typename?: 'SearchPrefectureFromStationResponse';
  prefectureIds: Array<Scalars['String']>;
};

export type SearchRailwayFromPrefectureInput = {
  prefectureIds: Array<Scalars['String']>;
};

export type SearchRailwayFromPrefectureResponse = {
  __typename?: 'SearchRailwayFromPrefectureResponse';
  corporations: Array<RailCorporation>;
};

export type Section = {
  __typename?: 'Section';
  attendances: Array<SectionsAttendance>;
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: SectionType;
};

export enum SectionType {
  Accepted = 'ACCEPTED',
  Created = 'CREATED',
  Rejected = 'REJECTED',
  TodayWork = 'TODAY_WORK'
}

export type SectionsAttendance = {
  __typename?: 'SectionsAttendance';
  bonus?: Maybe<Scalars['String']>;
  buttons: Array<Buttons>;
  facility: Facility;
  id: Scalars['ID'];
  job: SectionsAttendanceJob;
  label: SectionsAttendanceLabel;
  recruitmentNoticeView?: Maybe<SectionsAttendanceRecruitmentNoticeView>;
  tapToTransition: Scalars['Boolean'];
  workday: Workday;
};

export type SectionsAttendanceJob = {
  __typename?: 'SectionsAttendanceJob';
  representativeImage: Scalars['String'];
  title: Scalars['String'];
};

export type SectionsAttendanceLabel = {
  __typename?: 'SectionsAttendanceLabel';
  resultOfApprovalRequest?: Maybe<Scalars['String']>;
  timeToActivateWorkStartButton?: Maybe<Scalars['String']>;
};

export type SectionsAttendanceRecruitmentNoticeView = {
  __typename?: 'SectionsAttendanceRecruitmentNoticeView';
  backgroundColor: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export enum Sex {
  Female = 'Female',
  Male = 'Male'
}

export type Shift = {
  __typename?: 'Shift';
  displayName: Scalars['String'];
  kind: ShiftKind;
};

export enum ShiftKind {
  ShiftDay = 'SHIFT_DAY',
  ShiftEarlyMorning = 'SHIFT_EARLY_MORNING',
  ShiftNight = 'SHIFT_NIGHT'
}

export type SkipPreparationToApplyInput = {
  kind: PreparationToApplyKind;
};

export type SortOption = {
  __typename?: 'SortOption';
  howToEnable?: Maybe<HowToEnable>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SortOptionListResponse = {
  __typename?: 'SortOptionListResponse';
  options: Array<SortOption>;
};

export type StatementOfEarning = {
  __typename?: 'StatementOfEarning';
  employerId: Scalars['ID'];
  employerName: Scalars['String'];
  year: Scalars['String'];
};

export type StatementOfEarningFileInput = {
  employerId: Scalars['ID'];
  year: Scalars['String'];
};

export type StatementOfEarningFileResponse = {
  __typename?: 'StatementOfEarningFileResponse';
  base64EncodedFile: Scalars['String'];
};

export type StatementOfEarningsInput = {
  cursor?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

export type StatementOfEarningsResponse = {
  __typename?: 'StatementOfEarningsResponse';
  paging?: Maybe<PagingCursor>;
  statementOfEarnings: Array<StatementOfEarning>;
};

export type Station = {
  __typename?: 'Station';
  code: Scalars['String'];
  name: Scalars['String'];
};

export type StationOfSubscription = {
  __typename?: 'StationOfSubscription';
  code: Scalars['String'];
  name: Scalars['String'];
};

export type Subscription = {
  __typename?: 'Subscription';
  smsEnabled: Scalars['Boolean'];
};

export type SubscriptionCountResponse = {
  __typename?: 'SubscriptionCountResponse';
  count: Scalars['Int'];
};

export type SubscriptionForAvailabilityResponse = {
  __typename?: 'SubscriptionForAvailabilityResponse';
  maximumRangeOfWorkingHours?: Maybe<Scalars['Int']>;
  minimumRangeOfDailyWage?: Maybe<Scalars['Int']>;
  prefectures: Array<PrefectureOfSubscription>;
  shifts: Array<Shift>;
  stations: Array<StationOfSubscription>;
};

export enum UndeletableReason {
  WageIsReviewing = 'wageIsReviewing',
  WageTransferIsNotFinished = 'wageTransferIsNotFinished',
  WorkerIsGoingToWork = 'workerIsGoingToWork',
  WorkerNeedsToFixWage = 'workerNeedsToFixWage'
}

export type UpdateAbsentNotificationInput = {
  absentNotificationId: Scalars['String'];
  attendanceId: Scalars['String'];
};

export type UpdateBreakTimeInput = {
  attendanceId: Scalars['ID'];
  dayTime: Scalars['Int'];
  nightTime: Scalars['Int'];
};

export type UpdateBreakTimeResponse = {
  __typename?: 'UpdateBreakTimeResponse';
  success: Scalars['Boolean'];
};

export type UpdateCheckinTimeInput = {
  attendanceId: Scalars['ID'];
  time: Scalars['String'];
};

export type UpdateCheckinTimeResponse = {
  __typename?: 'UpdateCheckinTimeResponse';
  success: Scalars['Boolean'];
};

export type UpdateCheckoutTimeInput = {
  attendanceId: Scalars['ID'];
  time: Scalars['String'];
};

export type UpdateCheckoutTimeResponse = {
  __typename?: 'UpdateCheckoutTimeResponse';
  success: Scalars['Boolean'];
};

export type UpdateEmergencyContactInput = {
  phoneNumber: Scalars['String'];
  relationShipId: Scalars['ID'];
};

export type UpdateEmergencyContactResponse = {
  __typename?: 'UpdateEmergencyContactResponse';
  success: Scalars['Boolean'];
};

export type UpdateSubscriptionForAvailabilityInput = {
  idempotencyKey: Scalars['String'];
  maximumRangeOfWorkingHours?: InputMaybe<Scalars['Int']>;
  minimumRangeOfDailyWage?: InputMaybe<Scalars['Int']>;
  prefectureIds: Array<Scalars['String']>;
  shiftKinds: Array<ShiftKind>;
  stationCodes: Array<Scalars['String']>;
};

export type UpdateWorkerLicenseCertificateInput = {
  licenseId: Scalars['String'];
  remarksOnDifferentName?: InputMaybe<WorkerLicenseCertificateRemarksOnDifferentNameInput>;
  uploadId: Scalars['String'];
};

export type UpdateWorkerMainImageInput = {
  /** @deprecated アカウントは認証情報から特定できるので不要 */
  accountId?: InputMaybe<Scalars['ID']>;
  file: Scalars['UploadFile'];
};

export type UpdateWorkerMainImageResponse = {
  __typename?: 'UpdateWorkerMainImageResponse';
  success: Scalars['Boolean'];
  updatedImage?: Maybe<Scalars['String']>;
};

export type UpdateWorkerProfileInput = {
  accountId: Scalars['ID'];
  areaLId: Scalars['String'];
  areaLIds?: InputMaybe<Array<Scalars['String']>>;
  bornOn: Scalars['String'];
  building?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  desiredJobTaskIds?: InputMaybe<Array<Scalars['String']>>;
  desiredStationCodes?: InputMaybe<Array<Scalars['String']>>;
  desiredWorkingHourIds?: InputMaybe<Array<Scalars['String']>>;
  experiencedJobTaskIds?: InputMaybe<Array<Scalars['String']>>;
  firstKana: Scalars['String'];
  firstName: Scalars['String'];
  jobArrangementIds?: InputMaybe<Array<Scalars['String']>>;
  jobChangeIntention?: InputMaybe<Scalars['String']>;
  lastKana: Scalars['String'];
  lastName: Scalars['String'];
  nationality: Nationality;
  occupation?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  profile?: InputMaybe<Scalars['String']>;
  sex: Scalars['String'];
  streetNumber: Scalars['String'];
  yearsOfExperience?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UpdateWorkerProfileResponse = {
  __typename?: 'UpdateWorkerProfileResponse';
  success: Scalars['Boolean'];
};

export type User = {
  __typename?: 'User';
  id: Scalars['ID'];
};

export type WageBreakdown = {
  __typename?: 'WageBreakdown';
  expectedSalaryLabel: Scalars['String'];
  hourlyWageLabel: Scalars['String'];
  salaryDifference: ColoredLabel;
  trafficAllowanceLabel: Scalars['String'];
  withholdingTax: ColoredLabel;
};

export type WageWithAdjustmentEmploymentConditionSummary = {
  __typename?: 'WageWithAdjustmentEmploymentConditionSummary';
  breakTime: WageWithAdjustmentEmploymentConditionSummaryBreakTime;
  dateOfWork: Scalars['String'];
  facilityName: Scalars['String'];
  jobTitle: Scalars['String'];
  wage: Scalars['Int'];
};

export type WageWithAdjustmentEmploymentConditionSummaryBreakTime = {
  __typename?: 'WageWithAdjustmentEmploymentConditionSummaryBreakTime';
  dayTime: Scalars['String'];
  nightTime: Scalars['String'];
};

export type WageWithAdjustmentInput = {
  applicationId: Scalars['String'];
  token: Scalars['String'];
};

export type WageWithAdjustmentResponse = {
  __typename?: 'WageWithAdjustmentResponse';
  applicationId: Scalars['String'];
  attendanceAdjustment: AttendanceAdjustment;
  conditionLabel?: Maybe<Scalars['String']>;
  employmentConditionSummary: WageWithAdjustmentEmploymentConditionSummary;
  verifyButtonDisabled?: Maybe<Scalars['Boolean']>;
  wageBreakdown: WageBreakdown;
  wageLabel: Scalars['String'];
};

export type WageWithoutAdjustmentAttendance = {
  __typename?: 'WageWithoutAdjustmentAttendance';
  breakTimeLabel: Scalars['String'];
  endTimeLabel: Scalars['String'];
  startTimeLabel: Scalars['String'];
};

export type WageWithoutAdjustmentEmploymentConditionSummary = {
  __typename?: 'WageWithoutAdjustmentEmploymentConditionSummary';
  dateOfWork: Scalars['String'];
  facilityName: Scalars['String'];
  jobTitle: Scalars['String'];
  wage: Scalars['Int'];
};

export type WageWithoutAdjustmentInput = {
  applicationId: Scalars['String'];
  token: Scalars['String'];
};

export type WageWithoutAdjustmentResponse = {
  __typename?: 'WageWithoutAdjustmentResponse';
  applicationId: Scalars['String'];
  attendance: WageWithoutAdjustmentAttendance;
  conditionLabel?: Maybe<Scalars['String']>;
  employmentConditionSummary: WageWithoutAdjustmentEmploymentConditionSummary;
  wageBreakdown: WageBreakdown;
  wageLabel: Scalars['String'];
};

export type WithdrawApplicationInput = {
  id: Scalars['ID'];
};

export type WorkTimeResponse = {
  __typename?: 'WorkTimeResponse';
  attendanceId: Scalars['String'];
  checkinTimeLabel: Scalars['String'];
  checkoutTimeLabel: Scalars['String'];
  title: Scalars['String'];
  workPlace: Scalars['String'];
  workday: AttendanceWorkday;
};

export type Workday = {
  __typename?: 'Workday';
  endsAt: Scalars['String'];
  salary: Scalars['Int'];
  startsAt: Scalars['String'];
  wage: Scalars['Int'];
};

export type WorkerAvailableDate = {
  __typename?: 'WorkerAvailableDate';
  date: Scalars['String'];
};

export type WorkerAvailableDateListInput = {
  addedDates: Array<Scalars['String']>;
  id: Scalars['ID'];
  removedDates: Array<Scalars['String']>;
};

export type WorkerAvailableDateListResponse = {
  __typename?: 'WorkerAvailableDateListResponse';
  availableDates: Array<WorkerAvailableDate>;
};

export type WorkerBankSummaryResponse = {
  __typename?: 'WorkerBankSummaryResponse';
  balance: Scalars['Int'];
  bankAccount?: Maybe<WorkerBankSummaryBankAccount>;
  errorMessage?: Maybe<WorkerBankSummaryResponseErrorMessage>;
  withdrawing: Scalars['Int'];
};

export type WorkerBankSummaryResponseErrorMessage = {
  __typename?: 'WorkerBankSummaryResponseErrorMessage';
  reason: Scalars['String'];
};

export type WorkerBankTransfer = {
  __typename?: 'WorkerBankTransfer';
  amount: Scalars['Int'];
  breakdown?: Maybe<WorkerBankTransferBreakdown>;
  date: Scalars['String'];
  message: Scalars['String'];
  type: Scalars['String'];
};

export type WorkerBankTransferBreakdown = {
  __typename?: 'WorkerBankTransferBreakdown';
  fee: Scalars['Int'];
  netAmount: Scalars['Int'];
};

export type WorkerBankTransferInput = {
  cursor?: InputMaybe<Scalars['String']>;
  /** @deprecated アカウントは認証情報から特定できるので不要 */
  workerId?: InputMaybe<Scalars['String']>;
};

export type WorkerBankTransferPaging = {
  __typename?: 'WorkerBankTransferPaging';
  nextCursor?: Maybe<Scalars['String']>;
};

export type WorkerBankTransferResponse = {
  __typename?: 'WorkerBankTransferResponse';
  paging: WorkerBankTransferPaging;
  transfers: Array<WorkerBankTransfer>;
};

export type WorkerDeletableJudgementResponse = {
  __typename?: 'WorkerDeletableJudgementResponse';
  isDeletable: Scalars['Boolean'];
  undeletableReasons: Array<UndeletableReason>;
};

export type WorkerIdentificationResponse = {
  __typename?: 'WorkerIdentificationResponse';
  current?: Maybe<Current>;
};

export type WorkerIdentityResponse = {
  __typename?: 'WorkerIdentityResponse';
  hasUnapprovedIdentity: Scalars['Boolean'];
  nationality?: Maybe<Nationality>;
};

export type WorkerLicenseCertificate = {
  __typename?: 'WorkerLicenseCertificate';
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  licenseId: Scalars['String'];
  name: Scalars['String'];
  verificationState: LicenseVerificationState;
};

export type WorkerLicenseCertificateListResponse = {
  __typename?: 'WorkerLicenseCertificateListResponse';
  licenses: Array<WorkerLicenseCertificate>;
};

export type WorkerLicenseCertificateRejectionReason = {
  __typename?: 'WorkerLicenseCertificateRejectionReason';
  kind: Scalars['String'];
  note?: Maybe<Scalars['String']>;
};

export type WorkerLicenseCertificateRemarksOnDifferentName = {
  __typename?: 'WorkerLicenseCertificateRemarksOnDifferentName';
  note?: Maybe<Scalars['String']>;
  reason: Scalars['String'];
};

export type WorkerLicenseCertificateRemarksOnDifferentNameInput = {
  note?: InputMaybe<Scalars['String']>;
  reason: RemarksOnDifferentNameReason;
};

export type WorkerProfileAreaL = {
  __typename?: 'WorkerProfileAreaL';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type WorkerProfileAreaLList = {
  __typename?: 'WorkerProfileAreaLList';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type WorkerProfileAttendanceSummary = {
  __typename?: 'WorkerProfileAttendanceSummary';
  workedCount: Scalars['Int'];
  workedHours: Scalars['Int'];
};

export type WorkerProfileDesiredJobTasks = {
  __typename?: 'WorkerProfileDesiredJobTasks';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type WorkerProfileExperiencedJobTasks = {
  __typename?: 'WorkerProfileExperiencedJobTasks';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type WorkerProfileJobArrangements = {
  __typename?: 'WorkerProfileJobArrangements';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type WorkerProfileResponse = {
  __typename?: 'WorkerProfileResponse';
  areaL?: Maybe<WorkerProfileAreaL>;
  areaLList: Array<WorkerProfileAreaLList>;
  bornOn?: Maybe<Scalars['String']>;
  building?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  desiredJobTasks: Array<WorkerProfileDesiredJobTasks>;
  desiredStationCodes: Array<Scalars['String']>;
  desiredWorkingHourIds?: Maybe<Array<Scalars['String']>>;
  experiencedJobTasks: Array<WorkerProfileExperiencedJobTasks>;
  firstKana?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  identityVerified: Scalars['Boolean'];
  jobArrangements: Array<WorkerProfileJobArrangements>;
  jobChangeIntention?: Maybe<Scalars['String']>;
  lastKana?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  nationality?: Maybe<Nationality>;
  occupation?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profile?: Maybe<Scalars['String']>;
  representativeImage?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  workerId: Scalars['String'];
  yearsOfExperience?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type WorkerProfileReviewSummary = {
  __typename?: 'WorkerProfileReviewSummary';
  description?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
};

export type WorkingHourOption = {
  __typename?: 'WorkingHourOption';
  id: Scalars['String'];
  name: Scalars['String'];
  term: Scalars['String'];
};

export type WorkingHourOptionListResponse = {
  __typename?: 'WorkingHourOptionListResponse';
  workingHourOptions: Array<WorkingHourOption>;
};

export type UpdateWorkerAvailableDateListResponse = {
  __typename?: 'updateWorkerAvailableDateListResponse';
  success: Scalars['Boolean'];
};

export type WorkerBankSummaryBankAccount = {
  __typename?: 'workerBankSummaryBankAccount';
  name: Scalars['String'];
  numberSuffix: Scalars['String'];
  state: BankAccountState;
};

export type ApplyToRecruitmentMutationVariables = Exact<{
  data: ApplyToRecruitmentInput;
}>;


export type ApplyToRecruitmentMutation = { __typename?: 'Mutation', applyToRecruitment: { __typename?: 'ApplyToRecruitmentResponse', success: boolean } };

export type WithdrawApplicationMutationVariables = Exact<{
  data: WithdrawApplicationInput;
  token: Scalars['String'];
}>;


export type WithdrawApplicationMutation = { __typename?: 'Mutation', withdrawApplication?: boolean | null };

export type AnswerAttendanceQuestionnaireMutationVariables = Exact<{
  data: AnswerAttendanceQuestionnaireInput;
}>;


export type AnswerAttendanceQuestionnaireMutation = { __typename?: 'Mutation', answerAttendanceQuestionnaire: { __typename?: 'AnswerAttendanceQuestionnaireResponse', success: boolean } };

export type CancelAttendanceMutationVariables = Exact<{
  data: CancelAttendanceInput;
}>;


export type CancelAttendanceMutation = { __typename?: 'Mutation', cancelAttendance: { __typename?: 'CancelAttendanceResponse', success: boolean } };

export type RegisterWorkEndTimeByCodeMutationVariables = Exact<{
  data: RegisterWorkEndTimeByCodeInput;
}>;


export type RegisterWorkEndTimeByCodeMutation = { __typename?: 'Mutation', registerWorkEndTimeByCode: { __typename?: 'RegisterWorkEndTimeByCodeResponse', success: boolean } };

export type RegisterWorkStartTimeByCodeMutationVariables = Exact<{
  data: RegisterWorkStartTimeByCodeInput;
}>;


export type RegisterWorkStartTimeByCodeMutation = { __typename?: 'Mutation', registerWorkStartTimeByCode: { __typename?: 'RegisterWorkStartTimeByCodeResponse', success: boolean } };

export type RequestAttendanceApprovalMutationVariables = Exact<{
  data: RequestAttendanceApprovalInput;
}>;


export type RequestAttendanceApprovalMutation = { __typename?: 'Mutation', requestAttendanceApproval: { __typename?: 'RequestAttendanceApprovalResponse', success: boolean } };

export type UpdateAbsentNotificationMutationVariables = Exact<{
  data: UpdateAbsentNotificationInput;
  token: Scalars['String'];
}>;


export type UpdateAbsentNotificationMutation = { __typename?: 'Mutation', updateAbsentNotification?: boolean | null };

export type UpdateBreakTimeMutationVariables = Exact<{
  data: UpdateBreakTimeInput;
}>;


export type UpdateBreakTimeMutation = { __typename?: 'Mutation', updateBreakTime: { __typename?: 'UpdateBreakTimeResponse', success: boolean } };

export type UpdateCheckinTimeMutationVariables = Exact<{
  data: UpdateCheckinTimeInput;
}>;


export type UpdateCheckinTimeMutation = { __typename?: 'Mutation', updateCheckinTime: { __typename?: 'UpdateCheckinTimeResponse', success: boolean } };

export type UpdateCheckoutTimeMutationVariables = Exact<{
  data: UpdateCheckoutTimeInput;
}>;


export type UpdateCheckoutTimeMutation = { __typename?: 'Mutation', updateCheckoutTime: { __typename?: 'UpdateCheckoutTimeResponse', success: boolean } };

export type DeleteWorkerMutationVariables = Exact<{
  data: DeleteWorkerInput;
  token: Scalars['String'];
}>;


export type DeleteWorkerMutation = { __typename?: 'Mutation', deleteWorker: { __typename?: 'DeleteWorkerResponse', success: boolean } };

export type UpdateWorkerAvailableDateListMutationVariables = Exact<{
  data: WorkerAvailableDateListInput;
  token: Scalars['String'];
}>;


export type UpdateWorkerAvailableDateListMutation = { __typename?: 'Mutation', updateWorkerAvailableDateList: { __typename?: 'updateWorkerAvailableDateListResponse', success: boolean } };

export type MakeChannelMutationVariables = Exact<{
  memberId: Scalars['String'];
}>;


export type MakeChannelMutation = { __typename?: 'Mutation', makeChannel: { __typename?: 'MakeChannelResponse', id: string, type: string } };

export type MakeCsChannelMutationVariables = Exact<{ [key: string]: never; }>;


export type MakeCsChannelMutation = { __typename?: 'Mutation', makeCsChannel: { __typename?: 'MakeCsChannelResponse', id: string, type: string } };

export type RequestChatTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestChatTokenMutation = { __typename?: 'Mutation', requestChatToken: { __typename?: 'RequestChatTokenResponse', token: string } };

export type DummyMutationVariables = Exact<{ [key: string]: never; }>;


export type DummyMutation = { __typename?: 'Mutation', dummy?: { __typename?: 'DummyResponse', success: boolean } | null };

export type UpdateEmergencyContactMutationVariables = Exact<{
  data: UpdateEmergencyContactInput;
  token: Scalars['String'];
}>;


export type UpdateEmergencyContactMutation = { __typename?: 'Mutation', updateEmergencyContact: { __typename?: 'UpdateEmergencyContactResponse', success: boolean } };

export type GenerateIdentificationMutationVariables = Exact<{
  data: GenerateIdentificationInput;
  token: Scalars['String'];
}>;


export type GenerateIdentificationMutation = { __typename?: 'Mutation', generateIdentification: { __typename?: 'GenerateIdentificationResponse', publicId: string } };

export type ExchangeAmazonGiftCardMutationVariables = Exact<{
  data: ExchangeAmazonGiftCardInput;
  token: Scalars['String'];
}>;


export type ExchangeAmazonGiftCardMutation = { __typename?: 'Mutation', exchangeAmazonGiftCard: { __typename?: 'ExchangeAmazonGiftCardResponse', success: boolean } };

export type RemitPenaltyMutationVariables = Exact<{
  data: RemitPenaltyRequest;
  token: Scalars['String'];
}>;


export type RemitPenaltyMutation = { __typename?: 'Mutation', remitPenalty: { __typename?: 'RemitPenaltyResponse', orderId: string } };

export type UpdateSubscriptionForAvailabilityMutationVariables = Exact<{
  data: UpdateSubscriptionForAvailabilityInput;
  token: Scalars['String'];
}>;


export type UpdateSubscriptionForAvailabilityMutation = { __typename?: 'Mutation', updateSubscriptionForAvailability?: boolean | null };

export type SaveNotificationSettingMutationVariables = Exact<{
  data: SaveNotificationSettingInput;
  token: Scalars['String'];
}>;


export type SaveNotificationSettingMutation = { __typename?: 'Mutation', saveNotificationSetting: { __typename?: 'SaveNotificationSettingResponse', success: boolean } };

export type SkipPreparationToApplyMutationVariables = Exact<{
  data: SkipPreparationToApplyInput;
  token: Scalars['String'];
}>;


export type SkipPreparationToApplyMutation = { __typename?: 'Mutation', skipPreparationToApply?: boolean | null };

export type AddRecruitmentToFavoriteMutationVariables = Exact<{
  data: AddRecruitmentToFavoriteInput;
}>;


export type AddRecruitmentToFavoriteMutation = { __typename?: 'Mutation', addRecruitmentToFavorite: { __typename?: 'AddRecruitmentToFavoriteResponse', success: boolean } };

export type RemoveRecruitmentFromFavoriteMutationVariables = Exact<{
  data: RemoveRecruitmentFromFavoriteInput;
}>;


export type RemoveRecruitmentFromFavoriteMutation = { __typename?: 'Mutation', removeRecruitmentFromFavorite: { __typename?: 'RemoveRecruitmentFromFavoriteResponse', success: boolean } };

export type PostReviewMutationVariables = Exact<{
  data: PostReviewInput;
  token: Scalars['String'];
}>;


export type PostReviewMutation = { __typename?: 'Mutation', postReview?: boolean | null };

export type ApproveScheduleCancellationMutationVariables = Exact<{
  data: ApproveScheduleCancellationInput;
  token: Scalars['String'];
}>;


export type ApproveScheduleCancellationMutation = { __typename?: 'Mutation', approveScheduleCancellation?: boolean | null };

export type RefuseScheduleCancellationApprovalMutationVariables = Exact<{
  data: RefuseScheduleCancellationApprovalInput;
  token: Scalars['String'];
}>;


export type RefuseScheduleCancellationApprovalMutation = { __typename?: 'Mutation', refuseScheduleCancellationApproval?: boolean | null };

export type RegisterBankMutationVariables = Exact<{
  data: RegisterBankInput;
  token: Scalars['String'];
}>;


export type RegisterBankMutation = { __typename?: 'Mutation', registerBank: { __typename?: 'RegisterBankResponse', success: boolean } };

export type RequestBankTransferMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type RequestBankTransferMutation = { __typename?: 'Mutation', requestBankTransfer: { __typename?: 'RequestBankTransferResponse', success: boolean } };

export type DeleteWorkerLicenseCertificateMutationVariables = Exact<{
  data: DeleteWorkerLicenseCertificateInput;
  token: Scalars['String'];
}>;


export type DeleteWorkerLicenseCertificateMutation = { __typename?: 'Mutation', deleteWorkerLicenseCertificate?: boolean | null };

export type RegisterIdentityAndContactMutationVariables = Exact<{
  data: RegisterIdentityAndContactInput;
  token: Scalars['String'];
}>;


export type RegisterIdentityAndContactMutation = { __typename?: 'Mutation', registerIdentityAndContact?: boolean | null };

export type RegisterWorkerLicenseCertificateMutationVariables = Exact<{
  data: RegisterWorkerLicenseCertificateInput;
  token: Scalars['String'];
}>;


export type RegisterWorkerLicenseCertificateMutation = { __typename?: 'Mutation', registerWorkerLicenseCertificate: { __typename?: 'RegisterWorkerLicenseCertificateResponse', uploadId: string } };

export type UpdateEmailNotificationSettingMutationVariables = Exact<{
  data: EmailNotificationSettingInput;
  token: Scalars['String'];
}>;


export type UpdateEmailNotificationSettingMutation = { __typename?: 'Mutation', updateEmailNotificationSetting: boolean };

export type UpdateWorkerLicenseCertificateMutationVariables = Exact<{
  data: UpdateWorkerLicenseCertificateInput;
  token: Scalars['String'];
}>;


export type UpdateWorkerLicenseCertificateMutation = { __typename?: 'Mutation', updateWorkerLicenseCertificate?: boolean | null };

export type UpdateWorkerMainImageMutationVariables = Exact<{
  data: UpdateWorkerMainImageInput;
  token: Scalars['String'];
}>;


export type UpdateWorkerMainImageMutation = { __typename?: 'Mutation', updateWorkerMainImage: { __typename?: 'UpdateWorkerMainImageResponse', success: boolean, updatedImage?: string | null } };

export type UpdateWorkerProfileMutationVariables = Exact<{
  data: UpdateWorkerProfileInput;
  token: Scalars['String'];
}>;


export type UpdateWorkerProfileMutation = { __typename?: 'Mutation', updateWorkerProfile: { __typename?: 'UpdateWorkerProfileResponse', success: boolean } };

export type AddressSearchQueryVariables = Exact<{
  data: AddressSearchInput;
}>;


export type AddressSearchQuery = { __typename?: 'Query', addressSearch: { __typename?: 'AddressSearchResponse', address?: string | null, areaL?: { __typename?: 'AddressSearchResponseAreaL', id: string, name: string } | null } };

export type AbsentNotificationsQueryVariables = Exact<{
  data: AbsentNotificationsInput;
  token: Scalars['String'];
}>;


export type AbsentNotificationsQuery = { __typename?: 'Query', absentNotifications: { __typename?: 'AbsentNotificationsResponse', absentNotifications: Array<{ __typename?: 'AbsentNotification', id: string, name: string }> } };

export type AttendanceHistoriesQueryVariables = Exact<{
  data: AttendanceHistoriesInput;
  token: Scalars['String'];
}>;


export type AttendanceHistoriesQuery = { __typename?: 'Query', attendanceHistories: { __typename?: 'AttendanceHistoriesResponse', attendances: Array<{ __typename?: 'AttendanceHistoriesResponseAttendance', id: string, stateLabel?: string | null, tapToTransition: boolean, label?: { __typename?: 'AttendanceHistoriesResponseApplicationLabel', type: string, text: string } | null, workday: { __typename?: 'Workday', wage: number, salary: number, startsAt: string, endsAt: string }, job: { __typename?: 'Job', title: string, facilityName: string, representativeImage: string } }>, paging: { __typename?: 'Paging', nextCursor?: string | null } } };

export type AttendanceScheduleListQueryVariables = Exact<{
  data: AttendanceScheduleListInput;
  token: Scalars['String'];
}>;


export type AttendanceScheduleListQuery = { __typename?: 'Query', attendanceScheduleList: { __typename?: 'AttendanceScheduleListResponse', sections: Array<{ __typename?: 'Section', type: SectionType, title?: string | null, description?: string | null, attendances: Array<{ __typename?: 'SectionsAttendance', id: string, bonus?: string | null, tapToTransition: boolean, buttons: Array<{ __typename?: 'Buttons', name?: string | null, type?: ButtonType | null }>, workday: { __typename?: 'Workday', wage: number, salary: number, startsAt: string, endsAt: string }, job: { __typename?: 'SectionsAttendanceJob', title: string, representativeImage: string }, facility: { __typename?: 'Facility', id: string, name: string, phoneNumber: string }, label: { __typename?: 'SectionsAttendanceLabel', resultOfApprovalRequest?: string | null, timeToActivateWorkStartButton?: string | null }, recruitmentNoticeView?: { __typename?: 'SectionsAttendanceRecruitmentNoticeView', title: string, description?: string | null, backgroundColor: string } | null }> }>, paging: { __typename?: 'Paging', nextCursor?: string | null } } };

export type AttendanceSummaryQueryVariables = Exact<{
  data: AttendanceSummaryInput;
}>;


export type AttendanceSummaryQuery = { __typename?: 'Query', attendanceSummary: { __typename?: 'AttendanceSummaryResponse', attendanceId: string, title: string, facilityName: string, workday: { __typename?: 'AttendanceSummaryWorkday', startsAt: string, endsAt: string, salary: number } } };

export type AttendanceQuestionnaireQueryVariables = Exact<{
  data: AttendanceQuestionnaireInput;
}>;


export type AttendanceQuestionnaireQuery = { __typename?: 'Query', attendanceQuestionnaire: { __typename?: 'AttendanceQuestionnaireResponse', questionnaireItemList: Array<{ __typename?: 'AttendancesQuestionnaireItem', id: string, name: string }> } };

export type CancelWarningsQueryVariables = Exact<{
  data: CancelWarningsInput;
  token: Scalars['String'];
}>;


export type CancelWarningsQuery = { __typename?: 'Query', cancelWarnings: { __typename?: 'CancelWarningsResponse', importantMatters?: string | null, precautions: Array<string>, needsPhoneCall: boolean, penalties: Array<{ __typename?: 'PenaltySimulation', subject: string, current: { __typename?: 'PenaltySimulationTarget', prefix: string, amount: string }, afterCancellation: { __typename?: 'PenaltySimulationTarget', prefix: string, amount: string } }>, reasons: Array<{ __typename?: 'CancelReason', id: string, name: string }> } };

export type WageWithAdjustmentQueryVariables = Exact<{
  data: WageWithAdjustmentInput;
}>;


export type WageWithAdjustmentQuery = { __typename?: 'Query', wageWithAdjustment: { __typename?: 'WageWithAdjustmentResponse', applicationId: string, conditionLabel?: string | null, wageLabel: string, verifyButtonDisabled?: boolean | null, employmentConditionSummary: { __typename?: 'WageWithAdjustmentEmploymentConditionSummary', dateOfWork: string, jobTitle: string, facilityName: string, wage: number, breakTime: { __typename?: 'WageWithAdjustmentEmploymentConditionSummaryBreakTime', dayTime: string, nightTime: string } }, attendanceAdjustment: { __typename?: 'AttendanceAdjustment', startTime: { __typename?: 'ColoredLabel', label: string, colored: boolean }, endTime: { __typename?: 'ColoredLabel', label: string, colored: boolean }, breakTime: { __typename?: 'BreakTimeAdjustment', label: string, dayTimeAdjustable?: boolean | null, nightTimeAdjustable?: boolean | null } }, wageBreakdown: { __typename?: 'WageBreakdown', hourlyWageLabel: string, expectedSalaryLabel: string, trafficAllowanceLabel: string, salaryDifference: { __typename?: 'ColoredLabel', label: string, colored: boolean }, withholdingTax: { __typename?: 'ColoredLabel', label: string, colored: boolean } } } };

export type WageWithoutAdjustmentQueryVariables = Exact<{
  data: WageWithoutAdjustmentInput;
}>;


export type WageWithoutAdjustmentQuery = { __typename?: 'Query', wageWithoutAdjustment: { __typename?: 'WageWithoutAdjustmentResponse', applicationId: string, conditionLabel?: string | null, wageLabel: string, employmentConditionSummary: { __typename?: 'WageWithoutAdjustmentEmploymentConditionSummary', dateOfWork: string, jobTitle: string, facilityName: string, wage: number }, attendance: { __typename?: 'WageWithoutAdjustmentAttendance', startTimeLabel: string, endTimeLabel: string, breakTimeLabel: string }, wageBreakdown: { __typename?: 'WageBreakdown', hourlyWageLabel: string, expectedSalaryLabel: string, trafficAllowanceLabel: string, salaryDifference: { __typename?: 'ColoredLabel', label: string, colored: boolean }, withholdingTax: { __typename?: 'ColoredLabel', label: string, colored: boolean } } } };

export type WorkTimeQueryVariables = Exact<{
  id: Scalars['ID'];
  token: Scalars['String'];
}>;


export type WorkTimeQuery = { __typename?: 'Query', workTime: { __typename?: 'WorkTimeResponse', attendanceId: string, title: string, workPlace: string, checkinTimeLabel: string, checkoutTimeLabel: string, workday: { __typename?: 'AttendanceWorkday', endsAt: string, startsAt: string, wage: number, salary: number } } };

export type PredefinedDeletionReasonQueryVariables = Exact<{ [key: string]: never; }>;


export type PredefinedDeletionReasonQuery = { __typename?: 'Query', predefinedDeletionReason: { __typename?: 'PredefinedDeletionReasonResponse', reasons: Array<{ __typename?: 'Reasons', id: string, label: string }> } };

export type WorkerDeletableJudgementQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkerDeletableJudgementQuery = { __typename?: 'Query', workerDeletableJudgement: { __typename?: 'WorkerDeletableJudgementResponse', isDeletable: boolean, undeletableReasons: Array<UndeletableReason> } };

export type WorkerAvailableDateListQueryVariables = Exact<{
  id: Scalars['ID'];
  token: Scalars['String'];
}>;


export type WorkerAvailableDateListQuery = { __typename?: 'Query', workerAvailableDateList: { __typename?: 'WorkerAvailableDateListResponse', availableDates: Array<{ __typename?: 'WorkerAvailableDate', date: string }> } };

export type CurrentUserQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string } | null };

export type EmergencyContactQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type EmergencyContactQuery = { __typename?: 'Query', emergencyContact: { __typename?: 'EmergencyContactResponse', phoneNumber: string, relationShipId: string } };

export type RelationShipListQueryVariables = Exact<{ [key: string]: never; }>;


export type RelationShipListQuery = { __typename?: 'Query', relationShipList: { __typename?: 'RelationShipListResponse', relationShips: Array<{ __typename?: 'RelationShip', id: string, label: string }> } };

export type EmploymentConditionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EmploymentConditionQuery = { __typename?: 'Query', employmentCondition: { __typename?: 'EmploymentConditionResponse', id: string, recruitmentId: string, isFavoriteRecruitment: boolean, jobId: string, images: Array<string>, title: string, description: string, tasks: string, requirementLicenses?: string | null, requirementNote?: string | null, startsAt: string, endsAt: string, breakTimeLabel: string, salary: number, wageAndAllowanceLabel: string, workflow?: string | null, belonging: string, note?: string | null, appealPoints?: string | null, bonus?: string | null, tagline?: string | null, stateLabel?: string | null, review?: { __typename?: 'EmploymentConditionReview', rate?: number | null, description?: string | null, ratings: Array<{ __typename?: 'EmploymentConditionRating', name: string, rate: number }> } | null, actions: Array<{ __typename?: 'EmploymentConditionAction', name?: string | null, type?: ButtonType | null } | null>, tags: Array<{ __typename?: 'EmploymentConditionTag', name: string, color: { __typename?: 'EmploymentConditionTagColor', background: string, font: string, border: string } }>, employer: { __typename?: 'EmploymentConditionEmployer', id: string, name: string, service: string, phoneNumber: string, address: string, station: string, ambience: { __typename?: 'EmploymentConditionAmbience', averageNursingCareLevel: string } }, agreedDocuments?: Array<{ __typename?: 'AgreedDocument', name: string, url: string }> | null } };

export type WorkerIdentificationQueryVariables = Exact<{
  id: Scalars['ID'];
  token?: InputMaybe<Scalars['String']>;
}>;


export type WorkerIdentificationQuery = { __typename?: 'Query', workerIdentification: { __typename?: 'WorkerIdentificationResponse', current?: { __typename?: 'Current', state: string, messages: Array<string>, document: { __typename?: 'Document', type?: DocumentType | null, name: string } } | null } };

export type WorkerIdentityQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type WorkerIdentityQuery = { __typename?: 'Query', workerIdentity: { __typename?: 'WorkerIdentityResponse', nationality?: Nationality | null, hasUnapprovedIdentity: boolean } };

export type ExchangeRateOfAmazonGiftCardQueryVariables = Exact<{ [key: string]: never; }>;


export type ExchangeRateOfAmazonGiftCardQuery = { __typename?: 'Query', exchangeRateOfAmazonGiftCard: { __typename?: 'ExchangeRateOfAmazonGiftCardResponse', minimumExchangeableAmount: number, exchangedAmount: number } };

export type GetIncentivePointBalanceQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type GetIncentivePointBalanceQuery = { __typename?: 'Query', getIncentivePointBalance: { __typename?: 'GetIncentivePointBalanceResponse', balance: number } };

export type GetIncentivePointHistoriesQueryVariables = Exact<{
  token: Scalars['String'];
  data: GetIncentivePointHistoriesRequest;
}>;


export type GetIncentivePointHistoriesQuery = { __typename?: 'Query', getIncentivePointHistories: { __typename?: 'GetIncentivePointHistoriesResponse', cursor?: string | null, histories: Array<{ __typename?: 'History', id: string, amount: number, note?: string | null, date: string }> } };

export type IncentiveItemOrderQueryVariables = Exact<{
  data: IncentiveItemOrderRequest;
  token: Scalars['String'];
}>;


export type IncentiveItemOrderQuery = { __typename?: 'Query', incentiveItemOrder: { __typename?: 'IncentiveItemOrderResponse', status: IncentiveItemOrderStatus } };

export type SubscriptionCountQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type SubscriptionCountQuery = { __typename?: 'Query', subscriptionCount: { __typename?: 'SubscriptionCountResponse', count: number } };

export type SubscriptionForAvailabilityQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type SubscriptionForAvailabilityQuery = { __typename?: 'Query', subscriptionForAvailability: { __typename?: 'SubscriptionForAvailabilityResponse', maximumRangeOfWorkingHours?: number | null, minimumRangeOfDailyWage?: number | null, prefectures: Array<{ __typename?: 'PrefectureOfSubscription', id: string, name: string }>, stations: Array<{ __typename?: 'StationOfSubscription', code: string, name: string }>, shifts: Array<{ __typename?: 'Shift', kind: ShiftKind, displayName: string }> } };

export type AreaLListQueryVariables = Exact<{ [key: string]: never; }>;


export type AreaLListQuery = { __typename?: 'Query', areaLList: { __typename?: 'AreaLListResponse', areas: Array<{ __typename?: 'Area', id: string, name: string }> } };

export type AreaTreeQueryVariables = Exact<{ [key: string]: never; }>;


export type AreaTreeQuery = { __typename?: 'Query', areaTree: { __typename?: 'AreaTreeResponse', regions: Array<{ __typename?: 'AreaTreeResponseRegion', id: string, name: string, areaLList: Array<{ __typename?: 'AreaLTreeItem', id: string, name: string, areaMList: Array<{ __typename?: 'Area', id: string, name: string }> }> }> } };

export type BankBranchSearchQueryVariables = Exact<{
  data: BankBranchSearchInput;
}>;


export type BankBranchSearchQuery = { __typename?: 'Query', bankBranchSearch: { __typename?: 'BankBranchSearchResponse', branches: Array<{ __typename?: 'BankSearchBranches', name?: string | null, code?: string | null }> } };

export type BankSearchQueryVariables = Exact<{
  data: BankSearchInput;
}>;


export type BankSearchQuery = { __typename?: 'Query', bankSearch: { __typename?: 'BankSearchResponse', banks: Array<{ __typename?: 'BankSearchBanks', name?: string | null, code?: string | null }> } };

export type FacilityFeatureListQueryVariables = Exact<{ [key: string]: never; }>;


export type FacilityFeatureListQuery = { __typename?: 'Query', facilityFeatureList: { __typename?: 'FacilityFeatureListResponse', features: Array<{ __typename?: 'FacilityFeature', id: string, name: string }> } };

export type JobArrangementListQueryVariables = Exact<{ [key: string]: never; }>;


export type JobArrangementListQuery = { __typename?: 'Query', jobArrangementList: { __typename?: 'JobArrangementListResponse', arrangements?: Array<{ __typename?: 'JobArrangementListArrangements', id: string, name: string }> | null } };

export type JobBenefitListQueryVariables = Exact<{ [key: string]: never; }>;


export type JobBenefitListQuery = { __typename?: 'Query', jobBenefitList: { __typename?: 'JobBenefitListResponse', jobBenefits: Array<{ __typename?: 'JobBenefit', id: string, name: string }> } };

export type JobTaskListQueryVariables = Exact<{ [key: string]: never; }>;


export type JobTaskListQuery = { __typename?: 'Query', jobTaskList: { __typename?: 'JobTaskListResponse', jobTasks?: Array<{ __typename?: 'JobTask', id: string, name: string }> | null } };

export type LicenseListQueryVariables = Exact<{ [key: string]: never; }>;


export type LicenseListQuery = { __typename?: 'Query', licenseList: { __typename?: 'LicenseListResponse', licenses: Array<{ __typename?: 'License', id: string, name: string }> } };

export type NotificationSettingQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type NotificationSettingQuery = { __typename?: 'Query', notificationSetting: { __typename?: 'Subscription', smsEnabled: boolean } };

export type GetPenaltyPointHistoriesQueryVariables = Exact<{
  token: Scalars['String'];
  data: GetPenaltyPointHistoriesRequest;
}>;


export type GetPenaltyPointHistoriesQuery = { __typename?: 'Query', getPenaltyPointHistories: { __typename?: 'GetPenaltyPointHistoriesResponse', cursor?: string | null, histories: Array<{ __typename?: 'History', id: string, amount: number, note?: string | null, date: string }> } };

export type GetPenaltySummaryQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type GetPenaltySummaryQuery = { __typename?: 'Query', getPenaltySummary: { __typename?: 'GetPenaltySummaryResponse', balance: number, penaltyCount: number, feedbackComment?: string | null, currentPenalty?: { __typename?: 'CurrentPenalty', name: string, expirationDate: string } | null } };

export type PenaltyRemissionQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type PenaltyRemissionQuery = { __typename?: 'Query', penaltyRemission: { __typename?: 'PenaltyRemissionResponse', remission?: { __typename?: 'PenaltyRemission', amount: number, before: { __typename?: 'PenaltyRemissionPoints', incentivePoints: number }, after: { __typename?: 'PenaltyRemissionPoints', incentivePoints: number } } | null } };

export type GetRemainingPreparationToApplyListQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type GetRemainingPreparationToApplyListQuery = { __typename?: 'Query', getRemainingPreparationToApplyList: { __typename?: 'RemainingPreparationToApplyListResponse', preparations: Array<{ __typename?: 'PreparationToApply', kind: PreparationToApplyKind, optional: boolean } | null> } };

export type ApplicationConfirmationQueryVariables = Exact<{
  recruitmentId: Scalars['ID'];
  token?: InputMaybe<Scalars['String']>;
}>;


export type ApplicationConfirmationQuery = { __typename?: 'Query', applicationConfirmation: { __typename?: 'ApplicationConfirmationResponse', documents?: { __typename?: 'ApplicationConfirmationDocuments', type: string, button?: string | null, body: { __typename?: 'ApplicationConfirmationDocumentsBody', title: string, description: string, documents?: Array<{ __typename?: 'ApplicationConfirmationDocumentsBodyItem', name?: string | null, url?: string | null } | null> | null } } | null, confirmations: { __typename?: 'ApplicationConfirmationConfirmations', type: string, button?: string | null, body: { __typename?: 'ApplicationConfirmationConfirmationsBody', title: string, description: string, items: Array<{ __typename?: 'ApplicationConfirmationConfirmationsBodyItem', label: string, description: string }>, dialog: { __typename?: 'ApplicationConfirmationDialog', recruitment: { __typename?: 'ApplicationRecruitment', dateOfWork: string, jobTitle: string, jobRepresentativeImage: string, facilityName: string } } } } } };

export type FavoriteRecruitmentListQueryVariables = Exact<{
  data: FavoriteRecruitmentListInput;
}>;


export type FavoriteRecruitmentListQuery = { __typename?: 'Query', favoriteRecruitmentList: { __typename?: 'FavoriteRecruitmentListResponse', recruitments: Array<{ __typename?: 'RecruitmentSearchRecruitment', id: string, title: string, representativeImage: string, tasks: string, startsAt: string, endsAt: string, salary: number, travelAllowanceLabel?: string | null, capacity?: number | null, remainingRecruitmentNumbers?: number | null, state: RecruitmentState, deadline: string, bonus?: string | null, tags: Array<{ __typename?: 'RecruitmentSearchTags', name: string, color: { __typename?: 'RecruitmentSearchTagsColor', background: string, font: string, border: string } }>, facility: { __typename?: 'RecruitmentSearchFacility', name: string, service: string, address: string }, review?: { __typename?: 'RecruitmentSearchReview', rate?: number | null, description?: string | null } | null }>, paging: { __typename?: 'RecruitmentSearchPaging', nextCursor?: string | null } } };

export type RecruitmentDetailQueryVariables = Exact<{
  recruitmentId: Scalars['ID'];
  token?: InputMaybe<Scalars['String']>;
}>;


export type RecruitmentDetailQuery = { __typename?: 'Query', recruitmentDetail: { __typename?: 'RecruitmentDetailResponse', recruitmentId: string, jobId: string, images: Array<string>, title: string, description: string, tasks: string, requirementLicenses?: string | null, requirementNote?: string | null, startsAt: string, endsAt: string, breakTimeLabel: string, salary: number, capacity?: number | null, remainingRecruitmentNumbers: number, isRecruitmentCompleted: boolean, deadline: string, wageAndAllowanceLabel: string, workflow?: string | null, belonging?: string | null, note?: string | null, appealPoints?: string | null, favorited: boolean, bonus?: string | null, tagline?: string | null, tags: Array<{ __typename?: 'RecruitmentDetailTags', name: string, color: { __typename?: 'RecruitmentDetailTagsColor', background: string, font: string, border: string } }>, facility: { __typename?: 'RecruitmentDetailFacility', facilityId: string, name: string, service: string, phoneNumber: string, address: string, station: string, ambience: { __typename?: 'FacilityAmbience', averageNursingCareLevel: string } }, button: { __typename?: 'RecruitmentDetailButton', label: string, disabled: boolean, action: RecruitmentDetailButtonAction }, otherCandidates: Array<{ __typename?: 'RecruitmentDetailOtherCandidates', otherCandidatesId: string, startsAt: string, endsAt: string, salary: number, capacity: number, remainingRecruitmentNumbers: number, deadline: string, canApply: boolean, breakTimeLabel: string, wageAndAllowanceLabel: string, bonus?: string | null, warningDialogView?: { __typename?: 'RecruitmentDetailWarningDialogView', title: string, description: string, kind: RecruitmentDetailWarningDialogKind } | null }>, rate?: { __typename?: 'RecruitmentDetailRate', value?: number | null, description?: string | null, ratings: Array<{ __typename?: 'RecruitmentDetailRateRating', name: string, rate: number }> } | null, warningDialogView?: { __typename?: 'RecruitmentDetailWarningDialogView', title: string, description: string, kind: RecruitmentDetailWarningDialogKind } | null } };

export type RecruitmentSearchQueryVariables = Exact<{
  data: RecruitmentSearchInput;
}>;


export type RecruitmentSearchQuery = { __typename?: 'Query', recruitmentSearch: { __typename?: 'RecruitmentSearchResponse', recruitments: Array<{ __typename?: 'RecruitmentSearchRecruitment', id: string, title: string, representativeImage: string, tasks: string, startsAt: string, endsAt: string, salary: number, travelAllowanceLabel?: string | null, capacity?: number | null, remainingRecruitmentNumbers?: number | null, state: RecruitmentState, deadline: string, bonus?: string | null, tags: Array<{ __typename?: 'RecruitmentSearchTags', name: string, color: { __typename?: 'RecruitmentSearchTagsColor', background: string, font: string, border: string } }>, facility: { __typename?: 'RecruitmentSearchFacility', name: string, service: string, address: string }, review?: { __typename?: 'RecruitmentSearchReview', rate?: number | null, description?: string | null } | null }>, paging: { __typename?: 'RecruitmentSearchPaging', nextCursor?: string | null } } };

export type SortOptionListQueryVariables = Exact<{ [key: string]: never; }>;


export type SortOptionListQuery = { __typename?: 'Query', sortOptionList: { __typename?: 'SortOptionListResponse', options: Array<{ __typename?: 'SortOption', id: string, name: string, howToEnable?: { __typename?: 'HowToEnable', message: string } | null }> } };

export type WorkingHourOptionListQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkingHourOptionListQuery = { __typename?: 'Query', workingHourOptionList: { __typename?: 'WorkingHourOptionListResponse', workingHourOptions: Array<{ __typename?: 'WorkingHourOption', id: string, name: string, term: string }> } };

export type ReviewRequestsQueryVariables = Exact<{
  data?: InputMaybe<ReviewRequestInput>;
  token: Scalars['String'];
}>;


export type ReviewRequestsQuery = { __typename?: 'Query', reviewRequests: { __typename?: 'ReviewRequestsResponse', requests: Array<{ __typename?: 'ReviewRequest', eventId: string, startsAt: string, endsAt: string, wage: number, jobTitle: string, facilityName: string, ratings: { __typename?: 'ReviewRating', description: string, commentNotes: string, items: Array<{ __typename?: 'ReviewRatingItem', id: string, name: string, rates: Array<{ __typename?: 'ReviewRatingItemRate', id: string, name: string }> }> } }> } };

export type ReviewSummaryFromFacilityQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type ReviewSummaryFromFacilityQuery = { __typename?: 'Query', reviewSummaryFromFacility: { __typename?: 'ReviewSummaryFromFacilityResponse', reviewSummaryFromFacility?: { __typename?: 'ReviewSummaryFromFacility', rate: number, count: number } | null } };

export type ReviewsFromFacilityQueryVariables = Exact<{
  data: ReviewsFromFacilityInput;
  token: Scalars['String'];
}>;


export type ReviewsFromFacilityQuery = { __typename?: 'Query', reviewsFromFacility: { __typename?: 'ReviewsFromFacilityResponse', reviews: Array<{ __typename?: 'ReviewFromFacility', rate: number, feedbackComment?: string | null, attendance: { __typename?: 'ReviewsFromFacilityReviewAttendance', name: string, image: string, workdayLabel: string, jobTitle: string }, ratings: Array<{ __typename?: 'ReviewsFromFacilityReviewRating', name: string, rateName: string, comment?: string | null }> }>, paging: { __typename?: 'ReviewsFromFacilityPaging', cursor?: string | null } } };

export type ScheduleCancellationRequestsQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type ScheduleCancellationRequestsQuery = { __typename?: 'Query', scheduleCancellationRequests: { __typename?: 'ScheduleCancellationRequestsResponse', requests: Array<{ __typename?: 'ScheduleCancellationRequest', id: string, situation: CancelSituation, warningMessage?: string | null, reason: string, schedule: { __typename?: 'ScheduleToBeCanceled', workplace: string, thumbnail?: string | null, workingHours: string, jobTitle: string } }> } };

export type SearchPrefectureFromStationQueryVariables = Exact<{
  data: SearchPrefectureFromStationInput;
}>;


export type SearchPrefectureFromStationQuery = { __typename?: 'Query', searchPrefectureFromStation: { __typename?: 'SearchPrefectureFromStationResponse', prefectureIds: Array<string> } };

export type SearchRailwayFromPrefectureQueryVariables = Exact<{
  data: SearchRailwayFromPrefectureInput;
}>;


export type SearchRailwayFromPrefectureQuery = { __typename?: 'Query', searchRailwayFromPrefecture: { __typename?: 'SearchRailwayFromPrefectureResponse', corporations: Array<{ __typename?: 'RailCorporation', name: string, code: string, lines: Array<{ __typename?: 'RailLine', name: string, code: string, stations: Array<{ __typename?: 'Station', name: string, code: string }> }> }> } };

export type StatementOfEarningFileQueryVariables = Exact<{
  data: StatementOfEarningFileInput;
  token: Scalars['String'];
}>;


export type StatementOfEarningFileQuery = { __typename?: 'Query', statementOfEarningFile: { __typename?: 'StatementOfEarningFileResponse', base64EncodedFile: string } };

export type StatementOfEarningsQueryVariables = Exact<{
  data: StatementOfEarningsInput;
  token: Scalars['String'];
}>;


export type StatementOfEarningsQuery = { __typename?: 'Query', statementOfEarnings: { __typename?: 'StatementOfEarningsResponse', statementOfEarnings: Array<{ __typename?: 'StatementOfEarning', year: string, employerId: string, employerName: string }>, paging?: { __typename?: 'PagingCursor', cursor: string } | null } };

export type WorkerBankSummaryQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type WorkerBankSummaryQuery = { __typename?: 'Query', workerBankSummary: { __typename?: 'WorkerBankSummaryResponse', balance: number, withdrawing: number, bankAccount?: { __typename?: 'workerBankSummaryBankAccount', name: string, numberSuffix: string, state: BankAccountState } | null, errorMessage?: { __typename?: 'WorkerBankSummaryResponseErrorMessage', reason: string } | null } };

export type WorkerBankTransferQueryVariables = Exact<{
  data: WorkerBankTransferInput;
  token: Scalars['String'];
}>;


export type WorkerBankTransferQuery = { __typename?: 'Query', workerBankTransfer: { __typename?: 'WorkerBankTransferResponse', transfers: Array<{ __typename?: 'WorkerBankTransfer', type: string, message: string, amount: number, date: string, breakdown?: { __typename?: 'WorkerBankTransferBreakdown', netAmount: number, fee: number } | null }>, paging: { __typename?: 'WorkerBankTransferPaging', nextCursor?: string | null } } };

export type EmailNotificationSettingQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type EmailNotificationSettingQuery = { __typename?: 'Query', emailNotificationSetting: { __typename?: 'EmailNotificationSettingResponse', enabled: boolean } };

export type WorkerLicenseCertificateListQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type WorkerLicenseCertificateListQuery = { __typename?: 'Query', workerLicenseCertificateList: { __typename?: 'WorkerLicenseCertificateListResponse', licenses: Array<{ __typename?: 'WorkerLicenseCertificate', id: string, licenseId: string, name: string, imageUrl: string, verificationState: { __typename: 'LicenseVerificationStatePending', remarksOnDifferentName?: string | null, displayName: string } | { __typename: 'LicenseVerificationStateRejected', rejectionReason: string, displayName: string } | { __typename: 'LicenseVerificationStateVerified', displayName: string } }> } };

export type WorkerProfileQueryVariables = Exact<{
  id: Scalars['ID'];
  token: Scalars['String'];
}>;


export type WorkerProfileQuery = { __typename?: 'Query', workerProfile: { __typename?: 'WorkerProfileResponse', workerId: string, representativeImage?: string | null, lastName?: string | null, firstName?: string | null, lastKana?: string | null, firstKana?: string | null, bornOn?: string | null, sex?: string | null, nationality?: Nationality | null, phoneNumber?: string | null, zipCode?: string | null, city?: string | null, streetNumber?: string | null, building?: string | null, occupation?: string | null, jobChangeIntention?: string | null, desiredWorkingHourIds?: Array<string> | null, profile?: string | null, yearsOfExperience?: string | null, identityVerified: boolean, desiredStationCodes: Array<string>, areaL?: { __typename?: 'WorkerProfileAreaL', id: string, name: string } | null, jobArrangements: Array<{ __typename?: 'WorkerProfileJobArrangements', id: string, name: string }>, areaLList: Array<{ __typename?: 'WorkerProfileAreaLList', id: string, name: string }>, experiencedJobTasks: Array<{ __typename?: 'WorkerProfileExperiencedJobTasks', id: string, name: string }>, desiredJobTasks: Array<{ __typename?: 'WorkerProfileDesiredJobTasks', id: string, name: string }> } };


export const ApplyToRecruitmentDocument = gql`
    mutation applyToRecruitment($data: ApplyToRecruitmentInput!) {
  applyToRecruitment(data: $data) {
    success
  }
}
    `;
export type ApplyToRecruitmentMutationFn = Apollo.MutationFunction<ApplyToRecruitmentMutation, ApplyToRecruitmentMutationVariables>;

/**
 * __useApplyToRecruitmentMutation__
 *
 * To run a mutation, you first call `useApplyToRecruitmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyToRecruitmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyToRecruitmentMutation, { data, loading, error }] = useApplyToRecruitmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useApplyToRecruitmentMutation(baseOptions?: Apollo.MutationHookOptions<ApplyToRecruitmentMutation, ApplyToRecruitmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyToRecruitmentMutation, ApplyToRecruitmentMutationVariables>(ApplyToRecruitmentDocument, options);
      }
export type ApplyToRecruitmentMutationHookResult = ReturnType<typeof useApplyToRecruitmentMutation>;
export type ApplyToRecruitmentMutationResult = Apollo.MutationResult<ApplyToRecruitmentMutation>;
export type ApplyToRecruitmentMutationOptions = Apollo.BaseMutationOptions<ApplyToRecruitmentMutation, ApplyToRecruitmentMutationVariables>;
export const WithdrawApplicationDocument = gql`
    mutation withdrawApplication($data: WithdrawApplicationInput!, $token: String!) {
  withdrawApplication(data: $data, token: $token)
}
    `;
export type WithdrawApplicationMutationFn = Apollo.MutationFunction<WithdrawApplicationMutation, WithdrawApplicationMutationVariables>;

/**
 * __useWithdrawApplicationMutation__
 *
 * To run a mutation, you first call `useWithdrawApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawApplicationMutation, { data, loading, error }] = useWithdrawApplicationMutation({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useWithdrawApplicationMutation(baseOptions?: Apollo.MutationHookOptions<WithdrawApplicationMutation, WithdrawApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WithdrawApplicationMutation, WithdrawApplicationMutationVariables>(WithdrawApplicationDocument, options);
      }
export type WithdrawApplicationMutationHookResult = ReturnType<typeof useWithdrawApplicationMutation>;
export type WithdrawApplicationMutationResult = Apollo.MutationResult<WithdrawApplicationMutation>;
export type WithdrawApplicationMutationOptions = Apollo.BaseMutationOptions<WithdrawApplicationMutation, WithdrawApplicationMutationVariables>;
export const AnswerAttendanceQuestionnaireDocument = gql`
    mutation answerAttendanceQuestionnaire($data: AnswerAttendanceQuestionnaireInput!) {
  answerAttendanceQuestionnaire(data: $data) {
    success
  }
}
    `;
export type AnswerAttendanceQuestionnaireMutationFn = Apollo.MutationFunction<AnswerAttendanceQuestionnaireMutation, AnswerAttendanceQuestionnaireMutationVariables>;

/**
 * __useAnswerAttendanceQuestionnaireMutation__
 *
 * To run a mutation, you first call `useAnswerAttendanceQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerAttendanceQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerAttendanceQuestionnaireMutation, { data, loading, error }] = useAnswerAttendanceQuestionnaireMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAnswerAttendanceQuestionnaireMutation(baseOptions?: Apollo.MutationHookOptions<AnswerAttendanceQuestionnaireMutation, AnswerAttendanceQuestionnaireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerAttendanceQuestionnaireMutation, AnswerAttendanceQuestionnaireMutationVariables>(AnswerAttendanceQuestionnaireDocument, options);
      }
export type AnswerAttendanceQuestionnaireMutationHookResult = ReturnType<typeof useAnswerAttendanceQuestionnaireMutation>;
export type AnswerAttendanceQuestionnaireMutationResult = Apollo.MutationResult<AnswerAttendanceQuestionnaireMutation>;
export type AnswerAttendanceQuestionnaireMutationOptions = Apollo.BaseMutationOptions<AnswerAttendanceQuestionnaireMutation, AnswerAttendanceQuestionnaireMutationVariables>;
export const CancelAttendanceDocument = gql`
    mutation cancelAttendance($data: CancelAttendanceInput!) {
  cancelAttendance(data: $data) {
    success
  }
}
    `;
export type CancelAttendanceMutationFn = Apollo.MutationFunction<CancelAttendanceMutation, CancelAttendanceMutationVariables>;

/**
 * __useCancelAttendanceMutation__
 *
 * To run a mutation, you first call `useCancelAttendanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAttendanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAttendanceMutation, { data, loading, error }] = useCancelAttendanceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCancelAttendanceMutation(baseOptions?: Apollo.MutationHookOptions<CancelAttendanceMutation, CancelAttendanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAttendanceMutation, CancelAttendanceMutationVariables>(CancelAttendanceDocument, options);
      }
export type CancelAttendanceMutationHookResult = ReturnType<typeof useCancelAttendanceMutation>;
export type CancelAttendanceMutationResult = Apollo.MutationResult<CancelAttendanceMutation>;
export type CancelAttendanceMutationOptions = Apollo.BaseMutationOptions<CancelAttendanceMutation, CancelAttendanceMutationVariables>;
export const RegisterWorkEndTimeByCodeDocument = gql`
    mutation registerWorkEndTimeByCode($data: RegisterWorkEndTimeByCodeInput!) {
  registerWorkEndTimeByCode(data: $data) {
    success
  }
}
    `;
export type RegisterWorkEndTimeByCodeMutationFn = Apollo.MutationFunction<RegisterWorkEndTimeByCodeMutation, RegisterWorkEndTimeByCodeMutationVariables>;

/**
 * __useRegisterWorkEndTimeByCodeMutation__
 *
 * To run a mutation, you first call `useRegisterWorkEndTimeByCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterWorkEndTimeByCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerWorkEndTimeByCodeMutation, { data, loading, error }] = useRegisterWorkEndTimeByCodeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRegisterWorkEndTimeByCodeMutation(baseOptions?: Apollo.MutationHookOptions<RegisterWorkEndTimeByCodeMutation, RegisterWorkEndTimeByCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterWorkEndTimeByCodeMutation, RegisterWorkEndTimeByCodeMutationVariables>(RegisterWorkEndTimeByCodeDocument, options);
      }
export type RegisterWorkEndTimeByCodeMutationHookResult = ReturnType<typeof useRegisterWorkEndTimeByCodeMutation>;
export type RegisterWorkEndTimeByCodeMutationResult = Apollo.MutationResult<RegisterWorkEndTimeByCodeMutation>;
export type RegisterWorkEndTimeByCodeMutationOptions = Apollo.BaseMutationOptions<RegisterWorkEndTimeByCodeMutation, RegisterWorkEndTimeByCodeMutationVariables>;
export const RegisterWorkStartTimeByCodeDocument = gql`
    mutation registerWorkStartTimeByCode($data: RegisterWorkStartTimeByCodeInput!) {
  registerWorkStartTimeByCode(data: $data) {
    success
  }
}
    `;
export type RegisterWorkStartTimeByCodeMutationFn = Apollo.MutationFunction<RegisterWorkStartTimeByCodeMutation, RegisterWorkStartTimeByCodeMutationVariables>;

/**
 * __useRegisterWorkStartTimeByCodeMutation__
 *
 * To run a mutation, you first call `useRegisterWorkStartTimeByCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterWorkStartTimeByCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerWorkStartTimeByCodeMutation, { data, loading, error }] = useRegisterWorkStartTimeByCodeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRegisterWorkStartTimeByCodeMutation(baseOptions?: Apollo.MutationHookOptions<RegisterWorkStartTimeByCodeMutation, RegisterWorkStartTimeByCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterWorkStartTimeByCodeMutation, RegisterWorkStartTimeByCodeMutationVariables>(RegisterWorkStartTimeByCodeDocument, options);
      }
export type RegisterWorkStartTimeByCodeMutationHookResult = ReturnType<typeof useRegisterWorkStartTimeByCodeMutation>;
export type RegisterWorkStartTimeByCodeMutationResult = Apollo.MutationResult<RegisterWorkStartTimeByCodeMutation>;
export type RegisterWorkStartTimeByCodeMutationOptions = Apollo.BaseMutationOptions<RegisterWorkStartTimeByCodeMutation, RegisterWorkStartTimeByCodeMutationVariables>;
export const RequestAttendanceApprovalDocument = gql`
    mutation requestAttendanceApproval($data: RequestAttendanceApprovalInput!) {
  requestAttendanceApproval(data: $data) {
    success
  }
}
    `;
export type RequestAttendanceApprovalMutationFn = Apollo.MutationFunction<RequestAttendanceApprovalMutation, RequestAttendanceApprovalMutationVariables>;

/**
 * __useRequestAttendanceApprovalMutation__
 *
 * To run a mutation, you first call `useRequestAttendanceApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAttendanceApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAttendanceApprovalMutation, { data, loading, error }] = useRequestAttendanceApprovalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRequestAttendanceApprovalMutation(baseOptions?: Apollo.MutationHookOptions<RequestAttendanceApprovalMutation, RequestAttendanceApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAttendanceApprovalMutation, RequestAttendanceApprovalMutationVariables>(RequestAttendanceApprovalDocument, options);
      }
export type RequestAttendanceApprovalMutationHookResult = ReturnType<typeof useRequestAttendanceApprovalMutation>;
export type RequestAttendanceApprovalMutationResult = Apollo.MutationResult<RequestAttendanceApprovalMutation>;
export type RequestAttendanceApprovalMutationOptions = Apollo.BaseMutationOptions<RequestAttendanceApprovalMutation, RequestAttendanceApprovalMutationVariables>;
export const UpdateAbsentNotificationDocument = gql`
    mutation updateAbsentNotification($data: UpdateAbsentNotificationInput!, $token: String!) {
  updateAbsentNotification(data: $data, token: $token)
}
    `;
export type UpdateAbsentNotificationMutationFn = Apollo.MutationFunction<UpdateAbsentNotificationMutation, UpdateAbsentNotificationMutationVariables>;

/**
 * __useUpdateAbsentNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateAbsentNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAbsentNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAbsentNotificationMutation, { data, loading, error }] = useUpdateAbsentNotificationMutation({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUpdateAbsentNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAbsentNotificationMutation, UpdateAbsentNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAbsentNotificationMutation, UpdateAbsentNotificationMutationVariables>(UpdateAbsentNotificationDocument, options);
      }
export type UpdateAbsentNotificationMutationHookResult = ReturnType<typeof useUpdateAbsentNotificationMutation>;
export type UpdateAbsentNotificationMutationResult = Apollo.MutationResult<UpdateAbsentNotificationMutation>;
export type UpdateAbsentNotificationMutationOptions = Apollo.BaseMutationOptions<UpdateAbsentNotificationMutation, UpdateAbsentNotificationMutationVariables>;
export const UpdateBreakTimeDocument = gql`
    mutation updateBreakTime($data: UpdateBreakTimeInput!) {
  updateBreakTime(data: $data) {
    success
  }
}
    `;
export type UpdateBreakTimeMutationFn = Apollo.MutationFunction<UpdateBreakTimeMutation, UpdateBreakTimeMutationVariables>;

/**
 * __useUpdateBreakTimeMutation__
 *
 * To run a mutation, you first call `useUpdateBreakTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBreakTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBreakTimeMutation, { data, loading, error }] = useUpdateBreakTimeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBreakTimeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBreakTimeMutation, UpdateBreakTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBreakTimeMutation, UpdateBreakTimeMutationVariables>(UpdateBreakTimeDocument, options);
      }
export type UpdateBreakTimeMutationHookResult = ReturnType<typeof useUpdateBreakTimeMutation>;
export type UpdateBreakTimeMutationResult = Apollo.MutationResult<UpdateBreakTimeMutation>;
export type UpdateBreakTimeMutationOptions = Apollo.BaseMutationOptions<UpdateBreakTimeMutation, UpdateBreakTimeMutationVariables>;
export const UpdateCheckinTimeDocument = gql`
    mutation updateCheckinTime($data: UpdateCheckinTimeInput!) {
  updateCheckinTime(data: $data) {
    success
  }
}
    `;
export type UpdateCheckinTimeMutationFn = Apollo.MutationFunction<UpdateCheckinTimeMutation, UpdateCheckinTimeMutationVariables>;

/**
 * __useUpdateCheckinTimeMutation__
 *
 * To run a mutation, you first call `useUpdateCheckinTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckinTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckinTimeMutation, { data, loading, error }] = useUpdateCheckinTimeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCheckinTimeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCheckinTimeMutation, UpdateCheckinTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCheckinTimeMutation, UpdateCheckinTimeMutationVariables>(UpdateCheckinTimeDocument, options);
      }
export type UpdateCheckinTimeMutationHookResult = ReturnType<typeof useUpdateCheckinTimeMutation>;
export type UpdateCheckinTimeMutationResult = Apollo.MutationResult<UpdateCheckinTimeMutation>;
export type UpdateCheckinTimeMutationOptions = Apollo.BaseMutationOptions<UpdateCheckinTimeMutation, UpdateCheckinTimeMutationVariables>;
export const UpdateCheckoutTimeDocument = gql`
    mutation updateCheckoutTime($data: UpdateCheckoutTimeInput!) {
  updateCheckoutTime(data: $data) {
    success
  }
}
    `;
export type UpdateCheckoutTimeMutationFn = Apollo.MutationFunction<UpdateCheckoutTimeMutation, UpdateCheckoutTimeMutationVariables>;

/**
 * __useUpdateCheckoutTimeMutation__
 *
 * To run a mutation, you first call `useUpdateCheckoutTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckoutTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckoutTimeMutation, { data, loading, error }] = useUpdateCheckoutTimeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCheckoutTimeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCheckoutTimeMutation, UpdateCheckoutTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCheckoutTimeMutation, UpdateCheckoutTimeMutationVariables>(UpdateCheckoutTimeDocument, options);
      }
export type UpdateCheckoutTimeMutationHookResult = ReturnType<typeof useUpdateCheckoutTimeMutation>;
export type UpdateCheckoutTimeMutationResult = Apollo.MutationResult<UpdateCheckoutTimeMutation>;
export type UpdateCheckoutTimeMutationOptions = Apollo.BaseMutationOptions<UpdateCheckoutTimeMutation, UpdateCheckoutTimeMutationVariables>;
export const DeleteWorkerDocument = gql`
    mutation deleteWorker($data: DeleteWorkerInput!, $token: String!) {
  deleteWorker(data: $data, token: $token) {
    success
  }
}
    `;
export type DeleteWorkerMutationFn = Apollo.MutationFunction<DeleteWorkerMutation, DeleteWorkerMutationVariables>;

/**
 * __useDeleteWorkerMutation__
 *
 * To run a mutation, you first call `useDeleteWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkerMutation, { data, loading, error }] = useDeleteWorkerMutation({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useDeleteWorkerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkerMutation, DeleteWorkerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkerMutation, DeleteWorkerMutationVariables>(DeleteWorkerDocument, options);
      }
export type DeleteWorkerMutationHookResult = ReturnType<typeof useDeleteWorkerMutation>;
export type DeleteWorkerMutationResult = Apollo.MutationResult<DeleteWorkerMutation>;
export type DeleteWorkerMutationOptions = Apollo.BaseMutationOptions<DeleteWorkerMutation, DeleteWorkerMutationVariables>;
export const UpdateWorkerAvailableDateListDocument = gql`
    mutation updateWorkerAvailableDateList($data: WorkerAvailableDateListInput!, $token: String!) {
  updateWorkerAvailableDateList(data: $data, token: $token) {
    success
  }
}
    `;
export type UpdateWorkerAvailableDateListMutationFn = Apollo.MutationFunction<UpdateWorkerAvailableDateListMutation, UpdateWorkerAvailableDateListMutationVariables>;

/**
 * __useUpdateWorkerAvailableDateListMutation__
 *
 * To run a mutation, you first call `useUpdateWorkerAvailableDateListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkerAvailableDateListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkerAvailableDateListMutation, { data, loading, error }] = useUpdateWorkerAvailableDateListMutation({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUpdateWorkerAvailableDateListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkerAvailableDateListMutation, UpdateWorkerAvailableDateListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkerAvailableDateListMutation, UpdateWorkerAvailableDateListMutationVariables>(UpdateWorkerAvailableDateListDocument, options);
      }
export type UpdateWorkerAvailableDateListMutationHookResult = ReturnType<typeof useUpdateWorkerAvailableDateListMutation>;
export type UpdateWorkerAvailableDateListMutationResult = Apollo.MutationResult<UpdateWorkerAvailableDateListMutation>;
export type UpdateWorkerAvailableDateListMutationOptions = Apollo.BaseMutationOptions<UpdateWorkerAvailableDateListMutation, UpdateWorkerAvailableDateListMutationVariables>;
export const MakeChannelDocument = gql`
    mutation makeChannel($memberId: String!) {
  makeChannel(memberId: $memberId) {
    id
    type
  }
}
    `;
export type MakeChannelMutationFn = Apollo.MutationFunction<MakeChannelMutation, MakeChannelMutationVariables>;

/**
 * __useMakeChannelMutation__
 *
 * To run a mutation, you first call `useMakeChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeChannelMutation, { data, loading, error }] = useMakeChannelMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useMakeChannelMutation(baseOptions?: Apollo.MutationHookOptions<MakeChannelMutation, MakeChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeChannelMutation, MakeChannelMutationVariables>(MakeChannelDocument, options);
      }
export type MakeChannelMutationHookResult = ReturnType<typeof useMakeChannelMutation>;
export type MakeChannelMutationResult = Apollo.MutationResult<MakeChannelMutation>;
export type MakeChannelMutationOptions = Apollo.BaseMutationOptions<MakeChannelMutation, MakeChannelMutationVariables>;
export const MakeCsChannelDocument = gql`
    mutation makeCsChannel {
  makeCsChannel {
    id
    type
  }
}
    `;
export type MakeCsChannelMutationFn = Apollo.MutationFunction<MakeCsChannelMutation, MakeCsChannelMutationVariables>;

/**
 * __useMakeCsChannelMutation__
 *
 * To run a mutation, you first call `useMakeCsChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeCsChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeCsChannelMutation, { data, loading, error }] = useMakeCsChannelMutation({
 *   variables: {
 *   },
 * });
 */
export function useMakeCsChannelMutation(baseOptions?: Apollo.MutationHookOptions<MakeCsChannelMutation, MakeCsChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeCsChannelMutation, MakeCsChannelMutationVariables>(MakeCsChannelDocument, options);
      }
export type MakeCsChannelMutationHookResult = ReturnType<typeof useMakeCsChannelMutation>;
export type MakeCsChannelMutationResult = Apollo.MutationResult<MakeCsChannelMutation>;
export type MakeCsChannelMutationOptions = Apollo.BaseMutationOptions<MakeCsChannelMutation, MakeCsChannelMutationVariables>;
export const RequestChatTokenDocument = gql`
    mutation requestChatToken {
  requestChatToken {
    token
  }
}
    `;
export type RequestChatTokenMutationFn = Apollo.MutationFunction<RequestChatTokenMutation, RequestChatTokenMutationVariables>;

/**
 * __useRequestChatTokenMutation__
 *
 * To run a mutation, you first call `useRequestChatTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestChatTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestChatTokenMutation, { data, loading, error }] = useRequestChatTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestChatTokenMutation(baseOptions?: Apollo.MutationHookOptions<RequestChatTokenMutation, RequestChatTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestChatTokenMutation, RequestChatTokenMutationVariables>(RequestChatTokenDocument, options);
      }
export type RequestChatTokenMutationHookResult = ReturnType<typeof useRequestChatTokenMutation>;
export type RequestChatTokenMutationResult = Apollo.MutationResult<RequestChatTokenMutation>;
export type RequestChatTokenMutationOptions = Apollo.BaseMutationOptions<RequestChatTokenMutation, RequestChatTokenMutationVariables>;
export const DummyDocument = gql`
    mutation dummy {
  dummy {
    success
  }
}
    `;
export type DummyMutationFn = Apollo.MutationFunction<DummyMutation, DummyMutationVariables>;

/**
 * __useDummyMutation__
 *
 * To run a mutation, you first call `useDummyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDummyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dummyMutation, { data, loading, error }] = useDummyMutation({
 *   variables: {
 *   },
 * });
 */
export function useDummyMutation(baseOptions?: Apollo.MutationHookOptions<DummyMutation, DummyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DummyMutation, DummyMutationVariables>(DummyDocument, options);
      }
export type DummyMutationHookResult = ReturnType<typeof useDummyMutation>;
export type DummyMutationResult = Apollo.MutationResult<DummyMutation>;
export type DummyMutationOptions = Apollo.BaseMutationOptions<DummyMutation, DummyMutationVariables>;
export const UpdateEmergencyContactDocument = gql`
    mutation updateEmergencyContact($data: UpdateEmergencyContactInput!, $token: String!) {
  updateEmergencyContact(data: $data, token: $token) {
    success
  }
}
    `;
export type UpdateEmergencyContactMutationFn = Apollo.MutationFunction<UpdateEmergencyContactMutation, UpdateEmergencyContactMutationVariables>;

/**
 * __useUpdateEmergencyContactMutation__
 *
 * To run a mutation, you first call `useUpdateEmergencyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmergencyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmergencyContactMutation, { data, loading, error }] = useUpdateEmergencyContactMutation({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUpdateEmergencyContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmergencyContactMutation, UpdateEmergencyContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmergencyContactMutation, UpdateEmergencyContactMutationVariables>(UpdateEmergencyContactDocument, options);
      }
export type UpdateEmergencyContactMutationHookResult = ReturnType<typeof useUpdateEmergencyContactMutation>;
export type UpdateEmergencyContactMutationResult = Apollo.MutationResult<UpdateEmergencyContactMutation>;
export type UpdateEmergencyContactMutationOptions = Apollo.BaseMutationOptions<UpdateEmergencyContactMutation, UpdateEmergencyContactMutationVariables>;
export const GenerateIdentificationDocument = gql`
    mutation generateIdentification($data: GenerateIdentificationInput!, $token: String!) {
  generateIdentification(data: $data, token: $token) {
    publicId
  }
}
    `;
export type GenerateIdentificationMutationFn = Apollo.MutationFunction<GenerateIdentificationMutation, GenerateIdentificationMutationVariables>;

/**
 * __useGenerateIdentificationMutation__
 *
 * To run a mutation, you first call `useGenerateIdentificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateIdentificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateIdentificationMutation, { data, loading, error }] = useGenerateIdentificationMutation({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGenerateIdentificationMutation(baseOptions?: Apollo.MutationHookOptions<GenerateIdentificationMutation, GenerateIdentificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateIdentificationMutation, GenerateIdentificationMutationVariables>(GenerateIdentificationDocument, options);
      }
export type GenerateIdentificationMutationHookResult = ReturnType<typeof useGenerateIdentificationMutation>;
export type GenerateIdentificationMutationResult = Apollo.MutationResult<GenerateIdentificationMutation>;
export type GenerateIdentificationMutationOptions = Apollo.BaseMutationOptions<GenerateIdentificationMutation, GenerateIdentificationMutationVariables>;
export const ExchangeAmazonGiftCardDocument = gql`
    mutation exchangeAmazonGiftCard($data: ExchangeAmazonGiftCardInput!, $token: String!) {
  exchangeAmazonGiftCard(data: $data, token: $token) {
    success
  }
}
    `;
export type ExchangeAmazonGiftCardMutationFn = Apollo.MutationFunction<ExchangeAmazonGiftCardMutation, ExchangeAmazonGiftCardMutationVariables>;

/**
 * __useExchangeAmazonGiftCardMutation__
 *
 * To run a mutation, you first call `useExchangeAmazonGiftCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExchangeAmazonGiftCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exchangeAmazonGiftCardMutation, { data, loading, error }] = useExchangeAmazonGiftCardMutation({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useExchangeAmazonGiftCardMutation(baseOptions?: Apollo.MutationHookOptions<ExchangeAmazonGiftCardMutation, ExchangeAmazonGiftCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExchangeAmazonGiftCardMutation, ExchangeAmazonGiftCardMutationVariables>(ExchangeAmazonGiftCardDocument, options);
      }
export type ExchangeAmazonGiftCardMutationHookResult = ReturnType<typeof useExchangeAmazonGiftCardMutation>;
export type ExchangeAmazonGiftCardMutationResult = Apollo.MutationResult<ExchangeAmazonGiftCardMutation>;
export type ExchangeAmazonGiftCardMutationOptions = Apollo.BaseMutationOptions<ExchangeAmazonGiftCardMutation, ExchangeAmazonGiftCardMutationVariables>;
export const RemitPenaltyDocument = gql`
    mutation remitPenalty($data: RemitPenaltyRequest!, $token: String!) {
  remitPenalty(data: $data, token: $token) {
    orderId
  }
}
    `;
export type RemitPenaltyMutationFn = Apollo.MutationFunction<RemitPenaltyMutation, RemitPenaltyMutationVariables>;

/**
 * __useRemitPenaltyMutation__
 *
 * To run a mutation, you first call `useRemitPenaltyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemitPenaltyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [remitPenaltyMutation, { data, loading, error }] = useRemitPenaltyMutation({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRemitPenaltyMutation(baseOptions?: Apollo.MutationHookOptions<RemitPenaltyMutation, RemitPenaltyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemitPenaltyMutation, RemitPenaltyMutationVariables>(RemitPenaltyDocument, options);
      }
export type RemitPenaltyMutationHookResult = ReturnType<typeof useRemitPenaltyMutation>;
export type RemitPenaltyMutationResult = Apollo.MutationResult<RemitPenaltyMutation>;
export type RemitPenaltyMutationOptions = Apollo.BaseMutationOptions<RemitPenaltyMutation, RemitPenaltyMutationVariables>;
export const UpdateSubscriptionForAvailabilityDocument = gql`
    mutation updateSubscriptionForAvailability($data: UpdateSubscriptionForAvailabilityInput!, $token: String!) {
  updateSubscriptionForAvailability(data: $data, token: $token)
}
    `;
export type UpdateSubscriptionForAvailabilityMutationFn = Apollo.MutationFunction<UpdateSubscriptionForAvailabilityMutation, UpdateSubscriptionForAvailabilityMutationVariables>;

/**
 * __useUpdateSubscriptionForAvailabilityMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionForAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionForAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionForAvailabilityMutation, { data, loading, error }] = useUpdateSubscriptionForAvailabilityMutation({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUpdateSubscriptionForAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubscriptionForAvailabilityMutation, UpdateSubscriptionForAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubscriptionForAvailabilityMutation, UpdateSubscriptionForAvailabilityMutationVariables>(UpdateSubscriptionForAvailabilityDocument, options);
      }
export type UpdateSubscriptionForAvailabilityMutationHookResult = ReturnType<typeof useUpdateSubscriptionForAvailabilityMutation>;
export type UpdateSubscriptionForAvailabilityMutationResult = Apollo.MutationResult<UpdateSubscriptionForAvailabilityMutation>;
export type UpdateSubscriptionForAvailabilityMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionForAvailabilityMutation, UpdateSubscriptionForAvailabilityMutationVariables>;
export const SaveNotificationSettingDocument = gql`
    mutation saveNotificationSetting($data: SaveNotificationSettingInput!, $token: String!) {
  saveNotificationSetting(data: $data, token: $token) {
    success
  }
}
    `;
export type SaveNotificationSettingMutationFn = Apollo.MutationFunction<SaveNotificationSettingMutation, SaveNotificationSettingMutationVariables>;

/**
 * __useSaveNotificationSettingMutation__
 *
 * To run a mutation, you first call `useSaveNotificationSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveNotificationSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveNotificationSettingMutation, { data, loading, error }] = useSaveNotificationSettingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSaveNotificationSettingMutation(baseOptions?: Apollo.MutationHookOptions<SaveNotificationSettingMutation, SaveNotificationSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveNotificationSettingMutation, SaveNotificationSettingMutationVariables>(SaveNotificationSettingDocument, options);
      }
export type SaveNotificationSettingMutationHookResult = ReturnType<typeof useSaveNotificationSettingMutation>;
export type SaveNotificationSettingMutationResult = Apollo.MutationResult<SaveNotificationSettingMutation>;
export type SaveNotificationSettingMutationOptions = Apollo.BaseMutationOptions<SaveNotificationSettingMutation, SaveNotificationSettingMutationVariables>;
export const SkipPreparationToApplyDocument = gql`
    mutation skipPreparationToApply($data: SkipPreparationToApplyInput!, $token: String!) {
  skipPreparationToApply(data: $data, token: $token)
}
    `;
export type SkipPreparationToApplyMutationFn = Apollo.MutationFunction<SkipPreparationToApplyMutation, SkipPreparationToApplyMutationVariables>;

/**
 * __useSkipPreparationToApplyMutation__
 *
 * To run a mutation, you first call `useSkipPreparationToApplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipPreparationToApplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipPreparationToApplyMutation, { data, loading, error }] = useSkipPreparationToApplyMutation({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSkipPreparationToApplyMutation(baseOptions?: Apollo.MutationHookOptions<SkipPreparationToApplyMutation, SkipPreparationToApplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkipPreparationToApplyMutation, SkipPreparationToApplyMutationVariables>(SkipPreparationToApplyDocument, options);
      }
export type SkipPreparationToApplyMutationHookResult = ReturnType<typeof useSkipPreparationToApplyMutation>;
export type SkipPreparationToApplyMutationResult = Apollo.MutationResult<SkipPreparationToApplyMutation>;
export type SkipPreparationToApplyMutationOptions = Apollo.BaseMutationOptions<SkipPreparationToApplyMutation, SkipPreparationToApplyMutationVariables>;
export const AddRecruitmentToFavoriteDocument = gql`
    mutation addRecruitmentToFavorite($data: AddRecruitmentToFavoriteInput!) {
  addRecruitmentToFavorite(data: $data) {
    success
  }
}
    `;
export type AddRecruitmentToFavoriteMutationFn = Apollo.MutationFunction<AddRecruitmentToFavoriteMutation, AddRecruitmentToFavoriteMutationVariables>;

/**
 * __useAddRecruitmentToFavoriteMutation__
 *
 * To run a mutation, you first call `useAddRecruitmentToFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRecruitmentToFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRecruitmentToFavoriteMutation, { data, loading, error }] = useAddRecruitmentToFavoriteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddRecruitmentToFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<AddRecruitmentToFavoriteMutation, AddRecruitmentToFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRecruitmentToFavoriteMutation, AddRecruitmentToFavoriteMutationVariables>(AddRecruitmentToFavoriteDocument, options);
      }
export type AddRecruitmentToFavoriteMutationHookResult = ReturnType<typeof useAddRecruitmentToFavoriteMutation>;
export type AddRecruitmentToFavoriteMutationResult = Apollo.MutationResult<AddRecruitmentToFavoriteMutation>;
export type AddRecruitmentToFavoriteMutationOptions = Apollo.BaseMutationOptions<AddRecruitmentToFavoriteMutation, AddRecruitmentToFavoriteMutationVariables>;
export const RemoveRecruitmentFromFavoriteDocument = gql`
    mutation removeRecruitmentFromFavorite($data: RemoveRecruitmentFromFavoriteInput!) {
  removeRecruitmentFromFavorite(data: $data) {
    success
  }
}
    `;
export type RemoveRecruitmentFromFavoriteMutationFn = Apollo.MutationFunction<RemoveRecruitmentFromFavoriteMutation, RemoveRecruitmentFromFavoriteMutationVariables>;

/**
 * __useRemoveRecruitmentFromFavoriteMutation__
 *
 * To run a mutation, you first call `useRemoveRecruitmentFromFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRecruitmentFromFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRecruitmentFromFavoriteMutation, { data, loading, error }] = useRemoveRecruitmentFromFavoriteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveRecruitmentFromFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRecruitmentFromFavoriteMutation, RemoveRecruitmentFromFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRecruitmentFromFavoriteMutation, RemoveRecruitmentFromFavoriteMutationVariables>(RemoveRecruitmentFromFavoriteDocument, options);
      }
export type RemoveRecruitmentFromFavoriteMutationHookResult = ReturnType<typeof useRemoveRecruitmentFromFavoriteMutation>;
export type RemoveRecruitmentFromFavoriteMutationResult = Apollo.MutationResult<RemoveRecruitmentFromFavoriteMutation>;
export type RemoveRecruitmentFromFavoriteMutationOptions = Apollo.BaseMutationOptions<RemoveRecruitmentFromFavoriteMutation, RemoveRecruitmentFromFavoriteMutationVariables>;
export const PostReviewDocument = gql`
    mutation postReview($data: PostReviewInput!, $token: String!) {
  postReview(data: $data, token: $token)
}
    `;
export type PostReviewMutationFn = Apollo.MutationFunction<PostReviewMutation, PostReviewMutationVariables>;

/**
 * __usePostReviewMutation__
 *
 * To run a mutation, you first call `usePostReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postReviewMutation, { data, loading, error }] = usePostReviewMutation({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function usePostReviewMutation(baseOptions?: Apollo.MutationHookOptions<PostReviewMutation, PostReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostReviewMutation, PostReviewMutationVariables>(PostReviewDocument, options);
      }
export type PostReviewMutationHookResult = ReturnType<typeof usePostReviewMutation>;
export type PostReviewMutationResult = Apollo.MutationResult<PostReviewMutation>;
export type PostReviewMutationOptions = Apollo.BaseMutationOptions<PostReviewMutation, PostReviewMutationVariables>;
export const ApproveScheduleCancellationDocument = gql`
    mutation approveScheduleCancellation($data: ApproveScheduleCancellationInput!, $token: String!) {
  approveScheduleCancellation(data: $data, token: $token)
}
    `;
export type ApproveScheduleCancellationMutationFn = Apollo.MutationFunction<ApproveScheduleCancellationMutation, ApproveScheduleCancellationMutationVariables>;

/**
 * __useApproveScheduleCancellationMutation__
 *
 * To run a mutation, you first call `useApproveScheduleCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveScheduleCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveScheduleCancellationMutation, { data, loading, error }] = useApproveScheduleCancellationMutation({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useApproveScheduleCancellationMutation(baseOptions?: Apollo.MutationHookOptions<ApproveScheduleCancellationMutation, ApproveScheduleCancellationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveScheduleCancellationMutation, ApproveScheduleCancellationMutationVariables>(ApproveScheduleCancellationDocument, options);
      }
export type ApproveScheduleCancellationMutationHookResult = ReturnType<typeof useApproveScheduleCancellationMutation>;
export type ApproveScheduleCancellationMutationResult = Apollo.MutationResult<ApproveScheduleCancellationMutation>;
export type ApproveScheduleCancellationMutationOptions = Apollo.BaseMutationOptions<ApproveScheduleCancellationMutation, ApproveScheduleCancellationMutationVariables>;
export const RefuseScheduleCancellationApprovalDocument = gql`
    mutation refuseScheduleCancellationApproval($data: RefuseScheduleCancellationApprovalInput!, $token: String!) {
  refuseScheduleCancellationApproval(data: $data, token: $token)
}
    `;
export type RefuseScheduleCancellationApprovalMutationFn = Apollo.MutationFunction<RefuseScheduleCancellationApprovalMutation, RefuseScheduleCancellationApprovalMutationVariables>;

/**
 * __useRefuseScheduleCancellationApprovalMutation__
 *
 * To run a mutation, you first call `useRefuseScheduleCancellationApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefuseScheduleCancellationApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refuseScheduleCancellationApprovalMutation, { data, loading, error }] = useRefuseScheduleCancellationApprovalMutation({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRefuseScheduleCancellationApprovalMutation(baseOptions?: Apollo.MutationHookOptions<RefuseScheduleCancellationApprovalMutation, RefuseScheduleCancellationApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefuseScheduleCancellationApprovalMutation, RefuseScheduleCancellationApprovalMutationVariables>(RefuseScheduleCancellationApprovalDocument, options);
      }
export type RefuseScheduleCancellationApprovalMutationHookResult = ReturnType<typeof useRefuseScheduleCancellationApprovalMutation>;
export type RefuseScheduleCancellationApprovalMutationResult = Apollo.MutationResult<RefuseScheduleCancellationApprovalMutation>;
export type RefuseScheduleCancellationApprovalMutationOptions = Apollo.BaseMutationOptions<RefuseScheduleCancellationApprovalMutation, RefuseScheduleCancellationApprovalMutationVariables>;
export const RegisterBankDocument = gql`
    mutation registerBank($data: RegisterBankInput!, $token: String!) {
  registerBank(data: $data, token: $token) {
    success
  }
}
    `;
export type RegisterBankMutationFn = Apollo.MutationFunction<RegisterBankMutation, RegisterBankMutationVariables>;

/**
 * __useRegisterBankMutation__
 *
 * To run a mutation, you first call `useRegisterBankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterBankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerBankMutation, { data, loading, error }] = useRegisterBankMutation({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRegisterBankMutation(baseOptions?: Apollo.MutationHookOptions<RegisterBankMutation, RegisterBankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterBankMutation, RegisterBankMutationVariables>(RegisterBankDocument, options);
      }
export type RegisterBankMutationHookResult = ReturnType<typeof useRegisterBankMutation>;
export type RegisterBankMutationResult = Apollo.MutationResult<RegisterBankMutation>;
export type RegisterBankMutationOptions = Apollo.BaseMutationOptions<RegisterBankMutation, RegisterBankMutationVariables>;
export const RequestBankTransferDocument = gql`
    mutation requestBankTransfer($token: String!) {
  requestBankTransfer(token: $token) {
    success
  }
}
    `;
export type RequestBankTransferMutationFn = Apollo.MutationFunction<RequestBankTransferMutation, RequestBankTransferMutationVariables>;

/**
 * __useRequestBankTransferMutation__
 *
 * To run a mutation, you first call `useRequestBankTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestBankTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestBankTransferMutation, { data, loading, error }] = useRequestBankTransferMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRequestBankTransferMutation(baseOptions?: Apollo.MutationHookOptions<RequestBankTransferMutation, RequestBankTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestBankTransferMutation, RequestBankTransferMutationVariables>(RequestBankTransferDocument, options);
      }
export type RequestBankTransferMutationHookResult = ReturnType<typeof useRequestBankTransferMutation>;
export type RequestBankTransferMutationResult = Apollo.MutationResult<RequestBankTransferMutation>;
export type RequestBankTransferMutationOptions = Apollo.BaseMutationOptions<RequestBankTransferMutation, RequestBankTransferMutationVariables>;
export const DeleteWorkerLicenseCertificateDocument = gql`
    mutation deleteWorkerLicenseCertificate($data: DeleteWorkerLicenseCertificateInput!, $token: String!) {
  deleteWorkerLicenseCertificate(data: $data, token: $token)
}
    `;
export type DeleteWorkerLicenseCertificateMutationFn = Apollo.MutationFunction<DeleteWorkerLicenseCertificateMutation, DeleteWorkerLicenseCertificateMutationVariables>;

/**
 * __useDeleteWorkerLicenseCertificateMutation__
 *
 * To run a mutation, you first call `useDeleteWorkerLicenseCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkerLicenseCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkerLicenseCertificateMutation, { data, loading, error }] = useDeleteWorkerLicenseCertificateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useDeleteWorkerLicenseCertificateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkerLicenseCertificateMutation, DeleteWorkerLicenseCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkerLicenseCertificateMutation, DeleteWorkerLicenseCertificateMutationVariables>(DeleteWorkerLicenseCertificateDocument, options);
      }
export type DeleteWorkerLicenseCertificateMutationHookResult = ReturnType<typeof useDeleteWorkerLicenseCertificateMutation>;
export type DeleteWorkerLicenseCertificateMutationResult = Apollo.MutationResult<DeleteWorkerLicenseCertificateMutation>;
export type DeleteWorkerLicenseCertificateMutationOptions = Apollo.BaseMutationOptions<DeleteWorkerLicenseCertificateMutation, DeleteWorkerLicenseCertificateMutationVariables>;
export const RegisterIdentityAndContactDocument = gql`
    mutation registerIdentityAndContact($data: RegisterIdentityAndContactInput!, $token: String!) {
  registerIdentityAndContact(data: $data, token: $token)
}
    `;
export type RegisterIdentityAndContactMutationFn = Apollo.MutationFunction<RegisterIdentityAndContactMutation, RegisterIdentityAndContactMutationVariables>;

/**
 * __useRegisterIdentityAndContactMutation__
 *
 * To run a mutation, you first call `useRegisterIdentityAndContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterIdentityAndContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerIdentityAndContactMutation, { data, loading, error }] = useRegisterIdentityAndContactMutation({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRegisterIdentityAndContactMutation(baseOptions?: Apollo.MutationHookOptions<RegisterIdentityAndContactMutation, RegisterIdentityAndContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterIdentityAndContactMutation, RegisterIdentityAndContactMutationVariables>(RegisterIdentityAndContactDocument, options);
      }
export type RegisterIdentityAndContactMutationHookResult = ReturnType<typeof useRegisterIdentityAndContactMutation>;
export type RegisterIdentityAndContactMutationResult = Apollo.MutationResult<RegisterIdentityAndContactMutation>;
export type RegisterIdentityAndContactMutationOptions = Apollo.BaseMutationOptions<RegisterIdentityAndContactMutation, RegisterIdentityAndContactMutationVariables>;
export const RegisterWorkerLicenseCertificateDocument = gql`
    mutation registerWorkerLicenseCertificate($data: RegisterWorkerLicenseCertificateInput!, $token: String!) {
  registerWorkerLicenseCertificate(data: $data, token: $token) {
    uploadId
  }
}
    `;
export type RegisterWorkerLicenseCertificateMutationFn = Apollo.MutationFunction<RegisterWorkerLicenseCertificateMutation, RegisterWorkerLicenseCertificateMutationVariables>;

/**
 * __useRegisterWorkerLicenseCertificateMutation__
 *
 * To run a mutation, you first call `useRegisterWorkerLicenseCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterWorkerLicenseCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerWorkerLicenseCertificateMutation, { data, loading, error }] = useRegisterWorkerLicenseCertificateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRegisterWorkerLicenseCertificateMutation(baseOptions?: Apollo.MutationHookOptions<RegisterWorkerLicenseCertificateMutation, RegisterWorkerLicenseCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterWorkerLicenseCertificateMutation, RegisterWorkerLicenseCertificateMutationVariables>(RegisterWorkerLicenseCertificateDocument, options);
      }
export type RegisterWorkerLicenseCertificateMutationHookResult = ReturnType<typeof useRegisterWorkerLicenseCertificateMutation>;
export type RegisterWorkerLicenseCertificateMutationResult = Apollo.MutationResult<RegisterWorkerLicenseCertificateMutation>;
export type RegisterWorkerLicenseCertificateMutationOptions = Apollo.BaseMutationOptions<RegisterWorkerLicenseCertificateMutation, RegisterWorkerLicenseCertificateMutationVariables>;
export const UpdateEmailNotificationSettingDocument = gql`
    mutation updateEmailNotificationSetting($data: EmailNotificationSettingInput!, $token: String!) {
  updateEmailNotificationSetting(data: $data, token: $token)
}
    `;
export type UpdateEmailNotificationSettingMutationFn = Apollo.MutationFunction<UpdateEmailNotificationSettingMutation, UpdateEmailNotificationSettingMutationVariables>;

/**
 * __useUpdateEmailNotificationSettingMutation__
 *
 * To run a mutation, you first call `useUpdateEmailNotificationSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailNotificationSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailNotificationSettingMutation, { data, loading, error }] = useUpdateEmailNotificationSettingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUpdateEmailNotificationSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailNotificationSettingMutation, UpdateEmailNotificationSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailNotificationSettingMutation, UpdateEmailNotificationSettingMutationVariables>(UpdateEmailNotificationSettingDocument, options);
      }
export type UpdateEmailNotificationSettingMutationHookResult = ReturnType<typeof useUpdateEmailNotificationSettingMutation>;
export type UpdateEmailNotificationSettingMutationResult = Apollo.MutationResult<UpdateEmailNotificationSettingMutation>;
export type UpdateEmailNotificationSettingMutationOptions = Apollo.BaseMutationOptions<UpdateEmailNotificationSettingMutation, UpdateEmailNotificationSettingMutationVariables>;
export const UpdateWorkerLicenseCertificateDocument = gql`
    mutation updateWorkerLicenseCertificate($data: UpdateWorkerLicenseCertificateInput!, $token: String!) {
  updateWorkerLicenseCertificate(data: $data, token: $token)
}
    `;
export type UpdateWorkerLicenseCertificateMutationFn = Apollo.MutationFunction<UpdateWorkerLicenseCertificateMutation, UpdateWorkerLicenseCertificateMutationVariables>;

/**
 * __useUpdateWorkerLicenseCertificateMutation__
 *
 * To run a mutation, you first call `useUpdateWorkerLicenseCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkerLicenseCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkerLicenseCertificateMutation, { data, loading, error }] = useUpdateWorkerLicenseCertificateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUpdateWorkerLicenseCertificateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkerLicenseCertificateMutation, UpdateWorkerLicenseCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkerLicenseCertificateMutation, UpdateWorkerLicenseCertificateMutationVariables>(UpdateWorkerLicenseCertificateDocument, options);
      }
export type UpdateWorkerLicenseCertificateMutationHookResult = ReturnType<typeof useUpdateWorkerLicenseCertificateMutation>;
export type UpdateWorkerLicenseCertificateMutationResult = Apollo.MutationResult<UpdateWorkerLicenseCertificateMutation>;
export type UpdateWorkerLicenseCertificateMutationOptions = Apollo.BaseMutationOptions<UpdateWorkerLicenseCertificateMutation, UpdateWorkerLicenseCertificateMutationVariables>;
export const UpdateWorkerMainImageDocument = gql`
    mutation updateWorkerMainImage($data: UpdateWorkerMainImageInput!, $token: String!) {
  updateWorkerMainImage(data: $data, token: $token) {
    success
    updatedImage
  }
}
    `;
export type UpdateWorkerMainImageMutationFn = Apollo.MutationFunction<UpdateWorkerMainImageMutation, UpdateWorkerMainImageMutationVariables>;

/**
 * __useUpdateWorkerMainImageMutation__
 *
 * To run a mutation, you first call `useUpdateWorkerMainImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkerMainImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkerMainImageMutation, { data, loading, error }] = useUpdateWorkerMainImageMutation({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUpdateWorkerMainImageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkerMainImageMutation, UpdateWorkerMainImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkerMainImageMutation, UpdateWorkerMainImageMutationVariables>(UpdateWorkerMainImageDocument, options);
      }
export type UpdateWorkerMainImageMutationHookResult = ReturnType<typeof useUpdateWorkerMainImageMutation>;
export type UpdateWorkerMainImageMutationResult = Apollo.MutationResult<UpdateWorkerMainImageMutation>;
export type UpdateWorkerMainImageMutationOptions = Apollo.BaseMutationOptions<UpdateWorkerMainImageMutation, UpdateWorkerMainImageMutationVariables>;
export const UpdateWorkerProfileDocument = gql`
    mutation updateWorkerProfile($data: UpdateWorkerProfileInput!, $token: String!) {
  updateWorkerProfile(data: $data, token: $token) {
    success
  }
}
    `;
export type UpdateWorkerProfileMutationFn = Apollo.MutationFunction<UpdateWorkerProfileMutation, UpdateWorkerProfileMutationVariables>;

/**
 * __useUpdateWorkerProfileMutation__
 *
 * To run a mutation, you first call `useUpdateWorkerProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkerProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkerProfileMutation, { data, loading, error }] = useUpdateWorkerProfileMutation({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUpdateWorkerProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkerProfileMutation, UpdateWorkerProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkerProfileMutation, UpdateWorkerProfileMutationVariables>(UpdateWorkerProfileDocument, options);
      }
export type UpdateWorkerProfileMutationHookResult = ReturnType<typeof useUpdateWorkerProfileMutation>;
export type UpdateWorkerProfileMutationResult = Apollo.MutationResult<UpdateWorkerProfileMutation>;
export type UpdateWorkerProfileMutationOptions = Apollo.BaseMutationOptions<UpdateWorkerProfileMutation, UpdateWorkerProfileMutationVariables>;
export const AddressSearchDocument = gql`
    query addressSearch($data: AddressSearchInput!) {
  addressSearch(data: $data) {
    areaL {
      id
      name
    }
    address
  }
}
    `;

/**
 * __useAddressSearchQuery__
 *
 * To run a query within a React component, call `useAddressSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressSearchQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddressSearchQuery(baseOptions: Apollo.QueryHookOptions<AddressSearchQuery, AddressSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddressSearchQuery, AddressSearchQueryVariables>(AddressSearchDocument, options);
      }
export function useAddressSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressSearchQuery, AddressSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddressSearchQuery, AddressSearchQueryVariables>(AddressSearchDocument, options);
        }
export type AddressSearchQueryHookResult = ReturnType<typeof useAddressSearchQuery>;
export type AddressSearchLazyQueryHookResult = ReturnType<typeof useAddressSearchLazyQuery>;
export type AddressSearchQueryResult = Apollo.QueryResult<AddressSearchQuery, AddressSearchQueryVariables>;
export const AbsentNotificationsDocument = gql`
    query absentNotifications($data: AbsentNotificationsInput!, $token: String!) {
  absentNotifications(data: $data, token: $token) {
    absentNotifications {
      id
      name
    }
  }
}
    `;

/**
 * __useAbsentNotificationsQuery__
 *
 * To run a query within a React component, call `useAbsentNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbsentNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAbsentNotificationsQuery({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAbsentNotificationsQuery(baseOptions: Apollo.QueryHookOptions<AbsentNotificationsQuery, AbsentNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AbsentNotificationsQuery, AbsentNotificationsQueryVariables>(AbsentNotificationsDocument, options);
      }
export function useAbsentNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AbsentNotificationsQuery, AbsentNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AbsentNotificationsQuery, AbsentNotificationsQueryVariables>(AbsentNotificationsDocument, options);
        }
export type AbsentNotificationsQueryHookResult = ReturnType<typeof useAbsentNotificationsQuery>;
export type AbsentNotificationsLazyQueryHookResult = ReturnType<typeof useAbsentNotificationsLazyQuery>;
export type AbsentNotificationsQueryResult = Apollo.QueryResult<AbsentNotificationsQuery, AbsentNotificationsQueryVariables>;
export const AttendanceHistoriesDocument = gql`
    query attendanceHistories($data: AttendanceHistoriesInput!, $token: String!) {
  attendanceHistories(data: $data, token: $token) {
    attendances {
      id
      stateLabel
      tapToTransition
      label {
        type
        text
      }
      workday {
        wage
        salary
        startsAt
        endsAt
      }
      job {
        title
        facilityName
        representativeImage
      }
    }
    paging {
      nextCursor
    }
  }
}
    `;

/**
 * __useAttendanceHistoriesQuery__
 *
 * To run a query within a React component, call `useAttendanceHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceHistoriesQuery({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAttendanceHistoriesQuery(baseOptions: Apollo.QueryHookOptions<AttendanceHistoriesQuery, AttendanceHistoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttendanceHistoriesQuery, AttendanceHistoriesQueryVariables>(AttendanceHistoriesDocument, options);
      }
export function useAttendanceHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttendanceHistoriesQuery, AttendanceHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttendanceHistoriesQuery, AttendanceHistoriesQueryVariables>(AttendanceHistoriesDocument, options);
        }
export type AttendanceHistoriesQueryHookResult = ReturnType<typeof useAttendanceHistoriesQuery>;
export type AttendanceHistoriesLazyQueryHookResult = ReturnType<typeof useAttendanceHistoriesLazyQuery>;
export type AttendanceHistoriesQueryResult = Apollo.QueryResult<AttendanceHistoriesQuery, AttendanceHistoriesQueryVariables>;
export const AttendanceScheduleListDocument = gql`
    query attendanceScheduleList($data: AttendanceScheduleListInput!, $token: String!) {
  attendanceScheduleList(data: $data, token: $token) {
    sections {
      type
      title
      description
      attendances {
        id
        buttons {
          name
          type
        }
        workday {
          wage
          salary
          startsAt
          endsAt
        }
        job {
          title
          representativeImage
        }
        facility {
          id
          name
          phoneNumber
        }
        label {
          resultOfApprovalRequest
          timeToActivateWorkStartButton
        }
        bonus
        recruitmentNoticeView {
          title
          description
          backgroundColor
        }
        tapToTransition
      }
    }
    paging {
      nextCursor
    }
  }
}
    `;

/**
 * __useAttendanceScheduleListQuery__
 *
 * To run a query within a React component, call `useAttendanceScheduleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceScheduleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceScheduleListQuery({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAttendanceScheduleListQuery(baseOptions: Apollo.QueryHookOptions<AttendanceScheduleListQuery, AttendanceScheduleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttendanceScheduleListQuery, AttendanceScheduleListQueryVariables>(AttendanceScheduleListDocument, options);
      }
export function useAttendanceScheduleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttendanceScheduleListQuery, AttendanceScheduleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttendanceScheduleListQuery, AttendanceScheduleListQueryVariables>(AttendanceScheduleListDocument, options);
        }
export type AttendanceScheduleListQueryHookResult = ReturnType<typeof useAttendanceScheduleListQuery>;
export type AttendanceScheduleListLazyQueryHookResult = ReturnType<typeof useAttendanceScheduleListLazyQuery>;
export type AttendanceScheduleListQueryResult = Apollo.QueryResult<AttendanceScheduleListQuery, AttendanceScheduleListQueryVariables>;
export const AttendanceSummaryDocument = gql`
    query attendanceSummary($data: AttendanceSummaryInput!) {
  attendanceSummary(data: $data) {
    attendanceId
    title
    facilityName
    workday {
      startsAt
      endsAt
      salary
    }
  }
}
    `;

/**
 * __useAttendanceSummaryQuery__
 *
 * To run a query within a React component, call `useAttendanceSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceSummaryQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAttendanceSummaryQuery(baseOptions: Apollo.QueryHookOptions<AttendanceSummaryQuery, AttendanceSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttendanceSummaryQuery, AttendanceSummaryQueryVariables>(AttendanceSummaryDocument, options);
      }
export function useAttendanceSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttendanceSummaryQuery, AttendanceSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttendanceSummaryQuery, AttendanceSummaryQueryVariables>(AttendanceSummaryDocument, options);
        }
export type AttendanceSummaryQueryHookResult = ReturnType<typeof useAttendanceSummaryQuery>;
export type AttendanceSummaryLazyQueryHookResult = ReturnType<typeof useAttendanceSummaryLazyQuery>;
export type AttendanceSummaryQueryResult = Apollo.QueryResult<AttendanceSummaryQuery, AttendanceSummaryQueryVariables>;
export const AttendanceQuestionnaireDocument = gql`
    query attendanceQuestionnaire($data: AttendanceQuestionnaireInput!) {
  attendanceQuestionnaire(data: $data) {
    questionnaireItemList {
      id
      name
    }
  }
}
    `;

/**
 * __useAttendanceQuestionnaireQuery__
 *
 * To run a query within a React component, call `useAttendanceQuestionnaireQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceQuestionnaireQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceQuestionnaireQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAttendanceQuestionnaireQuery(baseOptions: Apollo.QueryHookOptions<AttendanceQuestionnaireQuery, AttendanceQuestionnaireQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttendanceQuestionnaireQuery, AttendanceQuestionnaireQueryVariables>(AttendanceQuestionnaireDocument, options);
      }
export function useAttendanceQuestionnaireLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttendanceQuestionnaireQuery, AttendanceQuestionnaireQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttendanceQuestionnaireQuery, AttendanceQuestionnaireQueryVariables>(AttendanceQuestionnaireDocument, options);
        }
export type AttendanceQuestionnaireQueryHookResult = ReturnType<typeof useAttendanceQuestionnaireQuery>;
export type AttendanceQuestionnaireLazyQueryHookResult = ReturnType<typeof useAttendanceQuestionnaireLazyQuery>;
export type AttendanceQuestionnaireQueryResult = Apollo.QueryResult<AttendanceQuestionnaireQuery, AttendanceQuestionnaireQueryVariables>;
export const CancelWarningsDocument = gql`
    query cancelWarnings($data: CancelWarningsInput!, $token: String!) {
  cancelWarnings(data: $data, token: $token) {
    importantMatters
    precautions
    penalties {
      subject
      current {
        prefix
        amount
      }
      afterCancellation {
        prefix
        amount
      }
    }
    reasons {
      id
      name
    }
    needsPhoneCall
  }
}
    `;

/**
 * __useCancelWarningsQuery__
 *
 * To run a query within a React component, call `useCancelWarningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCancelWarningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCancelWarningsQuery({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCancelWarningsQuery(baseOptions: Apollo.QueryHookOptions<CancelWarningsQuery, CancelWarningsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CancelWarningsQuery, CancelWarningsQueryVariables>(CancelWarningsDocument, options);
      }
export function useCancelWarningsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CancelWarningsQuery, CancelWarningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CancelWarningsQuery, CancelWarningsQueryVariables>(CancelWarningsDocument, options);
        }
export type CancelWarningsQueryHookResult = ReturnType<typeof useCancelWarningsQuery>;
export type CancelWarningsLazyQueryHookResult = ReturnType<typeof useCancelWarningsLazyQuery>;
export type CancelWarningsQueryResult = Apollo.QueryResult<CancelWarningsQuery, CancelWarningsQueryVariables>;
export const WageWithAdjustmentDocument = gql`
    query wageWithAdjustment($data: WageWithAdjustmentInput!) {
  wageWithAdjustment(data: $data) {
    applicationId
    conditionLabel
    employmentConditionSummary {
      dateOfWork
      jobTitle
      facilityName
      wage
      breakTime {
        dayTime
        nightTime
      }
    }
    attendanceAdjustment {
      startTime {
        label
        colored
      }
      endTime {
        label
        colored
      }
      breakTime {
        label
        dayTimeAdjustable
        nightTimeAdjustable
      }
    }
    wageBreakdown {
      hourlyWageLabel
      expectedSalaryLabel
      salaryDifference {
        label
        colored
      }
      withholdingTax {
        label
        colored
      }
      trafficAllowanceLabel
    }
    wageLabel
    verifyButtonDisabled
  }
}
    `;

/**
 * __useWageWithAdjustmentQuery__
 *
 * To run a query within a React component, call `useWageWithAdjustmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useWageWithAdjustmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWageWithAdjustmentQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useWageWithAdjustmentQuery(baseOptions: Apollo.QueryHookOptions<WageWithAdjustmentQuery, WageWithAdjustmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WageWithAdjustmentQuery, WageWithAdjustmentQueryVariables>(WageWithAdjustmentDocument, options);
      }
export function useWageWithAdjustmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WageWithAdjustmentQuery, WageWithAdjustmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WageWithAdjustmentQuery, WageWithAdjustmentQueryVariables>(WageWithAdjustmentDocument, options);
        }
export type WageWithAdjustmentQueryHookResult = ReturnType<typeof useWageWithAdjustmentQuery>;
export type WageWithAdjustmentLazyQueryHookResult = ReturnType<typeof useWageWithAdjustmentLazyQuery>;
export type WageWithAdjustmentQueryResult = Apollo.QueryResult<WageWithAdjustmentQuery, WageWithAdjustmentQueryVariables>;
export const WageWithoutAdjustmentDocument = gql`
    query wageWithoutAdjustment($data: WageWithoutAdjustmentInput!) {
  wageWithoutAdjustment(data: $data) {
    applicationId
    conditionLabel
    employmentConditionSummary {
      dateOfWork
      jobTitle
      facilityName
      wage
    }
    attendance {
      startTimeLabel
      endTimeLabel
      breakTimeLabel
    }
    wageBreakdown {
      hourlyWageLabel
      expectedSalaryLabel
      salaryDifference {
        label
        colored
      }
      withholdingTax {
        label
        colored
      }
      trafficAllowanceLabel
    }
    wageLabel
  }
}
    `;

/**
 * __useWageWithoutAdjustmentQuery__
 *
 * To run a query within a React component, call `useWageWithoutAdjustmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useWageWithoutAdjustmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWageWithoutAdjustmentQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useWageWithoutAdjustmentQuery(baseOptions: Apollo.QueryHookOptions<WageWithoutAdjustmentQuery, WageWithoutAdjustmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WageWithoutAdjustmentQuery, WageWithoutAdjustmentQueryVariables>(WageWithoutAdjustmentDocument, options);
      }
export function useWageWithoutAdjustmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WageWithoutAdjustmentQuery, WageWithoutAdjustmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WageWithoutAdjustmentQuery, WageWithoutAdjustmentQueryVariables>(WageWithoutAdjustmentDocument, options);
        }
export type WageWithoutAdjustmentQueryHookResult = ReturnType<typeof useWageWithoutAdjustmentQuery>;
export type WageWithoutAdjustmentLazyQueryHookResult = ReturnType<typeof useWageWithoutAdjustmentLazyQuery>;
export type WageWithoutAdjustmentQueryResult = Apollo.QueryResult<WageWithoutAdjustmentQuery, WageWithoutAdjustmentQueryVariables>;
export const WorkTimeDocument = gql`
    query workTime($id: ID!, $token: String!) {
  workTime(id: $id, token: $token) {
    attendanceId
    title
    workPlace
    workday {
      endsAt
      startsAt
      wage
      salary
    }
    checkinTimeLabel
    checkoutTimeLabel
  }
}
    `;

/**
 * __useWorkTimeQuery__
 *
 * To run a query within a React component, call `useWorkTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkTimeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useWorkTimeQuery(baseOptions: Apollo.QueryHookOptions<WorkTimeQuery, WorkTimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkTimeQuery, WorkTimeQueryVariables>(WorkTimeDocument, options);
      }
export function useWorkTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkTimeQuery, WorkTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkTimeQuery, WorkTimeQueryVariables>(WorkTimeDocument, options);
        }
export type WorkTimeQueryHookResult = ReturnType<typeof useWorkTimeQuery>;
export type WorkTimeLazyQueryHookResult = ReturnType<typeof useWorkTimeLazyQuery>;
export type WorkTimeQueryResult = Apollo.QueryResult<WorkTimeQuery, WorkTimeQueryVariables>;
export const PredefinedDeletionReasonDocument = gql`
    query predefinedDeletionReason {
  predefinedDeletionReason {
    reasons {
      id
      label
    }
  }
}
    `;

/**
 * __usePredefinedDeletionReasonQuery__
 *
 * To run a query within a React component, call `usePredefinedDeletionReasonQuery` and pass it any options that fit your needs.
 * When your component renders, `usePredefinedDeletionReasonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePredefinedDeletionReasonQuery({
 *   variables: {
 *   },
 * });
 */
export function usePredefinedDeletionReasonQuery(baseOptions?: Apollo.QueryHookOptions<PredefinedDeletionReasonQuery, PredefinedDeletionReasonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PredefinedDeletionReasonQuery, PredefinedDeletionReasonQueryVariables>(PredefinedDeletionReasonDocument, options);
      }
export function usePredefinedDeletionReasonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PredefinedDeletionReasonQuery, PredefinedDeletionReasonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PredefinedDeletionReasonQuery, PredefinedDeletionReasonQueryVariables>(PredefinedDeletionReasonDocument, options);
        }
export type PredefinedDeletionReasonQueryHookResult = ReturnType<typeof usePredefinedDeletionReasonQuery>;
export type PredefinedDeletionReasonLazyQueryHookResult = ReturnType<typeof usePredefinedDeletionReasonLazyQuery>;
export type PredefinedDeletionReasonQueryResult = Apollo.QueryResult<PredefinedDeletionReasonQuery, PredefinedDeletionReasonQueryVariables>;
export const WorkerDeletableJudgementDocument = gql`
    query workerDeletableJudgement {
  workerDeletableJudgement {
    isDeletable
    undeletableReasons
  }
}
    `;

/**
 * __useWorkerDeletableJudgementQuery__
 *
 * To run a query within a React component, call `useWorkerDeletableJudgementQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkerDeletableJudgementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkerDeletableJudgementQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkerDeletableJudgementQuery(baseOptions?: Apollo.QueryHookOptions<WorkerDeletableJudgementQuery, WorkerDeletableJudgementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkerDeletableJudgementQuery, WorkerDeletableJudgementQueryVariables>(WorkerDeletableJudgementDocument, options);
      }
export function useWorkerDeletableJudgementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkerDeletableJudgementQuery, WorkerDeletableJudgementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkerDeletableJudgementQuery, WorkerDeletableJudgementQueryVariables>(WorkerDeletableJudgementDocument, options);
        }
export type WorkerDeletableJudgementQueryHookResult = ReturnType<typeof useWorkerDeletableJudgementQuery>;
export type WorkerDeletableJudgementLazyQueryHookResult = ReturnType<typeof useWorkerDeletableJudgementLazyQuery>;
export type WorkerDeletableJudgementQueryResult = Apollo.QueryResult<WorkerDeletableJudgementQuery, WorkerDeletableJudgementQueryVariables>;
export const WorkerAvailableDateListDocument = gql`
    query workerAvailableDateList($id: ID!, $token: String!) {
  workerAvailableDateList(id: $id, token: $token) {
    availableDates {
      date
    }
  }
}
    `;

/**
 * __useWorkerAvailableDateListQuery__
 *
 * To run a query within a React component, call `useWorkerAvailableDateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkerAvailableDateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkerAvailableDateListQuery({
 *   variables: {
 *      id: // value for 'id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useWorkerAvailableDateListQuery(baseOptions: Apollo.QueryHookOptions<WorkerAvailableDateListQuery, WorkerAvailableDateListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkerAvailableDateListQuery, WorkerAvailableDateListQueryVariables>(WorkerAvailableDateListDocument, options);
      }
export function useWorkerAvailableDateListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkerAvailableDateListQuery, WorkerAvailableDateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkerAvailableDateListQuery, WorkerAvailableDateListQueryVariables>(WorkerAvailableDateListDocument, options);
        }
export type WorkerAvailableDateListQueryHookResult = ReturnType<typeof useWorkerAvailableDateListQuery>;
export type WorkerAvailableDateListLazyQueryHookResult = ReturnType<typeof useWorkerAvailableDateListLazyQuery>;
export type WorkerAvailableDateListQueryResult = Apollo.QueryResult<WorkerAvailableDateListQuery, WorkerAvailableDateListQueryVariables>;
export const CurrentUserDocument = gql`
    query currentUser($token: String!) {
  currentUser(token: $token) {
    id
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const EmergencyContactDocument = gql`
    query emergencyContact($token: String!) {
  emergencyContact(token: $token) {
    phoneNumber
    relationShipId
  }
}
    `;

/**
 * __useEmergencyContactQuery__
 *
 * To run a query within a React component, call `useEmergencyContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmergencyContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmergencyContactQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useEmergencyContactQuery(baseOptions: Apollo.QueryHookOptions<EmergencyContactQuery, EmergencyContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmergencyContactQuery, EmergencyContactQueryVariables>(EmergencyContactDocument, options);
      }
export function useEmergencyContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmergencyContactQuery, EmergencyContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmergencyContactQuery, EmergencyContactQueryVariables>(EmergencyContactDocument, options);
        }
export type EmergencyContactQueryHookResult = ReturnType<typeof useEmergencyContactQuery>;
export type EmergencyContactLazyQueryHookResult = ReturnType<typeof useEmergencyContactLazyQuery>;
export type EmergencyContactQueryResult = Apollo.QueryResult<EmergencyContactQuery, EmergencyContactQueryVariables>;
export const RelationShipListDocument = gql`
    query relationShipList {
  relationShipList {
    relationShips {
      id
      label
    }
  }
}
    `;

/**
 * __useRelationShipListQuery__
 *
 * To run a query within a React component, call `useRelationShipListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelationShipListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelationShipListQuery({
 *   variables: {
 *   },
 * });
 */
export function useRelationShipListQuery(baseOptions?: Apollo.QueryHookOptions<RelationShipListQuery, RelationShipListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelationShipListQuery, RelationShipListQueryVariables>(RelationShipListDocument, options);
      }
export function useRelationShipListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelationShipListQuery, RelationShipListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelationShipListQuery, RelationShipListQueryVariables>(RelationShipListDocument, options);
        }
export type RelationShipListQueryHookResult = ReturnType<typeof useRelationShipListQuery>;
export type RelationShipListLazyQueryHookResult = ReturnType<typeof useRelationShipListLazyQuery>;
export type RelationShipListQueryResult = Apollo.QueryResult<RelationShipListQuery, RelationShipListQueryVariables>;
export const EmploymentConditionDocument = gql`
    query employmentCondition($id: ID!) {
  employmentCondition(id: $id) {
    id
    review {
      rate
      description
      ratings {
        name
        rate
      }
    }
    actions {
      name
      type
    }
    tags {
      name
      color {
        background
        font
        border
      }
    }
    recruitmentId
    isFavoriteRecruitment
    jobId
    images
    title
    description
    tasks
    requirementLicenses
    requirementNote
    startsAt
    endsAt
    breakTimeLabel
    salary
    wageAndAllowanceLabel
    workflow
    belonging
    note
    appealPoints
    employer {
      id
      name
      service
      phoneNumber
      address
      station
      ambience {
        averageNursingCareLevel
      }
    }
    agreedDocuments {
      name
      url
    }
    bonus
    tagline
    stateLabel
  }
}
    `;

/**
 * __useEmploymentConditionQuery__
 *
 * To run a query within a React component, call `useEmploymentConditionQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmploymentConditionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmploymentConditionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmploymentConditionQuery(baseOptions: Apollo.QueryHookOptions<EmploymentConditionQuery, EmploymentConditionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmploymentConditionQuery, EmploymentConditionQueryVariables>(EmploymentConditionDocument, options);
      }
export function useEmploymentConditionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmploymentConditionQuery, EmploymentConditionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmploymentConditionQuery, EmploymentConditionQueryVariables>(EmploymentConditionDocument, options);
        }
export type EmploymentConditionQueryHookResult = ReturnType<typeof useEmploymentConditionQuery>;
export type EmploymentConditionLazyQueryHookResult = ReturnType<typeof useEmploymentConditionLazyQuery>;
export type EmploymentConditionQueryResult = Apollo.QueryResult<EmploymentConditionQuery, EmploymentConditionQueryVariables>;
export const WorkerIdentificationDocument = gql`
    query workerIdentification($id: ID!, $token: String) {
  workerIdentification(id: $id, token: $token) {
    current {
      state
      document {
        type
        name
      }
      messages
    }
  }
}
    `;

/**
 * __useWorkerIdentificationQuery__
 *
 * To run a query within a React component, call `useWorkerIdentificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkerIdentificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkerIdentificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useWorkerIdentificationQuery(baseOptions: Apollo.QueryHookOptions<WorkerIdentificationQuery, WorkerIdentificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkerIdentificationQuery, WorkerIdentificationQueryVariables>(WorkerIdentificationDocument, options);
      }
export function useWorkerIdentificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkerIdentificationQuery, WorkerIdentificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkerIdentificationQuery, WorkerIdentificationQueryVariables>(WorkerIdentificationDocument, options);
        }
export type WorkerIdentificationQueryHookResult = ReturnType<typeof useWorkerIdentificationQuery>;
export type WorkerIdentificationLazyQueryHookResult = ReturnType<typeof useWorkerIdentificationLazyQuery>;
export type WorkerIdentificationQueryResult = Apollo.QueryResult<WorkerIdentificationQuery, WorkerIdentificationQueryVariables>;
export const WorkerIdentityDocument = gql`
    query workerIdentity($token: String!) {
  workerIdentity(token: $token) {
    nationality
    hasUnapprovedIdentity
  }
}
    `;

/**
 * __useWorkerIdentityQuery__
 *
 * To run a query within a React component, call `useWorkerIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkerIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkerIdentityQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useWorkerIdentityQuery(baseOptions: Apollo.QueryHookOptions<WorkerIdentityQuery, WorkerIdentityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkerIdentityQuery, WorkerIdentityQueryVariables>(WorkerIdentityDocument, options);
      }
export function useWorkerIdentityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkerIdentityQuery, WorkerIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkerIdentityQuery, WorkerIdentityQueryVariables>(WorkerIdentityDocument, options);
        }
export type WorkerIdentityQueryHookResult = ReturnType<typeof useWorkerIdentityQuery>;
export type WorkerIdentityLazyQueryHookResult = ReturnType<typeof useWorkerIdentityLazyQuery>;
export type WorkerIdentityQueryResult = Apollo.QueryResult<WorkerIdentityQuery, WorkerIdentityQueryVariables>;
export const ExchangeRateOfAmazonGiftCardDocument = gql`
    query exchangeRateOfAmazonGiftCard {
  exchangeRateOfAmazonGiftCard {
    minimumExchangeableAmount
    exchangedAmount
  }
}
    `;

/**
 * __useExchangeRateOfAmazonGiftCardQuery__
 *
 * To run a query within a React component, call `useExchangeRateOfAmazonGiftCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useExchangeRateOfAmazonGiftCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExchangeRateOfAmazonGiftCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useExchangeRateOfAmazonGiftCardQuery(baseOptions?: Apollo.QueryHookOptions<ExchangeRateOfAmazonGiftCardQuery, ExchangeRateOfAmazonGiftCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExchangeRateOfAmazonGiftCardQuery, ExchangeRateOfAmazonGiftCardQueryVariables>(ExchangeRateOfAmazonGiftCardDocument, options);
      }
export function useExchangeRateOfAmazonGiftCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExchangeRateOfAmazonGiftCardQuery, ExchangeRateOfAmazonGiftCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExchangeRateOfAmazonGiftCardQuery, ExchangeRateOfAmazonGiftCardQueryVariables>(ExchangeRateOfAmazonGiftCardDocument, options);
        }
export type ExchangeRateOfAmazonGiftCardQueryHookResult = ReturnType<typeof useExchangeRateOfAmazonGiftCardQuery>;
export type ExchangeRateOfAmazonGiftCardLazyQueryHookResult = ReturnType<typeof useExchangeRateOfAmazonGiftCardLazyQuery>;
export type ExchangeRateOfAmazonGiftCardQueryResult = Apollo.QueryResult<ExchangeRateOfAmazonGiftCardQuery, ExchangeRateOfAmazonGiftCardQueryVariables>;
export const GetIncentivePointBalanceDocument = gql`
    query getIncentivePointBalance($token: String!) {
  getIncentivePointBalance(token: $token) {
    balance
  }
}
    `;

/**
 * __useGetIncentivePointBalanceQuery__
 *
 * To run a query within a React component, call `useGetIncentivePointBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncentivePointBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncentivePointBalanceQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetIncentivePointBalanceQuery(baseOptions: Apollo.QueryHookOptions<GetIncentivePointBalanceQuery, GetIncentivePointBalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIncentivePointBalanceQuery, GetIncentivePointBalanceQueryVariables>(GetIncentivePointBalanceDocument, options);
      }
export function useGetIncentivePointBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIncentivePointBalanceQuery, GetIncentivePointBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIncentivePointBalanceQuery, GetIncentivePointBalanceQueryVariables>(GetIncentivePointBalanceDocument, options);
        }
export type GetIncentivePointBalanceQueryHookResult = ReturnType<typeof useGetIncentivePointBalanceQuery>;
export type GetIncentivePointBalanceLazyQueryHookResult = ReturnType<typeof useGetIncentivePointBalanceLazyQuery>;
export type GetIncentivePointBalanceQueryResult = Apollo.QueryResult<GetIncentivePointBalanceQuery, GetIncentivePointBalanceQueryVariables>;
export const GetIncentivePointHistoriesDocument = gql`
    query getIncentivePointHistories($token: String!, $data: GetIncentivePointHistoriesRequest!) {
  getIncentivePointHistories(token: $token, data: $data) {
    histories {
      id
      amount
      note
      date
    }
    cursor
  }
}
    `;

/**
 * __useGetIncentivePointHistoriesQuery__
 *
 * To run a query within a React component, call `useGetIncentivePointHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncentivePointHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncentivePointHistoriesQuery({
 *   variables: {
 *      token: // value for 'token'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetIncentivePointHistoriesQuery(baseOptions: Apollo.QueryHookOptions<GetIncentivePointHistoriesQuery, GetIncentivePointHistoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIncentivePointHistoriesQuery, GetIncentivePointHistoriesQueryVariables>(GetIncentivePointHistoriesDocument, options);
      }
export function useGetIncentivePointHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIncentivePointHistoriesQuery, GetIncentivePointHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIncentivePointHistoriesQuery, GetIncentivePointHistoriesQueryVariables>(GetIncentivePointHistoriesDocument, options);
        }
export type GetIncentivePointHistoriesQueryHookResult = ReturnType<typeof useGetIncentivePointHistoriesQuery>;
export type GetIncentivePointHistoriesLazyQueryHookResult = ReturnType<typeof useGetIncentivePointHistoriesLazyQuery>;
export type GetIncentivePointHistoriesQueryResult = Apollo.QueryResult<GetIncentivePointHistoriesQuery, GetIncentivePointHistoriesQueryVariables>;
export const IncentiveItemOrderDocument = gql`
    query incentiveItemOrder($data: IncentiveItemOrderRequest!, $token: String!) {
  incentiveItemOrder(data: $data, token: $token) {
    status
  }
}
    `;

/**
 * __useIncentiveItemOrderQuery__
 *
 * To run a query within a React component, call `useIncentiveItemOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncentiveItemOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncentiveItemOrderQuery({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useIncentiveItemOrderQuery(baseOptions: Apollo.QueryHookOptions<IncentiveItemOrderQuery, IncentiveItemOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncentiveItemOrderQuery, IncentiveItemOrderQueryVariables>(IncentiveItemOrderDocument, options);
      }
export function useIncentiveItemOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncentiveItemOrderQuery, IncentiveItemOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncentiveItemOrderQuery, IncentiveItemOrderQueryVariables>(IncentiveItemOrderDocument, options);
        }
export type IncentiveItemOrderQueryHookResult = ReturnType<typeof useIncentiveItemOrderQuery>;
export type IncentiveItemOrderLazyQueryHookResult = ReturnType<typeof useIncentiveItemOrderLazyQuery>;
export type IncentiveItemOrderQueryResult = Apollo.QueryResult<IncentiveItemOrderQuery, IncentiveItemOrderQueryVariables>;
export const SubscriptionCountDocument = gql`
    query subscriptionCount($token: String!) {
  subscriptionCount(token: $token) {
    count
  }
}
    `;

/**
 * __useSubscriptionCountQuery__
 *
 * To run a query within a React component, call `useSubscriptionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionCountQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSubscriptionCountQuery(baseOptions: Apollo.QueryHookOptions<SubscriptionCountQuery, SubscriptionCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionCountQuery, SubscriptionCountQueryVariables>(SubscriptionCountDocument, options);
      }
export function useSubscriptionCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionCountQuery, SubscriptionCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionCountQuery, SubscriptionCountQueryVariables>(SubscriptionCountDocument, options);
        }
export type SubscriptionCountQueryHookResult = ReturnType<typeof useSubscriptionCountQuery>;
export type SubscriptionCountLazyQueryHookResult = ReturnType<typeof useSubscriptionCountLazyQuery>;
export type SubscriptionCountQueryResult = Apollo.QueryResult<SubscriptionCountQuery, SubscriptionCountQueryVariables>;
export const SubscriptionForAvailabilityDocument = gql`
    query subscriptionForAvailability($token: String!) {
  subscriptionForAvailability(token: $token) {
    prefectures {
      id
      name
    }
    stations {
      code
      name
    }
    shifts {
      kind
      displayName
    }
    maximumRangeOfWorkingHours
    minimumRangeOfDailyWage
  }
}
    `;

/**
 * __useSubscriptionForAvailabilityQuery__
 *
 * To run a query within a React component, call `useSubscriptionForAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionForAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionForAvailabilityQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSubscriptionForAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<SubscriptionForAvailabilityQuery, SubscriptionForAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionForAvailabilityQuery, SubscriptionForAvailabilityQueryVariables>(SubscriptionForAvailabilityDocument, options);
      }
export function useSubscriptionForAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionForAvailabilityQuery, SubscriptionForAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionForAvailabilityQuery, SubscriptionForAvailabilityQueryVariables>(SubscriptionForAvailabilityDocument, options);
        }
export type SubscriptionForAvailabilityQueryHookResult = ReturnType<typeof useSubscriptionForAvailabilityQuery>;
export type SubscriptionForAvailabilityLazyQueryHookResult = ReturnType<typeof useSubscriptionForAvailabilityLazyQuery>;
export type SubscriptionForAvailabilityQueryResult = Apollo.QueryResult<SubscriptionForAvailabilityQuery, SubscriptionForAvailabilityQueryVariables>;
export const AreaLListDocument = gql`
    query areaLList {
  areaLList {
    areas {
      id
      name
    }
  }
}
    `;

/**
 * __useAreaLListQuery__
 *
 * To run a query within a React component, call `useAreaLListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAreaLListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAreaLListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAreaLListQuery(baseOptions?: Apollo.QueryHookOptions<AreaLListQuery, AreaLListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AreaLListQuery, AreaLListQueryVariables>(AreaLListDocument, options);
      }
export function useAreaLListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AreaLListQuery, AreaLListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AreaLListQuery, AreaLListQueryVariables>(AreaLListDocument, options);
        }
export type AreaLListQueryHookResult = ReturnType<typeof useAreaLListQuery>;
export type AreaLListLazyQueryHookResult = ReturnType<typeof useAreaLListLazyQuery>;
export type AreaLListQueryResult = Apollo.QueryResult<AreaLListQuery, AreaLListQueryVariables>;
export const AreaTreeDocument = gql`
    query areaTree {
  areaTree {
    regions {
      id
      name
      areaLList {
        id
        name
        areaMList {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useAreaTreeQuery__
 *
 * To run a query within a React component, call `useAreaTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAreaTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAreaTreeQuery({
 *   variables: {
 *   },
 * });
 */
export function useAreaTreeQuery(baseOptions?: Apollo.QueryHookOptions<AreaTreeQuery, AreaTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AreaTreeQuery, AreaTreeQueryVariables>(AreaTreeDocument, options);
      }
export function useAreaTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AreaTreeQuery, AreaTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AreaTreeQuery, AreaTreeQueryVariables>(AreaTreeDocument, options);
        }
export type AreaTreeQueryHookResult = ReturnType<typeof useAreaTreeQuery>;
export type AreaTreeLazyQueryHookResult = ReturnType<typeof useAreaTreeLazyQuery>;
export type AreaTreeQueryResult = Apollo.QueryResult<AreaTreeQuery, AreaTreeQueryVariables>;
export const BankBranchSearchDocument = gql`
    query bankBranchSearch($data: BankBranchSearchInput!) {
  bankBranchSearch(data: $data) {
    branches {
      name
      code
    }
  }
}
    `;

/**
 * __useBankBranchSearchQuery__
 *
 * To run a query within a React component, call `useBankBranchSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankBranchSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankBranchSearchQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBankBranchSearchQuery(baseOptions: Apollo.QueryHookOptions<BankBranchSearchQuery, BankBranchSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankBranchSearchQuery, BankBranchSearchQueryVariables>(BankBranchSearchDocument, options);
      }
export function useBankBranchSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankBranchSearchQuery, BankBranchSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankBranchSearchQuery, BankBranchSearchQueryVariables>(BankBranchSearchDocument, options);
        }
export type BankBranchSearchQueryHookResult = ReturnType<typeof useBankBranchSearchQuery>;
export type BankBranchSearchLazyQueryHookResult = ReturnType<typeof useBankBranchSearchLazyQuery>;
export type BankBranchSearchQueryResult = Apollo.QueryResult<BankBranchSearchQuery, BankBranchSearchQueryVariables>;
export const BankSearchDocument = gql`
    query bankSearch($data: BankSearchInput!) {
  bankSearch(data: $data) {
    banks {
      name
      code
    }
  }
}
    `;

/**
 * __useBankSearchQuery__
 *
 * To run a query within a React component, call `useBankSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankSearchQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBankSearchQuery(baseOptions: Apollo.QueryHookOptions<BankSearchQuery, BankSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankSearchQuery, BankSearchQueryVariables>(BankSearchDocument, options);
      }
export function useBankSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankSearchQuery, BankSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankSearchQuery, BankSearchQueryVariables>(BankSearchDocument, options);
        }
export type BankSearchQueryHookResult = ReturnType<typeof useBankSearchQuery>;
export type BankSearchLazyQueryHookResult = ReturnType<typeof useBankSearchLazyQuery>;
export type BankSearchQueryResult = Apollo.QueryResult<BankSearchQuery, BankSearchQueryVariables>;
export const FacilityFeatureListDocument = gql`
    query facilityFeatureList {
  facilityFeatureList {
    features {
      id
      name
    }
  }
}
    `;

/**
 * __useFacilityFeatureListQuery__
 *
 * To run a query within a React component, call `useFacilityFeatureListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityFeatureListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityFeatureListQuery({
 *   variables: {
 *   },
 * });
 */
export function useFacilityFeatureListQuery(baseOptions?: Apollo.QueryHookOptions<FacilityFeatureListQuery, FacilityFeatureListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FacilityFeatureListQuery, FacilityFeatureListQueryVariables>(FacilityFeatureListDocument, options);
      }
export function useFacilityFeatureListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FacilityFeatureListQuery, FacilityFeatureListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FacilityFeatureListQuery, FacilityFeatureListQueryVariables>(FacilityFeatureListDocument, options);
        }
export type FacilityFeatureListQueryHookResult = ReturnType<typeof useFacilityFeatureListQuery>;
export type FacilityFeatureListLazyQueryHookResult = ReturnType<typeof useFacilityFeatureListLazyQuery>;
export type FacilityFeatureListQueryResult = Apollo.QueryResult<FacilityFeatureListQuery, FacilityFeatureListQueryVariables>;
export const JobArrangementListDocument = gql`
    query jobArrangementList {
  jobArrangementList {
    arrangements {
      id
      name
    }
  }
}
    `;

/**
 * __useJobArrangementListQuery__
 *
 * To run a query within a React component, call `useJobArrangementListQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobArrangementListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobArrangementListQuery({
 *   variables: {
 *   },
 * });
 */
export function useJobArrangementListQuery(baseOptions?: Apollo.QueryHookOptions<JobArrangementListQuery, JobArrangementListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobArrangementListQuery, JobArrangementListQueryVariables>(JobArrangementListDocument, options);
      }
export function useJobArrangementListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobArrangementListQuery, JobArrangementListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobArrangementListQuery, JobArrangementListQueryVariables>(JobArrangementListDocument, options);
        }
export type JobArrangementListQueryHookResult = ReturnType<typeof useJobArrangementListQuery>;
export type JobArrangementListLazyQueryHookResult = ReturnType<typeof useJobArrangementListLazyQuery>;
export type JobArrangementListQueryResult = Apollo.QueryResult<JobArrangementListQuery, JobArrangementListQueryVariables>;
export const JobBenefitListDocument = gql`
    query jobBenefitList {
  jobBenefitList {
    jobBenefits {
      id
      name
    }
  }
}
    `;

/**
 * __useJobBenefitListQuery__
 *
 * To run a query within a React component, call `useJobBenefitListQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobBenefitListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobBenefitListQuery({
 *   variables: {
 *   },
 * });
 */
export function useJobBenefitListQuery(baseOptions?: Apollo.QueryHookOptions<JobBenefitListQuery, JobBenefitListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobBenefitListQuery, JobBenefitListQueryVariables>(JobBenefitListDocument, options);
      }
export function useJobBenefitListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobBenefitListQuery, JobBenefitListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobBenefitListQuery, JobBenefitListQueryVariables>(JobBenefitListDocument, options);
        }
export type JobBenefitListQueryHookResult = ReturnType<typeof useJobBenefitListQuery>;
export type JobBenefitListLazyQueryHookResult = ReturnType<typeof useJobBenefitListLazyQuery>;
export type JobBenefitListQueryResult = Apollo.QueryResult<JobBenefitListQuery, JobBenefitListQueryVariables>;
export const JobTaskListDocument = gql`
    query jobTaskList {
  jobTaskList {
    jobTasks {
      id
      name
    }
  }
}
    `;

/**
 * __useJobTaskListQuery__
 *
 * To run a query within a React component, call `useJobTaskListQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobTaskListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobTaskListQuery({
 *   variables: {
 *   },
 * });
 */
export function useJobTaskListQuery(baseOptions?: Apollo.QueryHookOptions<JobTaskListQuery, JobTaskListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobTaskListQuery, JobTaskListQueryVariables>(JobTaskListDocument, options);
      }
export function useJobTaskListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobTaskListQuery, JobTaskListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobTaskListQuery, JobTaskListQueryVariables>(JobTaskListDocument, options);
        }
export type JobTaskListQueryHookResult = ReturnType<typeof useJobTaskListQuery>;
export type JobTaskListLazyQueryHookResult = ReturnType<typeof useJobTaskListLazyQuery>;
export type JobTaskListQueryResult = Apollo.QueryResult<JobTaskListQuery, JobTaskListQueryVariables>;
export const LicenseListDocument = gql`
    query licenseList {
  licenseList {
    licenses {
      id
      name
    }
  }
}
    `;

/**
 * __useLicenseListQuery__
 *
 * To run a query within a React component, call `useLicenseListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLicenseListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLicenseListQuery({
 *   variables: {
 *   },
 * });
 */
export function useLicenseListQuery(baseOptions?: Apollo.QueryHookOptions<LicenseListQuery, LicenseListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LicenseListQuery, LicenseListQueryVariables>(LicenseListDocument, options);
      }
export function useLicenseListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LicenseListQuery, LicenseListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LicenseListQuery, LicenseListQueryVariables>(LicenseListDocument, options);
        }
export type LicenseListQueryHookResult = ReturnType<typeof useLicenseListQuery>;
export type LicenseListLazyQueryHookResult = ReturnType<typeof useLicenseListLazyQuery>;
export type LicenseListQueryResult = Apollo.QueryResult<LicenseListQuery, LicenseListQueryVariables>;
export const NotificationSettingDocument = gql`
    query notificationSetting($token: String!) {
  notificationSetting(token: $token) {
    smsEnabled
  }
}
    `;

/**
 * __useNotificationSettingQuery__
 *
 * To run a query within a React component, call `useNotificationSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationSettingQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useNotificationSettingQuery(baseOptions: Apollo.QueryHookOptions<NotificationSettingQuery, NotificationSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationSettingQuery, NotificationSettingQueryVariables>(NotificationSettingDocument, options);
      }
export function useNotificationSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationSettingQuery, NotificationSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationSettingQuery, NotificationSettingQueryVariables>(NotificationSettingDocument, options);
        }
export type NotificationSettingQueryHookResult = ReturnType<typeof useNotificationSettingQuery>;
export type NotificationSettingLazyQueryHookResult = ReturnType<typeof useNotificationSettingLazyQuery>;
export type NotificationSettingQueryResult = Apollo.QueryResult<NotificationSettingQuery, NotificationSettingQueryVariables>;
export const GetPenaltyPointHistoriesDocument = gql`
    query getPenaltyPointHistories($token: String!, $data: GetPenaltyPointHistoriesRequest!) {
  getPenaltyPointHistories(token: $token, data: $data) {
    histories {
      id
      amount
      note
      date
    }
    cursor
  }
}
    `;

/**
 * __useGetPenaltyPointHistoriesQuery__
 *
 * To run a query within a React component, call `useGetPenaltyPointHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPenaltyPointHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPenaltyPointHistoriesQuery({
 *   variables: {
 *      token: // value for 'token'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetPenaltyPointHistoriesQuery(baseOptions: Apollo.QueryHookOptions<GetPenaltyPointHistoriesQuery, GetPenaltyPointHistoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPenaltyPointHistoriesQuery, GetPenaltyPointHistoriesQueryVariables>(GetPenaltyPointHistoriesDocument, options);
      }
export function useGetPenaltyPointHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPenaltyPointHistoriesQuery, GetPenaltyPointHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPenaltyPointHistoriesQuery, GetPenaltyPointHistoriesQueryVariables>(GetPenaltyPointHistoriesDocument, options);
        }
export type GetPenaltyPointHistoriesQueryHookResult = ReturnType<typeof useGetPenaltyPointHistoriesQuery>;
export type GetPenaltyPointHistoriesLazyQueryHookResult = ReturnType<typeof useGetPenaltyPointHistoriesLazyQuery>;
export type GetPenaltyPointHistoriesQueryResult = Apollo.QueryResult<GetPenaltyPointHistoriesQuery, GetPenaltyPointHistoriesQueryVariables>;
export const GetPenaltySummaryDocument = gql`
    query getPenaltySummary($token: String!) {
  getPenaltySummary(token: $token) {
    balance
    currentPenalty {
      name
      expirationDate
    }
    penaltyCount
    feedbackComment
  }
}
    `;

/**
 * __useGetPenaltySummaryQuery__
 *
 * To run a query within a React component, call `useGetPenaltySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPenaltySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPenaltySummaryQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetPenaltySummaryQuery(baseOptions: Apollo.QueryHookOptions<GetPenaltySummaryQuery, GetPenaltySummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPenaltySummaryQuery, GetPenaltySummaryQueryVariables>(GetPenaltySummaryDocument, options);
      }
export function useGetPenaltySummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPenaltySummaryQuery, GetPenaltySummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPenaltySummaryQuery, GetPenaltySummaryQueryVariables>(GetPenaltySummaryDocument, options);
        }
export type GetPenaltySummaryQueryHookResult = ReturnType<typeof useGetPenaltySummaryQuery>;
export type GetPenaltySummaryLazyQueryHookResult = ReturnType<typeof useGetPenaltySummaryLazyQuery>;
export type GetPenaltySummaryQueryResult = Apollo.QueryResult<GetPenaltySummaryQuery, GetPenaltySummaryQueryVariables>;
export const PenaltyRemissionDocument = gql`
    query penaltyRemission($token: String!) {
  penaltyRemission(token: $token) {
    remission {
      amount
      before {
        incentivePoints
      }
      after {
        incentivePoints
      }
    }
  }
}
    `;

/**
 * __usePenaltyRemissionQuery__
 *
 * To run a query within a React component, call `usePenaltyRemissionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePenaltyRemissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePenaltyRemissionQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function usePenaltyRemissionQuery(baseOptions: Apollo.QueryHookOptions<PenaltyRemissionQuery, PenaltyRemissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PenaltyRemissionQuery, PenaltyRemissionQueryVariables>(PenaltyRemissionDocument, options);
      }
export function usePenaltyRemissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PenaltyRemissionQuery, PenaltyRemissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PenaltyRemissionQuery, PenaltyRemissionQueryVariables>(PenaltyRemissionDocument, options);
        }
export type PenaltyRemissionQueryHookResult = ReturnType<typeof usePenaltyRemissionQuery>;
export type PenaltyRemissionLazyQueryHookResult = ReturnType<typeof usePenaltyRemissionLazyQuery>;
export type PenaltyRemissionQueryResult = Apollo.QueryResult<PenaltyRemissionQuery, PenaltyRemissionQueryVariables>;
export const GetRemainingPreparationToApplyListDocument = gql`
    query getRemainingPreparationToApplyList($token: String!) {
  getRemainingPreparationToApplyList(token: $token) {
    preparations {
      kind
      optional
    }
  }
}
    `;

/**
 * __useGetRemainingPreparationToApplyListQuery__
 *
 * To run a query within a React component, call `useGetRemainingPreparationToApplyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRemainingPreparationToApplyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRemainingPreparationToApplyListQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetRemainingPreparationToApplyListQuery(baseOptions: Apollo.QueryHookOptions<GetRemainingPreparationToApplyListQuery, GetRemainingPreparationToApplyListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRemainingPreparationToApplyListQuery, GetRemainingPreparationToApplyListQueryVariables>(GetRemainingPreparationToApplyListDocument, options);
      }
export function useGetRemainingPreparationToApplyListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRemainingPreparationToApplyListQuery, GetRemainingPreparationToApplyListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRemainingPreparationToApplyListQuery, GetRemainingPreparationToApplyListQueryVariables>(GetRemainingPreparationToApplyListDocument, options);
        }
export type GetRemainingPreparationToApplyListQueryHookResult = ReturnType<typeof useGetRemainingPreparationToApplyListQuery>;
export type GetRemainingPreparationToApplyListLazyQueryHookResult = ReturnType<typeof useGetRemainingPreparationToApplyListLazyQuery>;
export type GetRemainingPreparationToApplyListQueryResult = Apollo.QueryResult<GetRemainingPreparationToApplyListQuery, GetRemainingPreparationToApplyListQueryVariables>;
export const ApplicationConfirmationDocument = gql`
    query applicationConfirmation($recruitmentId: ID!, $token: String) {
  applicationConfirmation(recruitmentId: $recruitmentId, token: $token) {
    documents {
      type
      body {
        title
        description
        documents {
          name
          url
        }
      }
      button
    }
    confirmations {
      type
      body {
        title
        description
        items {
          label
          description
        }
        dialog {
          recruitment {
            dateOfWork
            jobTitle
            jobRepresentativeImage
            facilityName
          }
        }
      }
      button
    }
  }
}
    `;

/**
 * __useApplicationConfirmationQuery__
 *
 * To run a query within a React component, call `useApplicationConfirmationQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationConfirmationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationConfirmationQuery({
 *   variables: {
 *      recruitmentId: // value for 'recruitmentId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useApplicationConfirmationQuery(baseOptions: Apollo.QueryHookOptions<ApplicationConfirmationQuery, ApplicationConfirmationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationConfirmationQuery, ApplicationConfirmationQueryVariables>(ApplicationConfirmationDocument, options);
      }
export function useApplicationConfirmationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationConfirmationQuery, ApplicationConfirmationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationConfirmationQuery, ApplicationConfirmationQueryVariables>(ApplicationConfirmationDocument, options);
        }
export type ApplicationConfirmationQueryHookResult = ReturnType<typeof useApplicationConfirmationQuery>;
export type ApplicationConfirmationLazyQueryHookResult = ReturnType<typeof useApplicationConfirmationLazyQuery>;
export type ApplicationConfirmationQueryResult = Apollo.QueryResult<ApplicationConfirmationQuery, ApplicationConfirmationQueryVariables>;
export const FavoriteRecruitmentListDocument = gql`
    query favoriteRecruitmentList($data: FavoriteRecruitmentListInput!) {
  favoriteRecruitmentList(data: $data) {
    recruitments {
      id
      title
      tags {
        name
        color {
          background
          font
          border
        }
      }
      representativeImage
      tasks
      startsAt
      endsAt
      salary
      travelAllowanceLabel
      capacity
      remainingRecruitmentNumbers
      state
      deadline
      facility {
        name
        service
        address
      }
      review {
        rate
        description
      }
      bonus
    }
    paging {
      nextCursor
    }
  }
}
    `;

/**
 * __useFavoriteRecruitmentListQuery__
 *
 * To run a query within a React component, call `useFavoriteRecruitmentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoriteRecruitmentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoriteRecruitmentListQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFavoriteRecruitmentListQuery(baseOptions: Apollo.QueryHookOptions<FavoriteRecruitmentListQuery, FavoriteRecruitmentListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FavoriteRecruitmentListQuery, FavoriteRecruitmentListQueryVariables>(FavoriteRecruitmentListDocument, options);
      }
export function useFavoriteRecruitmentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FavoriteRecruitmentListQuery, FavoriteRecruitmentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FavoriteRecruitmentListQuery, FavoriteRecruitmentListQueryVariables>(FavoriteRecruitmentListDocument, options);
        }
export type FavoriteRecruitmentListQueryHookResult = ReturnType<typeof useFavoriteRecruitmentListQuery>;
export type FavoriteRecruitmentListLazyQueryHookResult = ReturnType<typeof useFavoriteRecruitmentListLazyQuery>;
export type FavoriteRecruitmentListQueryResult = Apollo.QueryResult<FavoriteRecruitmentListQuery, FavoriteRecruitmentListQueryVariables>;
export const RecruitmentDetailDocument = gql`
    query recruitmentDetail($recruitmentId: ID!, $token: String) {
  recruitmentDetail(recruitmentId: $recruitmentId, token: $token) {
    recruitmentId
    jobId
    images
    title
    tags {
      name
      color {
        background
        font
        border
      }
    }
    description
    tasks
    requirementLicenses
    requirementNote
    startsAt
    endsAt
    breakTimeLabel
    salary
    capacity
    remainingRecruitmentNumbers
    isRecruitmentCompleted
    deadline
    wageAndAllowanceLabel
    workflow
    belonging
    note
    appealPoints
    facility {
      facilityId
      name
      service
      phoneNumber
      address
      station
      ambience {
        averageNursingCareLevel
      }
    }
    favorited
    button {
      label
      disabled
      action
    }
    otherCandidates {
      otherCandidatesId
      startsAt
      endsAt
      salary
      capacity
      remainingRecruitmentNumbers
      deadline
      canApply
      breakTimeLabel
      wageAndAllowanceLabel
      bonus
      warningDialogView {
        title
        description
        kind
      }
    }
    rate {
      value
      description
      ratings {
        name
        rate
      }
    }
    bonus
    tagline
    warningDialogView {
      title
      description
      kind
    }
  }
}
    `;

/**
 * __useRecruitmentDetailQuery__
 *
 * To run a query within a React component, call `useRecruitmentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecruitmentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecruitmentDetailQuery({
 *   variables: {
 *      recruitmentId: // value for 'recruitmentId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRecruitmentDetailQuery(baseOptions: Apollo.QueryHookOptions<RecruitmentDetailQuery, RecruitmentDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecruitmentDetailQuery, RecruitmentDetailQueryVariables>(RecruitmentDetailDocument, options);
      }
export function useRecruitmentDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecruitmentDetailQuery, RecruitmentDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecruitmentDetailQuery, RecruitmentDetailQueryVariables>(RecruitmentDetailDocument, options);
        }
export type RecruitmentDetailQueryHookResult = ReturnType<typeof useRecruitmentDetailQuery>;
export type RecruitmentDetailLazyQueryHookResult = ReturnType<typeof useRecruitmentDetailLazyQuery>;
export type RecruitmentDetailQueryResult = Apollo.QueryResult<RecruitmentDetailQuery, RecruitmentDetailQueryVariables>;
export const RecruitmentSearchDocument = gql`
    query recruitmentSearch($data: RecruitmentSearchInput!) {
  recruitmentSearch(data: $data) {
    recruitments {
      id
      title
      tags {
        name
        color {
          background
          font
          border
        }
      }
      representativeImage
      tasks
      startsAt
      endsAt
      salary
      travelAllowanceLabel
      capacity
      remainingRecruitmentNumbers
      state
      deadline
      facility {
        name
        service
        address
      }
      review {
        rate
        description
      }
      bonus
    }
    paging {
      nextCursor
    }
  }
}
    `;

/**
 * __useRecruitmentSearchQuery__
 *
 * To run a query within a React component, call `useRecruitmentSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecruitmentSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecruitmentSearchQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRecruitmentSearchQuery(baseOptions: Apollo.QueryHookOptions<RecruitmentSearchQuery, RecruitmentSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecruitmentSearchQuery, RecruitmentSearchQueryVariables>(RecruitmentSearchDocument, options);
      }
export function useRecruitmentSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecruitmentSearchQuery, RecruitmentSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecruitmentSearchQuery, RecruitmentSearchQueryVariables>(RecruitmentSearchDocument, options);
        }
export type RecruitmentSearchQueryHookResult = ReturnType<typeof useRecruitmentSearchQuery>;
export type RecruitmentSearchLazyQueryHookResult = ReturnType<typeof useRecruitmentSearchLazyQuery>;
export type RecruitmentSearchQueryResult = Apollo.QueryResult<RecruitmentSearchQuery, RecruitmentSearchQueryVariables>;
export const SortOptionListDocument = gql`
    query sortOptionList {
  sortOptionList {
    options {
      id
      name
      howToEnable {
        message
      }
    }
  }
}
    `;

/**
 * __useSortOptionListQuery__
 *
 * To run a query within a React component, call `useSortOptionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSortOptionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSortOptionListQuery({
 *   variables: {
 *   },
 * });
 */
export function useSortOptionListQuery(baseOptions?: Apollo.QueryHookOptions<SortOptionListQuery, SortOptionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SortOptionListQuery, SortOptionListQueryVariables>(SortOptionListDocument, options);
      }
export function useSortOptionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SortOptionListQuery, SortOptionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SortOptionListQuery, SortOptionListQueryVariables>(SortOptionListDocument, options);
        }
export type SortOptionListQueryHookResult = ReturnType<typeof useSortOptionListQuery>;
export type SortOptionListLazyQueryHookResult = ReturnType<typeof useSortOptionListLazyQuery>;
export type SortOptionListQueryResult = Apollo.QueryResult<SortOptionListQuery, SortOptionListQueryVariables>;
export const WorkingHourOptionListDocument = gql`
    query workingHourOptionList {
  workingHourOptionList {
    workingHourOptions {
      id
      name
      term
    }
  }
}
    `;

/**
 * __useWorkingHourOptionListQuery__
 *
 * To run a query within a React component, call `useWorkingHourOptionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkingHourOptionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkingHourOptionListQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkingHourOptionListQuery(baseOptions?: Apollo.QueryHookOptions<WorkingHourOptionListQuery, WorkingHourOptionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkingHourOptionListQuery, WorkingHourOptionListQueryVariables>(WorkingHourOptionListDocument, options);
      }
export function useWorkingHourOptionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkingHourOptionListQuery, WorkingHourOptionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkingHourOptionListQuery, WorkingHourOptionListQueryVariables>(WorkingHourOptionListDocument, options);
        }
export type WorkingHourOptionListQueryHookResult = ReturnType<typeof useWorkingHourOptionListQuery>;
export type WorkingHourOptionListLazyQueryHookResult = ReturnType<typeof useWorkingHourOptionListLazyQuery>;
export type WorkingHourOptionListQueryResult = Apollo.QueryResult<WorkingHourOptionListQuery, WorkingHourOptionListQueryVariables>;
export const ReviewRequestsDocument = gql`
    query reviewRequests($data: ReviewRequestInput, $token: String!) {
  reviewRequests(data: $data, token: $token) {
    requests {
      eventId
      startsAt
      endsAt
      wage
      jobTitle
      facilityName
      ratings {
        description
        commentNotes
        items {
          id
          name
          rates {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useReviewRequestsQuery__
 *
 * To run a query within a React component, call `useReviewRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewRequestsQuery({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useReviewRequestsQuery(baseOptions: Apollo.QueryHookOptions<ReviewRequestsQuery, ReviewRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewRequestsQuery, ReviewRequestsQueryVariables>(ReviewRequestsDocument, options);
      }
export function useReviewRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewRequestsQuery, ReviewRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewRequestsQuery, ReviewRequestsQueryVariables>(ReviewRequestsDocument, options);
        }
export type ReviewRequestsQueryHookResult = ReturnType<typeof useReviewRequestsQuery>;
export type ReviewRequestsLazyQueryHookResult = ReturnType<typeof useReviewRequestsLazyQuery>;
export type ReviewRequestsQueryResult = Apollo.QueryResult<ReviewRequestsQuery, ReviewRequestsQueryVariables>;
export const ReviewSummaryFromFacilityDocument = gql`
    query reviewSummaryFromFacility($token: String!) {
  reviewSummaryFromFacility(token: $token) {
    reviewSummaryFromFacility {
      rate
      count
    }
  }
}
    `;

/**
 * __useReviewSummaryFromFacilityQuery__
 *
 * To run a query within a React component, call `useReviewSummaryFromFacilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewSummaryFromFacilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewSummaryFromFacilityQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useReviewSummaryFromFacilityQuery(baseOptions: Apollo.QueryHookOptions<ReviewSummaryFromFacilityQuery, ReviewSummaryFromFacilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewSummaryFromFacilityQuery, ReviewSummaryFromFacilityQueryVariables>(ReviewSummaryFromFacilityDocument, options);
      }
export function useReviewSummaryFromFacilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewSummaryFromFacilityQuery, ReviewSummaryFromFacilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewSummaryFromFacilityQuery, ReviewSummaryFromFacilityQueryVariables>(ReviewSummaryFromFacilityDocument, options);
        }
export type ReviewSummaryFromFacilityQueryHookResult = ReturnType<typeof useReviewSummaryFromFacilityQuery>;
export type ReviewSummaryFromFacilityLazyQueryHookResult = ReturnType<typeof useReviewSummaryFromFacilityLazyQuery>;
export type ReviewSummaryFromFacilityQueryResult = Apollo.QueryResult<ReviewSummaryFromFacilityQuery, ReviewSummaryFromFacilityQueryVariables>;
export const ReviewsFromFacilityDocument = gql`
    query reviewsFromFacility($data: ReviewsFromFacilityInput!, $token: String!) {
  reviewsFromFacility(data: $data, token: $token) {
    reviews {
      attendance {
        name
        image
        workdayLabel
        jobTitle
      }
      rate
      ratings {
        name
        rateName
        comment
      }
      feedbackComment
    }
    paging {
      cursor
    }
  }
}
    `;

/**
 * __useReviewsFromFacilityQuery__
 *
 * To run a query within a React component, call `useReviewsFromFacilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsFromFacilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewsFromFacilityQuery({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useReviewsFromFacilityQuery(baseOptions: Apollo.QueryHookOptions<ReviewsFromFacilityQuery, ReviewsFromFacilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewsFromFacilityQuery, ReviewsFromFacilityQueryVariables>(ReviewsFromFacilityDocument, options);
      }
export function useReviewsFromFacilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewsFromFacilityQuery, ReviewsFromFacilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewsFromFacilityQuery, ReviewsFromFacilityQueryVariables>(ReviewsFromFacilityDocument, options);
        }
export type ReviewsFromFacilityQueryHookResult = ReturnType<typeof useReviewsFromFacilityQuery>;
export type ReviewsFromFacilityLazyQueryHookResult = ReturnType<typeof useReviewsFromFacilityLazyQuery>;
export type ReviewsFromFacilityQueryResult = Apollo.QueryResult<ReviewsFromFacilityQuery, ReviewsFromFacilityQueryVariables>;
export const ScheduleCancellationRequestsDocument = gql`
    query scheduleCancellationRequests($token: String!) {
  scheduleCancellationRequests(token: $token) {
    requests {
      id
      situation
      schedule {
        workplace
        thumbnail
        workingHours
        jobTitle
      }
      warningMessage
      reason
    }
  }
}
    `;

/**
 * __useScheduleCancellationRequestsQuery__
 *
 * To run a query within a React component, call `useScheduleCancellationRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleCancellationRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleCancellationRequestsQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useScheduleCancellationRequestsQuery(baseOptions: Apollo.QueryHookOptions<ScheduleCancellationRequestsQuery, ScheduleCancellationRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleCancellationRequestsQuery, ScheduleCancellationRequestsQueryVariables>(ScheduleCancellationRequestsDocument, options);
      }
export function useScheduleCancellationRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleCancellationRequestsQuery, ScheduleCancellationRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleCancellationRequestsQuery, ScheduleCancellationRequestsQueryVariables>(ScheduleCancellationRequestsDocument, options);
        }
export type ScheduleCancellationRequestsQueryHookResult = ReturnType<typeof useScheduleCancellationRequestsQuery>;
export type ScheduleCancellationRequestsLazyQueryHookResult = ReturnType<typeof useScheduleCancellationRequestsLazyQuery>;
export type ScheduleCancellationRequestsQueryResult = Apollo.QueryResult<ScheduleCancellationRequestsQuery, ScheduleCancellationRequestsQueryVariables>;
export const SearchPrefectureFromStationDocument = gql`
    query searchPrefectureFromStation($data: SearchPrefectureFromStationInput!) {
  searchPrefectureFromStation(data: $data) {
    prefectureIds
  }
}
    `;

/**
 * __useSearchPrefectureFromStationQuery__
 *
 * To run a query within a React component, call `useSearchPrefectureFromStationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPrefectureFromStationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPrefectureFromStationQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSearchPrefectureFromStationQuery(baseOptions: Apollo.QueryHookOptions<SearchPrefectureFromStationQuery, SearchPrefectureFromStationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPrefectureFromStationQuery, SearchPrefectureFromStationQueryVariables>(SearchPrefectureFromStationDocument, options);
      }
export function useSearchPrefectureFromStationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPrefectureFromStationQuery, SearchPrefectureFromStationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPrefectureFromStationQuery, SearchPrefectureFromStationQueryVariables>(SearchPrefectureFromStationDocument, options);
        }
export type SearchPrefectureFromStationQueryHookResult = ReturnType<typeof useSearchPrefectureFromStationQuery>;
export type SearchPrefectureFromStationLazyQueryHookResult = ReturnType<typeof useSearchPrefectureFromStationLazyQuery>;
export type SearchPrefectureFromStationQueryResult = Apollo.QueryResult<SearchPrefectureFromStationQuery, SearchPrefectureFromStationQueryVariables>;
export const SearchRailwayFromPrefectureDocument = gql`
    query searchRailwayFromPrefecture($data: SearchRailwayFromPrefectureInput!) {
  searchRailwayFromPrefecture(data: $data) {
    corporations {
      name
      code
      lines {
        name
        code
        stations {
          name
          code
        }
      }
    }
  }
}
    `;

/**
 * __useSearchRailwayFromPrefectureQuery__
 *
 * To run a query within a React component, call `useSearchRailwayFromPrefectureQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchRailwayFromPrefectureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchRailwayFromPrefectureQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSearchRailwayFromPrefectureQuery(baseOptions: Apollo.QueryHookOptions<SearchRailwayFromPrefectureQuery, SearchRailwayFromPrefectureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchRailwayFromPrefectureQuery, SearchRailwayFromPrefectureQueryVariables>(SearchRailwayFromPrefectureDocument, options);
      }
export function useSearchRailwayFromPrefectureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchRailwayFromPrefectureQuery, SearchRailwayFromPrefectureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchRailwayFromPrefectureQuery, SearchRailwayFromPrefectureQueryVariables>(SearchRailwayFromPrefectureDocument, options);
        }
export type SearchRailwayFromPrefectureQueryHookResult = ReturnType<typeof useSearchRailwayFromPrefectureQuery>;
export type SearchRailwayFromPrefectureLazyQueryHookResult = ReturnType<typeof useSearchRailwayFromPrefectureLazyQuery>;
export type SearchRailwayFromPrefectureQueryResult = Apollo.QueryResult<SearchRailwayFromPrefectureQuery, SearchRailwayFromPrefectureQueryVariables>;
export const StatementOfEarningFileDocument = gql`
    query statementOfEarningFile($data: StatementOfEarningFileInput!, $token: String!) {
  statementOfEarningFile(data: $data, token: $token) {
    base64EncodedFile
  }
}
    `;

/**
 * __useStatementOfEarningFileQuery__
 *
 * To run a query within a React component, call `useStatementOfEarningFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatementOfEarningFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatementOfEarningFileQuery({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useStatementOfEarningFileQuery(baseOptions: Apollo.QueryHookOptions<StatementOfEarningFileQuery, StatementOfEarningFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatementOfEarningFileQuery, StatementOfEarningFileQueryVariables>(StatementOfEarningFileDocument, options);
      }
export function useStatementOfEarningFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatementOfEarningFileQuery, StatementOfEarningFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatementOfEarningFileQuery, StatementOfEarningFileQueryVariables>(StatementOfEarningFileDocument, options);
        }
export type StatementOfEarningFileQueryHookResult = ReturnType<typeof useStatementOfEarningFileQuery>;
export type StatementOfEarningFileLazyQueryHookResult = ReturnType<typeof useStatementOfEarningFileLazyQuery>;
export type StatementOfEarningFileQueryResult = Apollo.QueryResult<StatementOfEarningFileQuery, StatementOfEarningFileQueryVariables>;
export const StatementOfEarningsDocument = gql`
    query statementOfEarnings($data: StatementOfEarningsInput!, $token: String!) {
  statementOfEarnings(data: $data, token: $token) {
    statementOfEarnings {
      year
      employerId
      employerName
    }
    paging {
      cursor
    }
  }
}
    `;

/**
 * __useStatementOfEarningsQuery__
 *
 * To run a query within a React component, call `useStatementOfEarningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatementOfEarningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatementOfEarningsQuery({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useStatementOfEarningsQuery(baseOptions: Apollo.QueryHookOptions<StatementOfEarningsQuery, StatementOfEarningsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatementOfEarningsQuery, StatementOfEarningsQueryVariables>(StatementOfEarningsDocument, options);
      }
export function useStatementOfEarningsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatementOfEarningsQuery, StatementOfEarningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatementOfEarningsQuery, StatementOfEarningsQueryVariables>(StatementOfEarningsDocument, options);
        }
export type StatementOfEarningsQueryHookResult = ReturnType<typeof useStatementOfEarningsQuery>;
export type StatementOfEarningsLazyQueryHookResult = ReturnType<typeof useStatementOfEarningsLazyQuery>;
export type StatementOfEarningsQueryResult = Apollo.QueryResult<StatementOfEarningsQuery, StatementOfEarningsQueryVariables>;
export const WorkerBankSummaryDocument = gql`
    query workerBankSummary($token: String!) {
  workerBankSummary(token: $token) {
    balance
    withdrawing
    bankAccount {
      name
      numberSuffix
      state
    }
    errorMessage {
      reason
    }
  }
}
    `;

/**
 * __useWorkerBankSummaryQuery__
 *
 * To run a query within a React component, call `useWorkerBankSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkerBankSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkerBankSummaryQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useWorkerBankSummaryQuery(baseOptions: Apollo.QueryHookOptions<WorkerBankSummaryQuery, WorkerBankSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkerBankSummaryQuery, WorkerBankSummaryQueryVariables>(WorkerBankSummaryDocument, options);
      }
export function useWorkerBankSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkerBankSummaryQuery, WorkerBankSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkerBankSummaryQuery, WorkerBankSummaryQueryVariables>(WorkerBankSummaryDocument, options);
        }
export type WorkerBankSummaryQueryHookResult = ReturnType<typeof useWorkerBankSummaryQuery>;
export type WorkerBankSummaryLazyQueryHookResult = ReturnType<typeof useWorkerBankSummaryLazyQuery>;
export type WorkerBankSummaryQueryResult = Apollo.QueryResult<WorkerBankSummaryQuery, WorkerBankSummaryQueryVariables>;
export const WorkerBankTransferDocument = gql`
    query workerBankTransfer($data: WorkerBankTransferInput!, $token: String!) {
  workerBankTransfer(data: $data, token: $token) {
    transfers {
      type
      message
      amount
      date
      breakdown {
        netAmount
        fee
      }
    }
    paging {
      nextCursor
    }
  }
}
    `;

/**
 * __useWorkerBankTransferQuery__
 *
 * To run a query within a React component, call `useWorkerBankTransferQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkerBankTransferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkerBankTransferQuery({
 *   variables: {
 *      data: // value for 'data'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useWorkerBankTransferQuery(baseOptions: Apollo.QueryHookOptions<WorkerBankTransferQuery, WorkerBankTransferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkerBankTransferQuery, WorkerBankTransferQueryVariables>(WorkerBankTransferDocument, options);
      }
export function useWorkerBankTransferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkerBankTransferQuery, WorkerBankTransferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkerBankTransferQuery, WorkerBankTransferQueryVariables>(WorkerBankTransferDocument, options);
        }
export type WorkerBankTransferQueryHookResult = ReturnType<typeof useWorkerBankTransferQuery>;
export type WorkerBankTransferLazyQueryHookResult = ReturnType<typeof useWorkerBankTransferLazyQuery>;
export type WorkerBankTransferQueryResult = Apollo.QueryResult<WorkerBankTransferQuery, WorkerBankTransferQueryVariables>;
export const EmailNotificationSettingDocument = gql`
    query emailNotificationSetting($token: String!) {
  emailNotificationSetting(token: $token) {
    enabled
  }
}
    `;

/**
 * __useEmailNotificationSettingQuery__
 *
 * To run a query within a React component, call `useEmailNotificationSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailNotificationSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailNotificationSettingQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useEmailNotificationSettingQuery(baseOptions: Apollo.QueryHookOptions<EmailNotificationSettingQuery, EmailNotificationSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailNotificationSettingQuery, EmailNotificationSettingQueryVariables>(EmailNotificationSettingDocument, options);
      }
export function useEmailNotificationSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailNotificationSettingQuery, EmailNotificationSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailNotificationSettingQuery, EmailNotificationSettingQueryVariables>(EmailNotificationSettingDocument, options);
        }
export type EmailNotificationSettingQueryHookResult = ReturnType<typeof useEmailNotificationSettingQuery>;
export type EmailNotificationSettingLazyQueryHookResult = ReturnType<typeof useEmailNotificationSettingLazyQuery>;
export type EmailNotificationSettingQueryResult = Apollo.QueryResult<EmailNotificationSettingQuery, EmailNotificationSettingQueryVariables>;
export const WorkerLicenseCertificateListDocument = gql`
    query workerLicenseCertificateList($token: String!) {
  workerLicenseCertificateList(token: $token) {
    licenses {
      id
      licenseId
      name
      verificationState {
        __typename
        displayName
        ... on LicenseVerificationStatePending {
          remarksOnDifferentName
        }
        ... on LicenseVerificationStateRejected {
          rejectionReason
        }
      }
      imageUrl
    }
  }
}
    `;

/**
 * __useWorkerLicenseCertificateListQuery__
 *
 * To run a query within a React component, call `useWorkerLicenseCertificateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkerLicenseCertificateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkerLicenseCertificateListQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useWorkerLicenseCertificateListQuery(baseOptions: Apollo.QueryHookOptions<WorkerLicenseCertificateListQuery, WorkerLicenseCertificateListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkerLicenseCertificateListQuery, WorkerLicenseCertificateListQueryVariables>(WorkerLicenseCertificateListDocument, options);
      }
export function useWorkerLicenseCertificateListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkerLicenseCertificateListQuery, WorkerLicenseCertificateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkerLicenseCertificateListQuery, WorkerLicenseCertificateListQueryVariables>(WorkerLicenseCertificateListDocument, options);
        }
export type WorkerLicenseCertificateListQueryHookResult = ReturnType<typeof useWorkerLicenseCertificateListQuery>;
export type WorkerLicenseCertificateListLazyQueryHookResult = ReturnType<typeof useWorkerLicenseCertificateListLazyQuery>;
export type WorkerLicenseCertificateListQueryResult = Apollo.QueryResult<WorkerLicenseCertificateListQuery, WorkerLicenseCertificateListQueryVariables>;
export const WorkerProfileDocument = gql`
    query workerProfile($id: ID!, $token: String!) {
  workerProfile(id: $id, token: $token) {
    workerId
    representativeImage
    lastName
    firstName
    lastKana
    firstKana
    bornOn
    sex
    nationality
    phoneNumber
    zipCode
    areaL {
      id
      name
    }
    city
    streetNumber
    building
    occupation
    jobChangeIntention
    jobArrangements {
      id
      name
    }
    areaLList {
      id
      name
    }
    desiredWorkingHourIds
    experiencedJobTasks {
      id
      name
    }
    profile
    yearsOfExperience
    desiredJobTasks {
      id
      name
    }
    identityVerified
    desiredStationCodes
  }
}
    `;

/**
 * __useWorkerProfileQuery__
 *
 * To run a query within a React component, call `useWorkerProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkerProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkerProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useWorkerProfileQuery(baseOptions: Apollo.QueryHookOptions<WorkerProfileQuery, WorkerProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkerProfileQuery, WorkerProfileQueryVariables>(WorkerProfileDocument, options);
      }
export function useWorkerProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkerProfileQuery, WorkerProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkerProfileQuery, WorkerProfileQueryVariables>(WorkerProfileDocument, options);
        }
export type WorkerProfileQueryHookResult = ReturnType<typeof useWorkerProfileQuery>;
export type WorkerProfileLazyQueryHookResult = ReturnType<typeof useWorkerProfileLazyQuery>;
export type WorkerProfileQueryResult = Apollo.QueryResult<WorkerProfileQuery, WorkerProfileQueryVariables>;